export const es = {
  app: {
    home: 'Inicio',
    playerScout: 'Búsqueda de jugadores',
    playerComparison: 'Comparación de jugadores',
    playerRecruitment: 'Radar',
    collections: 'Colecciones',
    favoritePlayers: 'Jugadores favoritos',
    teamAnalytics: 'Analíticas de Equipo',
    gameAnalysis: 'Análisis de Partidos',
    validateEvents: 'Validar Eventos',
    seasonStats: 'Temporadas',
    leagueTable: 'Clasificación',
    scoresAndFixtures: 'Resultados',
    notifications: 'Notificaciones',
    administration: 'Administración',
    inbox: 'Bandeja de entrada',
    teamStats: 'Estadísticas de equipo',
    blog: 'Blog',
    leagues: 'Ligas',
    squadBuilder: 'Creador de plantillas',
    playerAlerts: 'Alertas de Jugadores',
    searchAlerts: 'Alertas de Búsqueda',
    videoUploadTool: 'Cargar videos',
    videoPlaylists: 'Listas de reproducción',
    uploadedGames: 'Partidos subidos',
    favoriteTeams: 'Equipos favoritos',
    arrigo: 'Arrigo'
  },
  playerRecruitment: {
    title: 'Ficha del perfil',
    subtitle: 'Profundiza en las características y estadísticas del perfil',
    league: 'Liga',
    selectedSeason: 'Temporada seleccionada',
    year: 'Año',
    radar: 'Radar',
    positions: 'Posiciones',
    numberOfPlayers: 'Número de jugadores',
    template: 'Plantilla',
    compareWith: 'Comparar con',
    previousPerformance: 'Rendimiento Previo',
    xGames: '{0} partidos',
    average: 'Promedio',
    leagueAverage: 'Promedio Liga',
    selectSeason: 'Selecciona una temporada',
    positionsPlayed: 'Posiciones en las que ha jugado',
    minMax: 'Mínimos y Máximos',
    top5Leagues: '5 Grandes Ligas',
    infoMessage: 'Selecciona solamente una temporada para habilitar los mínimos y máximos',
    infoMessage2: 'Selecciona la misma temporada para ambas comparaciones',
    infoMessage3: 'Esta opción solo está disponible a partir de la jornada 6',
    dataPer90MinText: 'Datos por 90 minutos',
    adjustToPossessionText: '* Ajustadas a posesión',
    text: 'Texto',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: 'No se encontraro partidos entre las fechas seleccionadas',
    radarTemplates: {
      Goalkeeper: 'Portero',
      GoalkeeperCustom: 'Portero Personalizado',
      GoalkeeperCustom1: 'Portero Personalizado 1',
      GoalkeeperCustom2: 'Portero Personalizado 2',
      GoalkeeperCustom3: 'Portero Personalizado 3',
      GoalkeeperCustom4: 'Portero Personalizado 4',
      GoalkeeperCustom5: 'Portero Personalizado 5',
      GoalkeeperCustom6: 'Portero Personalizado 6',
      Defender: 'Defensa',
      DefenderCustom: 'Defensa Personalizado',
      DefenderCustom1: 'Defensa Personalizado 1',
      DefenderCustom2: 'Defensa Personalizado 2',
      DefenderCustom3: 'Defensa Personalizado 3',
      DefenderCustom4: 'Defensa Personalizado 4',
      DefenderCustom5: 'Defensa Personalizado 5',
      DefenderCustom6: 'Defensa Personalizado 6',
      FullBack: 'Lateral',
      FullBackCustom: 'Lateral Personalizado',
      FullBackCustom1: 'Lateral Personalizado 1',
      FullBackCustom2: 'Lateral Personalizado 2',
      FullBackCustom3: 'Lateral Personalizado 3',
      FullBackCustom4: 'Lateral Personalizado 4',
      FullBackCustom5: 'Lateral Personalizado 5',
      FullBackCustom6: 'Lateral Personalizado 6',
      FullBackPredictive: 'Lateral',
      Midfielder: 'Centrocampista',
      MidfielderCustom: 'Centrocampista Personalizado',
      MidfielderCustom1: 'Centrocampista Personalizado 1',
      MidfielderCustom2: 'Centrocampista Personalizado 2',
      MidfielderCustom3: 'Centrocampista Personalizado 3',
      MidfielderCustom4: 'Centrocampista Personalizado 4',
      MidfielderCustom5: 'Centrocampista Personalizado 5',
      MidfielderCustom6: 'Centrocampista Personalizado 6',
      MidfielderPredictive: 'Centrocampista',
      MidfielderDefensive: 'Centrocampista Defensivo',
      MidfielderOffensive: 'Centrocampista Ofensivo',
      AttackingMidfielder: 'Media punta',
      MidfielderWing: 'Interior',
      Winger: 'Extremo',
      WingerCustom: 'Extremo Personalizado',
      WingerCustom1: 'Extremo Personalizado 1',
      WingerCustom2: 'Extremo Personalizado 2',
      WingerCustom3: 'Extremo Personalizado 3',
      WingerCustom4: 'Extremo Personalizado 4',
      WingerCustom5: 'Extremo Personalizado 5',
      WingerCustom6: 'Extremo Personalizado 6',
      WingerOffensive: 'Extremo Ofensivo',
      Forward: 'Delantero',
      ForwardCustom: 'Delantero Personalizado',
      ForwardCustom1: 'Delantero Personalizado 1',
      ForwardCustom2: 'Delantero Personalizado 2',
      ForwardCustom3: 'Delantero Personalizado 3',
      ForwardCustom4: 'Delantero Personalizado 4',
      ForwardCustom5: 'Delantero Personalizado 5',
      ForwardCustom6: 'Delantero Personalizado 6',
      ForwardPredictive: 'Delantero',
      WingBack: 'Carrilero',
      WingBackCustom: 'Carrilero Personalizado',
      WingBackCustom1: 'Carrilero Personalizado 1',
      WingBackCustom2: 'Carrilero Personalizado 2',
      WingBackCustom3: 'Carrilero Personalizado 3',
      WingBackCustom4: 'Carrilero Personalizado 4',
      WingBackCustom5: 'Carrilero Personalizado 5',
      WingBackCustom6: 'Carrilero Personalizado 6',
      WingBackMedia: 'Carrilero (SocialMedia)',
      FullBackMedia: 'Lateral (SocialMedia)',
      MidfielderMedia: 'Centrocampista (SocialMedia)',
      WingerMedia: 'Extremo (SocialMedia)',
      ForwardMedia: 'Delantero (SocialMedia)',
      PhysicalWingBack: 'Físico Carrilero',
      PhysicalForward: 'Físico Delantero',
      PhysicalWinger: 'Físico Extremo',
      PhysicalMidfielder: 'Físico Centrocampista',
      PhysicalFullBack: 'Físico Lateral',
      PhysicalDefender: 'Físico Defensa',
      PhysicalWingBackLMO: 'Físico Carrilero',
      PhysicalForwardLMO: 'Físico Delantero',
      PhysicalWingerLMO: 'Físico Extremo',
      PhysicalMidfielderLMO: 'Físico Centrocampista',
      PhysicalFullBackLMO: 'Físico Lateral',
      PhysicalDefenderLMO: 'Físico Defensa'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Portera',
      Defender: 'Defensa',
      FullBack: 'Lateral',
      FullBackPredictive: 'Lateral',
      Midfielder: 'Centrocampista',
      MidfielderPredictive: 'Centrocampista',
      MidfielderDefensive: 'Centrocampista Defensivo',
      MidfielderOffensive: 'Centrocampista Ofensivo',
      AttackingMidfielder: 'Media punta',
      MidfielderWing: 'Interior',
      Winger: 'Extremo',
      WingerOffensive: 'Extremo Ofensivo',
      Forward: 'Delantera',
      ForwardPredictive: 'Delantera',
      WingBack: 'Carrilera',
      WingBackMedia: 'Carrilera (SocialMedia)',
      FullBackMedia: 'Lateral (SocialMedia)',
      MidfielderMedia: 'Centrocampista (SocialMedia)',
      WingerMedia: 'Extremo (SocialMedia)',
      ForwardMedia: 'Delantera (SocialMedia)',
      PhysicalWingBack: 'Físico Carrilera',
      PhysicalForward: 'Físico Delantera',
      PhysicalWinger: 'Físico Extremo',
      PhysicalMidfielder: 'Físico Centrocampista',
      PhysicalFullBack: 'Físico Lateral',
      PhysicalDefender: 'Físico Defensa',
      PhysicalWingBackLMO: 'Físico Carrilera',
      PhysicalForwardLMO: 'Físico Delantera',
      PhysicalWingerLMO: 'Físico Extremo',
      PhysicalMidfielderLMO: 'Físico Centrocampista',
      PhysicalFullBackLMO: 'Físico Lateral',
      PhysicalDefenderLMO: 'Físico Defensa'
    },
    radarDescription: {
      basicStatistics: {
        title: 'ESTADÍSTICAS BÁSICAS',
        minutes: 'minutos',
        goals: 'goles',
        assists: 'asistencias',
        redCards: 'rojas',
        yellowCards: 'amarillas',
        games: 'partidos',
        goalsReceived: 'goles sin penaltis recibidos',
        xGFaced: 'xG recibido'
      },
      profiles: {
        3: {
          1: 'Gran habilidad con el balón en los pies, tanto en pases cortos como largos.',
          2: 'Capacidad para jugar con los pies y ser importante en la iniciación del juego, con buenos porcentajes de pase tanto en corto como en largo.',
          3: 'Buen juego de pies que convierte este perfil en una opción interesante por sus métricas con el pase.',
          4: 'Perfil que destaca por sus pases, ya sea en campo propio o en campo contrario.',
          5: 'Gran seguridad con el balón en los pies y alta habilidad en el pase.',
          6: 'Buen juego con los pies, aportando seguridad en la salida de balón y completando un alto porcentaje de pases en corto y en largo.',
          7: 'Alto porcentaje de pases completados, tanto en corto como en largo, aportando calidad en la circulación.'
        },
        5: {
          1: 'Perfil defensivo que se caracteriza por ir bien en el uno contra uno y realizar un gran número de tackles e intercepciones.',
          2: 'Central muy eficaz en los duelos individuales, tanto por arriba como en el tackle, con buena lectura para anticipar.',
          3: 'Defensa central con buen rendimiento en los duelos defensivos individuales, lo que se traduce en un gran volumen de recuperaciones.',
          4: 'Perfil con gran nivel defensivo, capaz de recuperar un gran volumen de balones gracias a tackles e intercepciones.',
          5: 'Defensa muy eficaz en el tackle y con gran número de intercepciones, destacando en el enfrentamiento individual.',
          6: 'Central con un alto número de recuperaciones por partido, habilidoso para leer el juego rival y cortar, con alta precisión y frecuencia en los tackles.',
          7: 'Perfil defensivo con alto volumen de recuperaciones gracias a la efectividad y frecuencia en tackles y a una buena lectura para anticipar.'
        },
        6: {
          1: 'Defensa con gran contribución en la generación de ocasiones y buena visión de juego.'
        },
        7: {
          1: 'Perfil con rendimiento equilibrado entre el juego ofensivo (gran aportación en la construcción de xG) y el defensivo (alto volumen de recuperaciones).'
        },
        8: {
          1: 'Defensa sólida en el uno contra uno y con gran número de recuperaciones, tanto por tackles como por intercepciones.'
        },
        9: {
          1: 'Perfil con gran aporte ofensivo generando acciones de peligro y ocasiones, con dificultades en tareas defensivas.'
        },
        10: {
          1: 'Perfil que abarca mucho terreno de juego, capaz de recuperar balones y aportar gran parte de la construcción de xG del equipo.'
        },
        11: {
          1: 'Centrocampista con alto rendimiento defensivo y gran efectividad en el pase, pese a tener poca influencia en el ataque.'
        },
        12: {
          1: 'Centrocampista completo, con influencia notable creando ocasiones de peligro y buen juego aéreo, además de una gran cantidad de intercepciones y tackles.'
        },
        15: {
          1: 'Extremo con habilidad en el uno contra uno y buen nivel de centros completados, generando más asistencias esperadas que remates.'
        },
        16: {
          1: 'Perfil con numerosos pases entre líneas y progresiones de balón, capaz de generar ocasiones y con más influencia con la posesión en zonas interiores que un extremo clásico.'
        },
        17: {
          1: 'Futbolista con buena habilidad en el regate, que suele partir de fuera hacia dentro para generar más remates (xG) que pases clave (xA).'
        },
        18: {
          1: 'Gran labor sin balón, con elevado valor de presión individual que se traduce en intercepciones y recuperaciones altas.'
        },
        22: {
          1: 'Gran movilidad como delantero, con capacidad para recibir pases entre líneas, caer a banda y generar ocasiones de gol. Alto porcentaje de toques fuera del área respecto al total de toques por partido.'
        }
      },
      description: 'DESCRIPCIÓN',
      conjuction: ' y ',
      conjuction2: ' e ',
      over: 'por encima',
      under: 'por debajo',
      respectively: ', respectivamente',
      Defending1: {
        1: 'El rendimiento defensivo se encuentra entre los peores de las 5 grandes ligas'
      },
      Defending2: {
        1: 'Defensivamente no cumple un buen papel ya que el rendimiento está por debajo del promedio'
      },
      Defending3: {
        1: 'Defensivamente cumple un buen papel, el nivel se encuentra un poco over_under_average del promedio'
      },
      Defending4: {
        1: 'Labor destacable en tareas defensivas con un rendimiento por encima de la media'
      },
      Defending5: {
        1: 'Sobresaliente en tareas defensivas, con un rendimiento superior al 80% de los player_positions de las 5 grandes ligas'
      },
      Saving1: {
        1: 'Perfil de portería con rendimiento muy bajo, con muchas dificultades a la hora de atajar el balón'
      },
      Saving2: {
        1: 'No se desempeña un buen papel bajo palos ya que el nivel está por debajo del promedio'
      },
      Saving3: {
        1: 'Guardameta con un rendimiento aceptable, se encuentra ligeramente over_under_average del promedio, con margen de mejora en metric_name'
      },
      Saving4: {
        1: 'Portería con buen nivel por encima de la media de las 5 grandes ligas, destacando especialmente en metric_name'
      },
      Saving5: {
        1: 'Perfil muy completo en acciones de parada; todas sus métricas lo ubican dentro del Top 20% comparado con los porteros de las 5 grandes ligas de Europa.'
      },
      Passing1: {
        1: 'Con el balón en los pies el nivel está entre los peores jugadores'
      },
      Passing2: {
        1: 'En cuanto a pases se refiere, el desempeño está por debajo de la media'
      },
      Passing3: {
        1: 'El nivel realizando pases es aceptable, levemente over_under_average del promedio'
      },
      Passing4: {
        1: 'Gran pasador con muy buen nivel en este aspecto, bastante superior a la media'
      },
      Passing5: {
        1: 'Gran efectividad pasando el balón con un rendimiento superior al de la mayoría de jugadores'
      },
      Aerial1: {
        1: 'Rendimiento muy bajo en el juego aéreo, entre los peores en su posición en este aspecto'
      },
      Aerial2: {
        1: 'En cuanto a ganar balones por arriba, el rendimiento es inferior a la media'
      },
      Aerial3: {
        1: 'Nivel aceptable en el juego aéreo, un poco over_under_average del promedio'
      },
      Aerial4: {
        1: 'Gran rendimiento en el juego por arriba, con alta efectividad en este aspecto'
      },
      Aerial5: {
        1: 'Las métricas en el juego aéreo sitúan este perfil entre los mejores'
      },
      Shooting1: {
        1: 'Estadísticas muy deficientes de cara a portería, entre los peores en este aspecto'
      },
      Shooting2: {
        1: 'Nivel de cara a puerta muy mejorable, por debajo del promedio'
      },
      Shooting3: {
        1: 'Rendimiento aceptable en labores ofensivas, levemente over_under_average del promedio'
      },
      Shooting4: {
        1: 'Muy buen rendimiento en el área, por encima del 60% de jugadores'
      },
      Shooting5: {
        1: 'Grandes habilidades en tareas ofensivas, con rendimiento espectacular, situándose entre los mejores en este aspecto'
      },
      Association1: {
        1: 'El rendimiento asociándose con el balón es muy bajo, entre los peores de las 5 grandes ligas'
      },
      Association2: {
        1: 'Hay bastante margen de mejora con el balón en los pies ya que se encuentra por debajo del rendimiento medio en este aspecto'
      },
      Association3: {
        1: 'Se asocia bien con el balón, ligeramente over_under_average del promedio'
      },
      Association4: {
        1: 'Se asocia muy bien con el balón, presentando un nivel muy notable'
      },
      Association5: {
        1: 'Extraordinaria capacidad asociativa con el balón en los pies, entre los mejores jugadores en este aspecto'
      },
      BallHandling1: {
        1: 'Pésimo rendimiento en el manejo de balón, entre los peores comparado con las 5 grandes ligas'
      },
      BallHandling2: {
        1: 'En referencia al manejo de balón, los niveles están por debajo del promedio'
      },
      BallHandling3: {
        1: 'Aceptable nivel manejando el balón, ligeramente over_under_average del promedio'
      },
      BallHandling4: {
        1: 'Alto nivel en cuanto a manejo de balón se refiere, con cifras cercanas a las de los mejores en este aspecto'
      },
      BallHandling5: {
        1: 'Capacidad para manejar el balón de forma excepcional, entre las mejores de las 5 grandes ligas'
      },
      Crosses1: {
        1: 'Rendimiento deficiente centrando el balón al área, entre los peores perfiles en métricas de centros'
      },
      Crosses2: {
        1: 'Rendimiento por debajo de la media en la creación de peligro con centros'
      },
      Crosses3: {
        1: 'Nivel aceptable, pero mejorable, enviando centros al área, un poco over_under_average de la media'
      },
      Crosses4: {
        1: 'Buenas estadísticas a la hora de centrar el balón, bastante por encima de lo normal'
      },
      Crosses5: {
        1: 'Entre los mejores perfiles centrando al área; en concreto, dentro del 20% más efectivo en esta categoría'
      },
      Carries1: {
        1: 'Entre el 20% de jugadores con peores números en cuanto a la conducción de balón se refiere'
      },
      Carries2: {
        1: 'El rendimiento en la conducción de la posesión está alejado de la media de los jugadores de su posición'
      },
      Carries3: {
        1: 'Rendimiento cercano al promedio, levemente over_under_average, en cuanto a conducción del balón se refiere'
      },
      Carries4: {
        1: 'Perfil destacable con muy buenos números en profundidad y conducciones de balón'
      },
      Carries5: {
        1: 'Gran talento conduciendo el esférico, con alto rendimiento en las métricas de la categoría de Conducciones'
      },
      Turnovers1: {
        1: 'Rendimiento muy negativo con un alto volumen de pérdidas que facilitan la producción de peligro de los rivales, situándose entre los peores en esta métrica'
      },
      Turnovers2: {
        1: 'Las numerosas pérdidas peligrosas benefician a los contrarios; es necesario mejorar de forma importante y reducirlas.'
      },
      Turnovers3: {
        1: 'El perfil se encuentra ligeramente over_under_average de la media en cuanto a pérdidas de balón, por lo que el rendimiento aún es mejorable'
      },
      Turnovers4: {
        1: 'Notable rendimiento en pérdidas, por encima del 60% de jugadores que menos balones pierden'
      },
      Turnovers5: {
        1: 'Destacan las pocas pérdidas de balón, que colocan este perfil entre quienes mejor mantienen la posesión para su equipo'
      },
      SequenceInvolvement1: {
        1: 'En la posesión de balón, los números no son favorables, muy pocas veces se finalizan las acciones con remate'
      },
      SequenceInvolvement2: {
        1: 'La finalización de las posesiones es bastante mejorable; apenas se terminan con tiro, y eso sitúa el rendimiento bastante por debajo de la media'
      },
      SequenceInvolvement3: {
        1: 'Nivel aceptable a la hora de finalizar las posesiones de cara a portería, con un percentil un poco over_under_average del promedio y gran margen de mejora'
      },
      SequenceInvolvement4: {
        1: 'Buena capacidad de terminar con tiro las posesiones del equipo, algunos de ellos acaban en gol, con rendimiento notable en esta categoría'
      },
      SequenceInvolvement5: {
        1: 'Perfil entre quienes mejor materializan las posesiones del equipo, finalizándolas con remates que generan peligro'
      },
      OutPlay1: {
        1: 'Se identifica un impacto mínimo a la hora de desorganizar las estructuras defensivas'
      },
      OutPlay2: {
        1: 'La contribución a la progresión y a la ruptura de defensas está por debajo de los estándares de la posición'
      },
      OutPlay3: {
        1: 'Capacidad para generar ventajas de forma ocasional, con rendimiento alrededor de la media para la posición'
      },
      OutPlay4: {
        1: 'Contribución frecuente a la ruptura de líneas defensivas y a la creación de desequilibrios'
      },
      OutPlay5: {
        1: 'Perfil situado entre quienes mejor eliminan rivales y generan progresiones en esa posición'
      },
      LineBreakingPasses1: {
        1: 'Rara vez se intentan o completan pases que rompan líneas defensivas, con una contribución muy escasa en esas acciones'
      },
      LineBreakingPasses2: {
        1: 'Existen dificultades para encontrar de forma constante compañeras o compañeros entre líneas o a la espalda de la presión, con contribución por debajo de los estándares de la posición'
      },
      LineBreakingPasses3: {
        1: 'Se realizan pases que rompen líneas de manera ocasional, con rendimiento próximo a la media para la posición'
      },
      LineBreakingPasses4: {
        1: 'Se rompen líneas con frecuencia mediante el pase, ayudando a desestabilizar los bloques rivales'
      },
      LineBreakingPasses5: {
        1: 'Entre quienes mejor rompen líneas y desbloquean la presión en su liga; esta es una de las principales virtudes del perfil'
      },
      PassUnderPressure1: {
        1: 'Se observa dificultad para mantener la calma y la eficacia cuando los rivales ejercen presión'
      },
      PassUnderPressure2: {
        1: 'Existen dificultades para mantener la precisión de pase en situaciones de alta presión'
      },
      PassUnderPressure3: {
        1: 'Rendimiento alrededor de la media en cuanto a pases bajo presión; la presión se maneja razonablemente bien, aunque sin una ejecución limpia de forma constante'
      },
      PassUnderPressure4: {
        1: 'Se consigue con frecuencia encontrar receptoras o receptores a pesar de la presión, rindiendo por encima de la media en ese tipo de pases'
      },
      PassUnderPressure5: {
        1: 'Compostura y precisión sobresalientes al pasar bajo intensa presión, situándose entre los mejores rendimientos de la posición en este aspecto'
      },
      BallReceived1: {
        1: 'Recibe muy pocos pases en zonas avanzadas; no es un perfil que opere regularmente entre líneas'
      },
      BallReceived2: {
        1: 'Registra algunas recepciones sin marca en campo rival, pero sin mucha regularidad'
      },
      BallReceived3: {
        1: 'Registra un volumen medio de recepciones sin oposición en zonas de ataque'
      },
      BallReceived4: {
        1: 'Recibe con frecuencia entre líneas y en zonas libres de presión'
      },
      BallReceived5: {
        1: 'Acumula muchas recepciones entre líneas, libre de defensas y en zonas potencialmente clave'
      },
      OnBallPressure1: {
        1: 'Se presiona rara vez y casi nunca cerca del poseedor del balón. Nivel de intensidad bajo'
      },
      OnBallPressure2: {
        1: 'Se realizan algunas presiones fuertes, pero no con frecuencia. La intensidad general es bastante baja'
      },
      OnBallPressure3: {
        1: 'Registra un volumen medio de presiones cerca del rival en posesión'
      },
      OnBallPressure4: {
        1: 'Perfil disciplinado en la presión, acercándose con regularidad al portador del balón'
      },
      OnBallPressure5: {
        1: 'Muy alta intensidad sin balón, con gran disciplina y trabajo constante para presionar al rival'
      },
      SpatialCoverage1: {
        1: 'Muestra una contribución muy limitada en la ocupación y control de espacios, con mínima implicación en la formación y estructura táctica del equipo. La cobertura espacial es pobre tanto en ataque como en defensa, reflejando poca influencia en la organización y compacidad colectiva'
      },
      SpatialCoverage2: {
        1: 'Ofrece una cobertura espacial por debajo de la media, mostrando algo de participación en la ocupación del campo pero con lagunas en la continuidad posicional y la cohesión con el resto del equipo. La influencia en la estructura táctica es intermitente y menos consistente que la de perfiles mejor clasificados'
      },
      SpatialCoverage3: {
        1: 'Presenta una cobertura espacial media, contribuyendo de forma estable a la ocupación y control de espacios. El posicionamiento es generalmente correcto y funcional, participando en la estructura táctica del equipo con impacto moderado en las fases ofensiva y defensiva'
      },
      SpatialCoverage4: {
        1: 'Ofrece una cobertura espacial por encima de la media, mostrando gran implicación en la ocupación del campo y en la estructura posicional del equipo. La capacidad para mantener la forma y adaptarse a las transiciones contribuye significativamente a la compacidad y control de espacios clave'
      },
      SpatialCoverage5: {
        1: 'Alcanza un nivel excelente de cobertura espacial, optimizando el posicionamiento para influir de forma decisiva en la formación y estructura táctica del equipo. La comprensión del juego y la sincronización con el resto del bloque permiten maximizar la ocupación de espacios estratégicos, tanto en ataque como en defensa'
      },
      OffBallPressure1: {
        1: 'Aplica una presión defensiva muy limitada sin balón, rara vez enfrentándose a rivales para interrumpir sus acciones o provocar errores. La contribución a la presión y a la estructura defensiva es mínima'
      },
      OffBallPressure2: {
        1: 'La presión defensiva sin balón se sitúa por debajo de la media, con participación ocasional pero tiempo o posicionamiento poco consistentes. El impacto en la recuperación de la posesión o en la interrupción de la construcción rival es limitado'
      },
      OffBallPressure3: {
        1: 'Muestra un nivel medio de presión sin balón, contribuyendo de forma constante a los esfuerzos defensivos del equipo. El posicionamiento y el tiempo de entrada suelen ser efectivos, aplicando una presión adecuada para ralentizar o limitar las opciones del rival'
      },
      OffBallPressure4: {
        1: 'Ofrece una presión defensiva sin balón por encima de la media, interrumpiendo con frecuencia las acciones rivales y reduciendo su tiempo y espacio. Los esfuerzos están bien coordinados, ayudando al equipo a mantener una estructura defensiva sólida'
      },
      OffBallPressure5: {
        1: 'Sobresale en la aplicación de presión defensiva sin balón, acosando de forma constante a los rivales, forzando pérdidas y limitando las líneas de pase. La intensidad, el posicionamiento y la anticipación mejoran significativamente la eficacia defensiva del equipo'
      },
      Distance1: {
        1: 'Cubre significativamente menos terreno que la media (el movimiento en el campo es muy limitado)'
      },
      Distance2: {
        1: 'La distancia que se recorre por partido está por debajo de lo común en el fútbol de alto nivel (menor actividad que la media)'
      },
      Distance3: {
        1: 'Se cubre una cantidad razonable de terreno, con cifras cercanas a la media de la liga (implicación física equilibrada)'
      },
      Distance4: {
        1: 'Se cubren distancias altas de manera constante, con cifras que reflejan gran resistencia (mostrando un sólido rendimiento físico)'
      },
      Distance5: {
        1: 'El volumen físico es sobresaliente, situándose entre los perfiles más activos de las 5 grandes ligas en cuanto a terreno recorrido'
      },
      Sprint1: {
        1: 'Se realizan muy pocas carreras a alta velocidad en comparación con la media (esfuerzo de sprint mínimo durante los partidos)'
      },
      Sprint2: {
        1: 'La frecuencia de sprint es inferior a la media para la posición (poca explosividad en movimientos a alta velocidad)'
      },
      Sprint3: {
        1: 'Se registra un número moderado de sprints por partido, dentro del promedio esperado (valores alrededor de la media de la liga)'
      },
      Sprint4: {
        1: 'Destaca por la frecuencia de los sprints, muy por encima de la media. Se muestra explosividad constante, aportando carreras de alta velocidad durante el partido'
      },
      Sprint5: {
        1: 'Se sitúa en el 20% superior de jugadores con mayor volumen de sprints por 90 minutos. Máximo rendimiento físico en esfuerzos repetidos a alta velocidad'
      },
      Acceleration1: {
        1: 'La capacidad para cambiar de ritmo está claramente por debajo de la media, con muy pocas aceleraciones explosivas durante el partido'
      },
      Acceleration2: {
        1: 'La producción de aceleraciones está por debajo de la media en comparación con perfiles similares, con poca frecuencia de arranques en corta distancia'
      },
      Acceleration3: {
        1: 'Se registra un número aceptable de aceleraciones, cercano a la media de la liga. Los cambios de ritmo no destacan, pero las cifras son correctas en esta métrica'
      },
      Acceleration4: {
        1: 'Existe gran capacidad para acelerar de forma rápida y repetida; la tasa de aceleración está claramente por encima de la media, con arranques frecuentes'
      },
      Acceleration5: {
        1: 'Entre el 20% de los perfiles más explosivos en cuanto a aceleraciones repetidas, manteniendo cifras muy por encima de la media en arranques y cambios de ritmo'
      },
      Speed1: {
        1: 'Es probable que se trate de un perfil físicamente lento o que dosifica los esfuerzos de alta intensidad durante los partidos'
      },
      Speed2: {
        1: 'Registra velocidades punta ligeramente por debajo de la media competitiva'
      },
      Speed3: {
        1: 'Mantiene valores de velocidad punta promedio durante el partido'
      },
      Speed4: {
        1: 'Alcanza con frecuencia altas velocidades, lo que sugiere un perfil rápido y potente'
      },
      Speed5: {
        1: 'Alcanza velocidades punta muy altas, con capacidad para marcar diferencias en cuanto a velocidad'
      },
      LineBreakingCarries1: {
        1: 'Rara vez se rompen líneas mediante conducciones. Falta iniciativa para avanzar con el balón'
      },
      LineBreakingCarries2: {
        1: 'Se completan algunas conducciones que rompen líneas, pero sin mucha regularidad'
      },
      LineBreakingCarries3: {
        1: 'Se promedia un número moderado de conducciones exitosas que rompen líneas'
      },
      LineBreakingCarries4: {
        1: 'Se contribuye a la salida de balón llevando con frecuencia más allá de las líneas y apoyando la progresión'
      },
      LineBreakingCarries5: {
        1: 'Perfil especialista en conducción; rompe líneas de forma constante y en gran volumen con el balón controlado'
      },
      LineBreakingActions1: {
        1: 'Se registran muy pocas acciones que rompen líneas (pases y conducciones). Se asumen riesgos en contadas ocasiones'
      },
      LineBreakingActions2: {
        1: 'Se producen algunas acciones progresivas (pases y conducciones), pero de forma poco frecuente. Predomina el juego más horizontal'
      },
      LineBreakingActions3: {
        1: 'Se combinan pases y conducciones que rompen líneas de forma regular, contribuyendo a la progresión'
      },
      LineBreakingActions4: {
        1: 'Perfil técnicamente dotado e inteligente para producir muchas acciones (pases y conducciones) que rompen líneas rivales'
      },
      LineBreakingActions5: {
        1: 'Especialista en progresión, con gran impacto en el equipo gracias a acciones constantes que rompen líneas mediante pases y conducciones'
      },
      OffBallRuns1: {
        1: 'Se realizan muy pocos movimientos intencionados sin balón, ofreciendo un apoyo limitado a la fase ofensiva. Los desmarques rara vez contribuyen a crear espacios, romper líneas defensivas o mejorar la coordinación del equipo en posesión'
      },
      OffBallRuns2: {
        1: 'El movimiento sin balón se sitúa por debajo de la media, apoyando ocasionalmente el ataque pero sin consistencia en tiempo, dirección o intención táctica. Las carreras tienen un impacto limitado en la apertura de espacios o la mejora de la estructura ofensiva'
      },
      OffBallRuns3: {
        1: 'Se muestra un nivel medio de movimientos intencionados sin balón, contribuyendo de forma constante a la fase ofensiva. Los movimientos suelen estar bien sincronizados y ser funcionales, creando espacios y apoyando el juego del equipo con impacto moderado'
      },
      OffBallRuns4: {
        1: 'Actividad sin balón por encima de la media, con movimientos intencionados frecuentes que desorganizan estructuras defensivas, crean opciones de pase y abren espacios de ataque. Los patrones de movimiento contribuyen significativamente a la coordinación del equipo en posesión'
      },
      OffBallRuns5: {
        1: 'Se sobresale en movimientos intencionados sin balón, anticipando constantemente el juego y realizando desmarques inteligentes que maximizan las oportunidades ofensivas. La sincronización, el posicionamiento y la conciencia espacial generan amenazas constantes y mejoran la fluidez del equipo en posesión'
      },
      OverMaxValue: {
        1: 'Se observa una habilidad extrema en over_max_metric_name, con un rendimiento por encima del valor máximo, lo que sitúa este perfil en ese aspecto en el top 10% de las 5 grandes ligas'
      },
      OverAverageSeason: {
        1: 'Respecto al desempeño en over_average_metric_name, el nivel está por encima del promedio de la liga league_name (over_average_metric_value frente a average_metric_value)',
        2: 'Si se comparan los números con los de la liga league_name, en over_average_metric_name se puede decir que el rendimiento supera el promedio (over_average_metric_value frente a average_metric_value)'
      },
      UnderMinValue: {
        1: 'En cuanto a under_min_metric_name, el rendimiento debe mejorar mucho ya que se sitúa en el percent_metric_name más bajo de las 5 grandes ligas'
      },
      Over70Percent: {
        1: ', destacando especialmente en over_70_metric_name con over_70_metric_value por 90 minutos, respectivamente',
        2: ', por encima del 70% en over_70_metric_name con over_70_metric_value por 90 minutos, respectivamente',
        3: ', desempeñando una labor más que notable en over_70_metric_name con over_70_metric_value por 90 minutos, respectivamente'
      },
      Under30Percent: {
        1: ', siendo necesario poner más énfasis en under_30_metric_name ya que con under_30_metric_value por 90 minutos, respectivamente, el rendimiento es pobre',
        2: ', con necesidad de mejorar notablemente en under_30_metric_name ya que con under_30_metric_value por 90 minutos, respectivamente, el rendimiento está por debajo de lo esperado',
        3: ', en cuanto a under_30_metric_name, con under_30_metric_value por 90 minutos, respectivamente, hace falta un mayor esfuerzo para obtener mejores números'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Cabe destacar el rendimiento superando el promedio de la liga league_name en '
      },
      OverAverageStats: {
        1: ' over_average_metric_name (over_average_metric_value frente a average_metric_value de promedio)'
      },
      Over70PercentIndividualPressure: {
        1: ', ejerciendo una muy buena presión a la hora de recuperar el balón',
        2: ', realizando una alta presión al rival para recuperar la pelota'
      },
      Under30PercentIndividualPressure: {
        1: ', siendo necesario intensificar más la presión para recuperar el balón',
        2: ', teniendo que poner más esfuerzo en cuanto a presionar al rival se refiere'
      }
    },
    himSelf: 'sí',
    ownSeason: 'Competición propia',
    minMaxTooltip: 'Ajustar valores mínimos y máximos del radar'
  },
  login: {
    login: 'Iniciar sesión',
    latestBlogPosts: 'Últimos Posts',
    signIn: 'Sign In',
    username: 'Usuario',
    password: 'Contraseña',
    passwordForgotten: 'Contraseña Olvidada',
    signUp: 'Registrarse',
    enter: 'Entrar',
    forceTitle: 'Cuenta en uso',
    forceMessage: 'La cuenta está en uso en otro dispositivo. ¿Quieres echarla y conectarla en este dispositivo?',
    forgotMyPassword: 'Olvidé mi contraseña',
    firstLogin: 'Primer acceso',
    firstLoginMessage: 'Por motivos de seguridad tienes que asignar una nueva contraseña en tu primer acceso. Además de un idioma de preferencia para visualizar la aplicación',
    firstLoginOverview: 'Aquí tienes un resumen de tu cuenta, las ligas y los productos a los que tienes acceso.',
    passwordConfirmation: 'Confirmar contraseña',
    forgotPasswordMessage: 'Escriba su correo electrónico, si existe una cuenta valida asociada recibirá en su correo los siguientes pasos para recuperar su contraseña',
    resetPassword: 'Restablecer contraseña',
    resetPasswordLinkInvalid: 'Este enlace no es válido o ha caducado. Solicita un nuevo restablecimiento de contraseña desde el inicio de sesión.',
    skipSettings: 'Omitir ajustes',
    contact: 'Contacto',
    cookiesText: 'Este sitio utiliza cookies de Google para prestar sus servicios, analizar su tráfico para garantizar la calidad del servicio, generar estadísticas de uso y detectar y solucionar abusos.',
    contactUs: 'Contáctanos',
    newsTitle: "Nuevo: ¡Scores físicos!",
    newsText: "Hemos añadido dos nuevas puntuaciones de rendimiento físico junto a nuestro score original de datos de eventos: <b>Score de Resistencia</b> y <b>Score de Velocidad y Potencia</b>.<br> Resistencia destaca a los jugadores que recorren terreno de forma constante y mantienen altas cargas de trabajo, mientras que Velocidad y Potencia se centra en la velocidad máxima, los sprints y las aceleraciones explosivas."
  },
  settings: {
    pageSubtitle: 'Configura tu experiencia en la aplicación',
    language: 'Idioma',
    availableLeagues: 'Ligas Disponibles',
    availableSeasons: 'Temporadas Disponibles',
    availableProducts: 'Productos Disponibles',
    organization: 'Organización',
    changePassword: 'Cambiar contraseña',
    seasonTemplates: 'Plantillas de temporadas',
    seasonTemplatesSubtitle: 'Crea plantillas de temporadas que luego podrán ser seleccionadas en Rendimiento de Jugadores y Búsqueda de Jugadores',
    templateName: 'Nombre de la plantilla',
    selectTemplate: 'Seleccionar plantilla a editar',
    radarDefault: 'Radar por defecto',
    default: 'Por Defecto',
    tabs: {
      options: 'Opciones',
      templates: 'Plantillas',
      availableLeagues: 'Ligas Disponibles',
      contactData: 'Datos de Contacto GBE'
    },
    contactData: {
      userDetails: 'Datos de Usuario',
      firstName: 'Nombre',
      lastName: 'Apellido',
      contactDetails: 'Datos de Contacto',
      name: 'Nombre',
      phone: 'Teléfono',
      mobile: 'Móvil',
      email: 'Correo',
      representativeDetails: 'Datos del Representante'
    },
    currency: 'Divisa',
    fieldPreferences: 'Ajustes del campo',
    visualizationsPreferences: 'Ajustes de visualizaciones',
    fieldColor: 'Color del campo',
    fieldColors: {
      green: 'Verde',
      blue: 'Azul',
      white: 'Blanco',
      black: 'Negro',
      grey: 'Gris'
    },
    defaultPlayerVisualization: 'Visualización de jugador por defecto',
    appPreferences: 'Preferencias de la aplicación',
    darkMode: 'Modo Oscuro',
    showTour: 'Mostrar Visita Guiada',
    customStats: 'Estadísticas Personalizadas',
    radarTemplates: 'Plantillas de radar',
    radarTemplatesSubtitle: 'Crea plantillas de métricas que luego podrán ser seleccionadas en Rendimiento de Jugadores y Ranking de Jugadores',
    radarCategories: {
      Custom1: 'Personalizado 1',
      Custom2: 'Personalizado 2',
      Custom3: 'Personalizado 3',
      Custom4: 'Personalizado 4',
      Custom5: 'Personalizado 5',
      Custom6: 'Personalizado 6',
      Physical: 'Física',
      CustomPhysical1: 'Personalizado Física 1',
      CustomPhysical2: 'Personalizado Física 2',
      CustomPhysical3: 'Personalizado Física 3',
      CustomPhysical4: 'Personalizado Física 4',
      CustomPhysical5: 'Personalizado Física 5',
      CustomPhysical6: 'Personalizado Física 6'
    },
    templateRemoveTitle: 'Eliminar Plantilla',
    templateRemoveMsg: '¿Está seguro que desea eliminar esta plantilla?',
    templateEditTitle: 'Guardar Plantilla',
    templateEditMsg: 'Existe una plantilla sin guardar, ¿Desea guardarla antes de cargar otra plantilla?',
    category: 'Categoría',
    playerRadar: 'Radar de jugador',
    teamRadar: 'Radar de equipo',
    statsAlert: 'Insertar mínimo una estadística para guardar',
    recommended: 'Recomendado',
    warning: 'Hay posiciones con el máximo de radares permitidos. Por favor, borre o edite alguún radar',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Español',
      numeric: 'Numérico'
    },
    showMediaMode: 'Mostrar Modo Media',
    statTemplates: 'Plantilla Métricas de Partido',
    statTemplatesSubtitle: 'Crea tus propias plantillas eligiendo entre multitud de métricas',
    ratingFormat: {
      ratingFormat: 'Formato de las valoraciones',
      numbers: 'Números',
      letters: 'Letras A-F',
    },
  },
  playerDetail: {
    passport: 'Pasaporte ',
    secondPassport: 'Segundo Pasaporte',
    age: 'Edad',
    dateOfBirth: 'Fecha de Nacimiento',
    height: 'Altura',
    weight: 'Peso',
    wage: 'Salario',
    history: 'Historial',
    positions: 'Posiciones',
    injuries: 'Lesiones',
    transfers: 'Transferencias',
    nationalTeam: 'Selección',
    addFavorite: 'Añadir a favoritos',
    removeFavorite: 'Quitar de favoritos',
    contractEnd: 'Fin de contrato',
    yearsOld: ' años',
    playerAvailability: 'Disponiblidad',
    playerUsage: 'Minutos Jugados',
    usage: 'Uso',
    addToCollection: 'Añadir a colección',
    performance: 'Rendimiento',
    info: 'Info',
    career: 'Trayectoria',
    playerStyle: 'Estilos',
    radar: 'Radar',
    finishingMap: 'Finalización',
    threatMap: 'Peligrosidad',
    keyPassMap: 'Pases Clave',
    turnoversMap: 'Pérdidas y Recuperaciones',
    beeswarm: 'Ranking',
    allGames: 'Partidos',
    eventsMap: 'Eventos',
    lbpMap: 'Pases Entre Líneas',
    obpMap: 'Presión Al Balón',
    pupMap: 'Pases Bajo Presión',
    obrMap: 'Recepciones En Espacio',
    fullName: 'Nombre completo',
    academy: 'Academia',
    name: 'Nombre',
    lastName: 'Apellidos',
    playerAvailabilityLong: '% de la temporada sin lesiones ni suspensiones',
    playerUsageLong: 'Minutos Jugados',
    playerAvailability1: 'partidos sin lesiones ni suspensiones',
    playerAvailability2: 'partidos esta temporada',
    playerUsage1: 'minutos jugados',
    playerUsage2: 'minutos totales del equipo',
    notMinutesThisSeason: 'No ha jugado minutos esta temporada',
    seasonPlaceholder: 'No hay temporada activa',
    inactivePlayer: 'Jugador inactivo',
    inactivePlayerMessage: 'Si necesitas más información, puedes pedir un informe!',
    goRequest: 'Ir a solicitar',
    warningMinutes: '¡Precaución! Menos de 450 minutos jugados, el análisis puede no ser representativo',
    scoreWarningMinutes: 'Jugadores con al menos 450 minutos totales jugados',
    pdScoreWarningMinutes: 'Jugadores con al menos 450 minutos totales jugados (mínimo 60 minutos por partido)',
    warningSeasonGames: 'Temporada con menos de 5 partidos jugados, Min & Max de las 5 grandes ligas',
    warningStatsRemoved: 'Algunas métricas no se muestran porque no están disponibles para la temporada seleccionada',
    warningBeeswarm: 'No se muestra el jugador porque no hay datos para esta métrica en la temporada seleccionada',
    warningPlayersZeroValue: 'No se muestran {x} jugadores con 0 ',
    onlyPlayersThatFit: 'Sólo jugadores que encajen en la plantilla del radar',
    gamesPlayedNotEnough: 'Opciones no disponibles porque no hay suficientes partidos jugados',
    gbe: 'GBE',
    analysis: 'Análisis',
    documents: 'Documentos',
    rankDefensive: 'Defensivo',
    rankBallHandling: 'Movimiento de balón',
    rankGoal: 'Contribución de gol',
    rankXt: 'Peligrosidad',
    rankIndex: 'Index',
    visitHistory: 'Historial de visitas',
    placer: 'Campo',
    touchesMap: 'Mapa de toques',
    heatMap: 'Mapa de calor',
    ageProfile: 'Perfil de edad',
    strongFoot: 'Pie bueno',
    player: 'Jugador',
    outOf: 'de',
    in: 'en',
    radius: 'Radio',
    blur: 'Desenfoque',
    careerTable: {
      nationalTeamCareer: 'Carrera en el Equipo Nacional',
      nationalTeamCompetitions: 'Competiciones del Equipo Nacional'
    },
    physicalProgression: 'Progresión física',
    gpi: 'Índice Global de Jugadores',
    gpiDescription: 'El Global Player Index (GPI) es un sistema estandarizado de calificación de futbolistas que los evalúa en función del nivel de su equipo y el de sus rivales, del rendimiento en los partidos disputados y de su disponibilidad. Inspirado en el sistema Elo, garantiza que las valoraciones reflejen entornos competitivos reales en lugar de partir de valores arbitrarios.',
    warningGPI: 'Disponible solo para jugadores activos en ligas ELO en los últimos 30 días',
    diffGPI: 'Variación desde el último partido',
    rankingInTheWorld: '#{0} en el mundo',
    rankingInTheLeague: '#{0} en {1}',
    max: 'Máx',
    gpiChart: 'Gráfico basado en el valor del Índice Global de Jugadores de los últimos {0} partidos',
    percentileRange: 'Percentiles {0} a {1}',
    months: 'meses',
    month: 'mes',
    contractExpOver4Years: 'El contrato expira en',
    contractExpSoon: 'El contrato expira pronto',
    contractFinalYear: 'Último año de contrato',
    freeAgent: 'Agente libre',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB',
      },
      25: {
        label: 'Portero de Área',
        abbreviation: 'PAR',
      },
      26: {
        label: 'Linea',
        abbreviation: 'LIN',
      },
      27: {
        label: 'Iniciador',
        abbreviation: 'INI',
      },
      28: {
        label: 'Conductor',
        abbreviation: 'CON',
      },
      29: {
        label: 'Anticipador',
        abbreviation: 'ANT',
      },
      30: {
        label: 'Cobertura',
        abbreviation: 'COB',
      },
      31: {
        label: 'Defensa de Área',
        abbreviation: 'DAR',
      },
      32: {
        label: 'Profundo',
        abbreviation: 'DPR',
      },
      33: {
        label: 'Interior',
        abbreviation: 'INT',
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY',
      },
      35: {
        label: 'Defensivo',
        abbreviation: 'DEF',
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN',
      },
      37: {
        label: 'Recuperador',
        abbreviation: 'REC',
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG',
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS',
      },
      40: {
        label: 'Progresivo',
        abbreviation: 'PRG',
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B',
      },
      42: {
        label: 'Regista ofensivo',
        abbreviation: 'ROF',
      },
      43: {
        label: 'Ultimo tercio',
        abbreviation: 'ULT',
      },
      44: {
        label: 'Caballo',
        abbreviation: 'CAB',
      },
      45: {
        label: 'Llegador',
        abbreviation: 'LLE',
      },
      46: {
        label: 'Desequilibrante',
        abbreviation: 'DES',
      },
      47: {
        label: 'Invertido goleador',
        abbreviation: 'ING',
      },
      48: {
        label: 'Creador',
        abbreviation: 'CRE',
      },
      49: {
        label: 'Medio Profundo',
        abbreviation: 'MPR',
      },
      50: {
        label: 'Referencia',
        abbreviation: 'REF',
      },
      51: {
        label: 'Asociativo',
        abbreviation: 'ASO',
      },
      52: {
        label: 'Ruptura',
        abbreviation: 'RUP',
      },
      53: {
        label: 'Finalizador',
        abbreviation: 'FIN',
      }
    }
  },
  finishingMap: {
    typesOfShot: 'Tipos de Remate',
    shotStrategy: 'Estrategia',
    strategiesCount: '{count} estrategias',
    areas: 'Áreas',
    bodyPart: 'Parte del Cuerpo',
    more: 'más',
    selectAll: 'Seleccionar Todos',
    minutes: 'Minutos',
    circles: 'Círculos',
    boxes: 'Mapa de Calor por Cajas',
    lines: 'Líneas',
    games: 'Partidos',
    perShot: 'por Remate',
    goal: 'Gol',
    missedShot: 'Remate Fuera',
    savedShot: 'Remate Parado',
    shotOnPost: 'Remate al Palo',
    missedChance: 'Ocasión Perdida',
    openPlay: 'En Juego',
    regularPlay: 'En Jugada',
    fastBreak: 'En Contrataque',
    individualPlay: 'En Jugada Individual',
    setPiece: 'A Balón Parado',
    fromCorner: 'De Corner',
    freeKick: 'De Falta Directa',
    indirectFreeKick: 'De Falta Indirecta',
    throwInSetPiece: 'De Saque de Banda',
    inBox: 'Dentro del Área',
    goalArea: 'Área Pequeña',
    boxLeft: 'Dentro del Área - Izquierda',
    boxCenter: 'Dentro del Área - Centro',
    boxRight: 'Dentro del Área - Derecha',
    outOfBox: 'Fuera del Área',
    outBoxDeepLeft: 'Fuera del Área - Fondo Izquierda',
    outBoxDeepRight: 'Fuera del Área - Fondo Derecha',
    outBoxLeft: 'Fuera del Área - Izquierda',
    outBoxCentreLeft: 'Fuera del Área - Centro Izquierda',
    outBoxCentre: 'Fuera del Área - Centro',
    outBoxCentreRight: 'Fuera del Área - Centro Derecha',
    outBoxRight: 'Fuera del Área - Derecha',
    left35: 'Izquierda +35',
    centreLeft35: 'Centro Izquierda +35',
    centre35: 'Centro +35',
    centreRight35: 'Centro Derecha +35',
    right35: 'Derecha +35',
    head: 'De Cabeza',
    rightFooted: 'Pie Derecho',
    leftFooted: 'Pie Izquierdo',
    otherBodyPart: 'Otro',
    chart: {
      shots: 'Remates',
      xGPerShot: 'xG por Tiro',
      exceptionTextPenaltyGoals: '* Penaltis = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Penaltis = 0.765 xGOT',
      exceptionTextOwnGoals: '* Goles en propia meta no se tienen en cuenta',
      og: 'PP',
      penaltiesExcluded: 'Goles de penalti excluidos',
      ownGoalsExcluded: 'Goles en propia excluidos',
      sumOfxG: 'Suma de xG',
      exceptionShotsOutOfRange: '* No se muestran los remates fuera de rango'
    },
    inGoal: 'Dentro de la portería',
    outOfGoal: 'Fuera de la portería',
    highLeft: 'Arriba izquierda',
    highCenter: 'Arriba centro',
    highRight: 'Arriba derecha',
    lowLeft: 'Abajo izquierda',
    lowCenter: 'Abajo centro',
    lowRight: 'Abajo derecha',
    outHighLeft: 'Fuera arriba izquierda',
    high: 'Fuera arriba centro',
    outHighRight: 'Fuera arriba derecha',
    closeHighLeft: 'Cerca arriba izquierda',
    closeHigh: 'Cerca arriba centro',
    closeHighRight: 'Cerca arriba derecha',
    closeLeft: 'Cerca abajo izquierda',
    closeRight: 'Cerca abajo derecha',
    finishingTable: 'Tabla de finalización',
    onGoal: 'A puerta',
    distributionFilters: 'Filtros de distribución',
    penalty: 'Penalti',
    penaltyShootout: 'Tanda de penaltis',
    onlyPercentage: 'Mostrar porcentaje',
    showAll: 'Mostrar todo',
    chanceMissed: 'Oportunidad perdida'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Pases Clave',
      xAPerPass: 'xA por Pase',
      xAOpenPlay: 'xA en Jugada',
      xASetPiece: 'xA en Parado'
    }
  },
  beeswarm: {
    template: 'Plantilla',
    templates: {
      Goalkeeper: 'Porteros',
      Defender: 'Defensas',
      'Full-Back': 'Laterales',
      FullBack: 'Laterales',
      'Wing-Back': 'Carrileros',
      WingBack: 'Carrileros',
      Midfielder: 'Centrocampistas',
      AttackingMidfielder: 'Media punta',
      Winger: 'Extremos',
      Forward: 'Delanteros',
      Physical: 'Física'
    },
    compareWith: 'Comparar con',
    highlightPlayersOf: 'Resaltar jugadores de',
    highlightPlayers: 'Resaltar jugadores',
    per90: 'Datos por 90 minutos de juego',
    highlightTeams: 'Resaltar equipos',
    filterTeams: 'Filtrar Equipos',
    warningZeros: 'Solo para métricas no invertidas'
  },
  collections: {
    newCollection: 'Nueva colección',
    editCollection: 'Editar colección',
    name: 'Nombre',
    visibility: 'Visibilidad',
    privacity: {
      publicTitle: 'Pública',
      publicDescription: 'Visible para ti y todo tu club',
      privateTitle: 'Privada',
      privateDescription: 'Solo visible para ti',
      supervisedTitle: 'Supervisadas',
      supervisedDescription: 'Solo visible para ti y tu supervisor'
    },
    addSuccess: 'Añadido con éxito',
    createAddSuccess: 'Creada y añadido correctamente',
    editSuccess: 'Actualizada correctamente',
    deleteSuccess: 'Eliminada correctamente',
    title: 'Colecciones de jugadores',
    publics: 'Públicas',
    privates: 'Privadas',
    supervised: 'Supervisadas',
    totalMarketValue: 'Valor de mercado total',
    avgMarketValue: 'Valor de mercado medio',
    avgAge: 'Edad media',
    searchBarPlaceholder: 'Busca y selecciona un jugador para añadirlo a la colección',
    deleteCollection: 'Eliminar colección',
    deleteCollectionMessage: 'Se eliminará la colección. ¿Está seguro?',
    removePlayer: 'Eliminar jugador',
    removePlayerMessage: 'Se eliminará el jugador de la colección. ¿Está seguro?',
    subtitle: 'Organiza tus búsquedas',
    notExitingTemplate: 'Todavía no hay plantillas'
  },
  searchbar: {
    placeholder: 'Teclee para buscar (Ej: `sergio sevilla´)',
    players: 'Jugadores',
    teams: 'Equipos',
    games: 'Partidos',
    leagues: 'Ligas',
    explore: 'Explorar mas resultados',
    placeholderNoResults: 'No hay resultados para la plantilla',
    teamPlaceholder: 'Busca y selecciona un equipo para compararlo'
  },
  favorites: {
    showOnly: 'Mostrar solo',
    selfFavorites: 'Mis favoritos',
    clubFavorites: 'Favoritos del club',
    contractExpiration: 'Expiración del contrato',
    groupBy: 'Agrupar por',
    noGrouped: 'Sin agrupar',
    maxSelection: 'Máximo',
    selectAtleastOne: 'Mínimo seleccionar uno',
    comparePlayers: 'Comparar jugadores',
    selectedPlayers: 'seleccionados',
    subtitle: 'Gestiona tus favoritos',
    generateXlsx: 'Generar XLSX',
    generating: 'Generando...',
    subscribed: 'Suscrito',
    subscribedTooltip: 'Suscribirse para recibir un correo cuando un partido se haya jugado',
    deleteSelected: 'Borrar seleccionados',
  },
  expiration: {
    summer: 'Junio',
    winter: 'Diciembre'
  },
  positions: {
    noposition: 'No Posición',
    goalkeeper: 'Portero',
    goalkeepers: 'Porteros',
    defender: 'Defensa',
    defenders: 'Defensas',
    defenses: 'Defensas',
    fullback: 'Lateral',
    fullbacks: 'Laterales',
    midfielder: 'Mediocentro',
    midfielders: 'Mediocentros',
    winger: 'Extremo',
    wingers: 'Extremos',
    forward: 'Delantero',
    forwards: 'Delanteros',
    wingback: 'Carrilero',
    wingbacks: 'Carrileros'
  },
  dPos: {
    1: {
      name: 'Goalkeeper',
      alias: ''
    },
    2: {
      name: 'Right Full Back',
      alias: 'RFB'
    },
    3: {
      name: 'Right Center Back',
      alias: 'RCB'
    },
    4: {
      name: 'Left Center Back',
      alias: 'LCB'
    },
    5: {
      name: 'Left Full Back',
      alias: 'LFB'
    },
    6: {
      name: 'Defensive Midfielder',
      alias: 'DM'
    },
    7: {
      name: 'Right Winger',
      alias: 'RW'
    },
    8: {
      name: 'Center Midfielder',
      alias: 'CM'
    },
    9: {
      name: 'Striker',
      alias: 'ST'
    },
    10: {
      name: 'Attacking Midfielder',
      alias: 'AM'
    },
    11: {
      name: 'Left Winger',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Comparar con',
    lastSeasonSelectText: 'Temporada pasada',
    lastAndCurrentSeasonSelectText: 'Temporada pasada + actual',
    currentSeasonSelectText: 'Temporada actual',
    lastNgamesSelectText: 'Últimos {x} partidos',
    npgVsXGTitle: 'Goles Sin Penaltis VS xG',
    totalXGLabel: 'Total xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Goles Sin Penaltis Totales',
    xGAgainstvsNPGAgainstTitle: 'xG En Contra VS Goles Sin Penaltis En Contra',
    totalXGAgainstLabel: 'xG En Contra Total',
    xGAgainstLabel: 'xG En Contra',
    totalNPGAgainstLabel: 'Total Goles Sin Penaltis En Contra',
    xGvsxGAgainstTitle: 'xG VS xG En Contra',
    pointsVsXPointsTitle: 'Puntos Obtenidos VS Puntos Esperados',
    xTTitle: 'Control de Partido',
    totalXPoints: 'Puntos Esperados Totales',
    totalPoints: 'Puntos Totales',
    requestedReports: 'Informes Solicitados',
    playersScouted: 'Jugadores ojeados',
    performanceVSAverageChart: 'Rendimiento VS Promedio',
    perPositions: 'Por Posiciones',
    perLeagues: 'Por Ligas',
    perMonths: 'Por Meses',
    perClients: 'Por Clientes',
    ofPreposition: 'de',
    idJChartTitle: 'Iniciativa de Juego',
    idJChartLabel: 'Índice IdJ',
    vJOChartTitle: 'Volumen Juego Ofensivo',
    vJOChartLabel: 'Índice VJO',
    preJOChartTitle: 'Precisión Juego Ofensivo',
    preJOChartLabel: 'Índice PreJO',
    proJOChartTitle: 'Progresión Juego Ofensivo',
    proJOChartLabel: 'Índice ProJO',
    chart: 'Gráfico',
    table: 'Tabla',
    showLeaguesWithAtLeast: 'Mostrar ligas con al menos',
    playersScoutedSuffix: 'jugadores ojeados'
  },
  table: {
    history: {
      season: 'Temporada',
      team: 'Equipo',
      position: 'Posición',
      side: 'Lado',
      games: 'Partidos',
      minutes: 'Mins',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Partidos Ausente',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Temporada',
      team: 'Equipo',
      injury: 'Lesión',
      dateFrom: 'Fecha Inicio',
      dateTo: 'Fecha Fin',
      daysLost: 'Días Perdidos',
      gamesLost: 'Partidos Perdidos',
      allInjuries: 'Todas las lesiones'
    },
    transfers: {
      season: 'Temporada',
      date: 'Fecha',
      teamFrom: 'Equipo Procedente',
      teamTo: 'Equipo Destino',
      marketValue: 'Valor de Mercado',
      fee: 'Coste',
      type: 'Tipo'
    },
    caps: {
      team: 'Equipo',
      debut: 'Debut',
      games: 'Partidos',
      goals: 'Goles',
      coachDuringDebut: 'Entrenador en el Debut',
      debutAge: 'Edad de Debut'
    },
    roster: {
      country: 'País',
      player: 'Jugador',
      positions: 'Posiciones',
      minutes: 'Minutos',
      games: 'Partidos',
      goals: 'Goles',
      assists: 'Asistencias',
      cards: 'Tarjetas',
      gamesExplicit: 'Partidos Jugados'
    },
    league: {
      title: 'Ficha de la liga',
      subtitle: 'Profundiza en la clasificación y las estadísticas de la liga',
      team: 'Equipo',
      games: 'PJ',
      gamesExplicit: 'Partidos Jugados',
      gamesRanking: 'P',
      gamesRankingExplicit: 'Partidos Jugados',
      points: 'Pts',
      pointsExplicit: 'Puntos',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Puntos esperados',
      goalsScored: 'NPG',
      goalsScoredExplicit: 'Goles sin penaltis',
      xG: 'xG',
      xGExplicit: 'Goles Esperados',
      goalsAgainst: 'NPGA',
      goalsAgainstExplicit: 'Goles en contra',
      xGAgainst: 'xGA',
      xGAgainstExplicit: 'Goles en contra esperados',
      xGAgainstDiff: 'xGA Dif.',
      xGAgainstDiffExplicit: 'Diferencia de goles en contra esperados',
      form: 'Forma',
      sos: 'SoS',
      sosExplicit: 'Dificultad del calendario',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Ventaja en casa',
      difficultyAboveAvg: 'Dificultad sobre la media',
      differentGames: '* Diferente Número de Partidos Jugados',
      berth: 'Calificación'
    },
    usersOfClient: {
      userName: 'Nombre',
      userRole: 'Usuario',
      devRole: 'Desarrollador',
      adminRole: 'Administrador',
      servicesRole: 'Servicios',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elevens',
      similarityRole: 'Similarity',
      gameAnalysisRole: 'Game Analysis',
      clientStatsRole: 'Stats de Cliente',
      created: 'Fecha Creación',
      type: 'Tipo',
      logins: 'Accesos',
      lastLogin: 'Último acceso',
      trialDate: 'Fecha límite'
    },
    clientLeagues: {
      league: 'Liga',
      area: 'Área',
      tier: 'Nivel',
      seasons: 'Temporadas',
      currentMatchDay: 'Jornada',
      regular: 'Regular',
      youthLeague: 'Filial',
      clientActive: 'Activa',
      visibleLeagues: 'Ligas visibles',
      male: 'Liga masculina',
      female: 'Liga femenina',
    },
    connections: {
      title: 'Combinaciones más comunes',
      playerFrom: 'Pasador',
      playerTo: 'Receptor',
      passes: 'Pases',
      passesTooltip: 'Pases Exitosos Total',
      passesFinalThird: 'PU ⅓',
      passesFinalThirdTooltip: 'Pases Último Tercio'
    },
    playerPassMapData: {
      title: 'Estadísticas de Pase',
      player: 'Jugador',
      passes: 'Pases',
      passesPct: '% Pases',
      xA: 'xA',
      xG: 'xG',
      xT: 'xT',
      playerTooltip: 'Nombre del Jugador',
      passesTooltip: 'Número Total de Pases Realizados',
      passesPctTooltip: 'Porcentaje de pases con éxito',
      xATooltip: 'Asistencias Esperadas',
      xGTooltip: 'Goles Esperados',
      xTTooltip: 'Peligro Esperado'
    },
    playerAllGames: {
      gameDate: 'Fecha',
      game: 'Partido',
      team: 'Equipo',
      positionsPlayed: 'Posiciones',
      minsPlayed: 'Minutos',
      gameActions: 'Acciones',
      gameDateTooltip: 'Fecha partido',
      gameTooltip: 'Partido',
      positionsPlayedTooltip: 'Posiciones en las que ha jugado',
      minsPlayedTooltip: 'Minutos Jugados',
      gameActionsTooltip: 'Goles, Asistencias, Tarjetas',
      from: 'Inicio',
      to: 'Fin',
      goalText: 'Gol en el',
      assistText: 'Asistencia en el',
      penaltyText: 'Penalti en el',
      ownGoalText: 'Gol en propia en el',
      yellowCardText: 'Amarilla en el',
      secondYellowCardText: 'Segunda Amarilla en el',
      redCardText: 'Roja en el',
      substitutionIN: 'Entra en el',
      substitutionOUT: 'Sale en el',
      suspendedText: 'Sancionado',
      Team: 'Equipo'
    },
    gameFlow: {
      phase: 'Fase ',
      mins: 'Minutos',
      team: 'Equipo',
      period: 'Período',
      possession: 'Pos',
      possessionTooltip: '% Posesión',
      xT: 'xT',
      xTTooltip: 'Peligro Esperado',
      pft: 'PUT',
      pftTooltip: 'Pases Último Tercio del Campo',
      xG: 'xG',
      xGTooltip: 'Goles Esperados'
    }
  },
  game: {
    title: 'Ficha del partido',
    subtitle: 'Profundiza en las características y estadísticas del partido',
    header: {
      gameDetails: 'Detalles',
      gameStats: 'Estadísticas',
      gameFinishingMap: 'Mapa xG',
      gameKeyPassMap: 'Mapa xA',
      gamePassMap: 'Mapa de Pases',
      gameThreat: 'Mapa de Peligro',
      gameFlow: 'Control de Partido',
      gameAnalysis: 'Análisis',
      gamePhysicalStats: 'Estadísticas Físicas',
      possessions: 'Posesiones',
      bench: 'Banquillo',
      video: 'Videos destacados',
      preGame: 'Prepartido',
      postGame: 'Pospartido',
      areaCoverage: 'Cobertura de área'
    },
    status: {
      scheduled: 'Programado',
      postponed: 'Aplazado',
      cancelled: 'Cancelado',
      inPlay: 'En directo',
      finished: 'Finalizado',
      awarded: 'Adjudicado',
      dataAvailable: 'Los datos estarán disponibles en las próximas horas',
    },
    avgScoreTooltip: 'Valoración media por minutos',
    passMap: {
      typeOfPlay: 'Tipo de juego:',
      passes: 'Pases:',
      team: 'Equipo',
      minutes: 'Minutos:',
      minuteRange: 'Rango de minutos',
      select: 'Selecciona',
      all: 'Todos',
      attacking: 'Ataque',
      defending: 'Defensa',
      forwards: 'Adelante',
      backwards: 'Atrás',
      sideways: 'A los lados',
      longBall: 'Pase Largo',
      successfullPasses: 'Pases Completados',
      homeTeam: 'Local',
      awayTeam: 'Visitante',
      passingMatrix: 'Matriz de Pases',
      passer: 'Pasador',
      receiver: 'Receptor',
      passOutcome: 'Resultado del Pase',
      passDirection: 'Dirección del Pase',
      half: 'Mitad',
      offensive: 'Ofensiva',
      defensive: 'Defensiva',
      passingConnections: 'Conexiones de Pases',
      pitchView: 'Campo',
      passSingular: 'Pase',
      passPlural: 'Pases',
      playerLocation: 'Posición del Jugador',
      passLegend: 'Posición Media de Toques'
    },
    stats: {
      summary: 'Resumen',
      attacking: 'Ataque',
      defending: 'Defensivas',
      contribution: 'Contribución',
      possession: 'Posesión',
      expectedPoints: 'Puntos esperados',
      directness: 'Verticalidad',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Balón Parado',
      xA: 'xA',
      xASetPiece: 'xA xG Balón Parado',
      xT: 'xT',
      xTSetPiece: 'xT xG Balón Parado',
      touchesInOppBox: 'Toques en Área Rival',
      passesFinalThird: 'Pases Último Tercio',
      interceptions: 'Intercepciones',
      recoveries: 'Recuperaciones',
      recoveriesOppHalf: 'Recuperaciones Campo Contrario',
      tackles: 'Tackles',
      tacklesWasDribbled: '1vs1 Defensivos Ganados',
      fouls: 'Faltas',
      yellowCards: 'Tarjetas Amarillas',
      redCards: 'Tarjetas Rojas',
      passes: 'Pases',
      passing: 'Porcentaje de Pases',
      crosses: 'Centros',
      crossing: 'Porcentaje de Centros',
      shots: 'Remates',
      shotsOnTarget: 'Remates a Puerta',
      ppdaExplicit: 'pases por acción defensiva',
      xgExplicit: 'Goles Esperados',
      xp: 'xP',
      ExpectedPassing: 'xP%',
      seasonAvg: 'Media de la competición',
      winChanceTooltip: 'Probabilidad de victoria basada en xG generado y concedido',
      drawChance: 'Empate',
      xgAgainst: 'xG En Contra',
      averagePossession: 'Posesión',
      averageShots: 'Remates',
      averagexG: 'Goles Esperados',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt'
    },
    detail: {
      halfTime: 'Media parte',
      overTime: 'Prórroga',
      showStats: 'Mostrar estadísticas',
      hideStats: 'Ocultar estadísticas',
      bench: 'Banquillo',
      showShotOptions: 'Mostrar opciones de tiro',
      hideShotOptions: 'Ocultar opciones de tiro',
      showPassOptions: 'Mostrar opciones de pase',
      hidePassOptions: 'Ocultar opciones de pase',
      endGame: 'Fin del partido',
      penalties: 'Penaltis'
    },
    timeline: {
      gameTimeline: 'Cronología del partido',
      events: {
        goal: 'Gol',
        goal_ownGoal: 'Gol en propia puerta',
        goal_penalty: 'Gol de penalti',
        card: 'Tarjeta',
        card_yellowCard: 'Tarjeta amarilla',
        card_secondYellowCard: 'Segunda tarjeta amarilla',
        card_redCard: 'Tarjeta roja',
        formationChange: 'Cambio de formación',
        substitution: 'Sustitución',
        saveShot: 'Tiro parado',
        saveShot_penalty: 'Penalti parado',
        missedShot: 'Tiro fallado',
        missedShot_penalty: 'Penalti fallado',
        shotOnPost: 'Tiro al Palo',
        shotOnPost_penalty: 'Penalti al Palo',
        drinksBreak_startDrinksBreak: 'Inicio de la pausa de hidratación',
        drinksBreak_endDrinksBreak: 'Fin de la pausa de hidratación',
        assist: 'Asistencia',
      }
    },
    gameFlow: {
      goalOf: 'Gol de ',
      redCardTo: 'Roja a ',
      missedPenalty: 'Penalty fallado '
    },
    gameThreat: {
      typeOfPlay: 'Tipo de Acción',
      regularPlay: 'En Juego',
      setPiece: 'Balón Parado',
      setPiecePlay: 'Balón Parado',
      throwInSetPiecePlay: 'Jugada de saque de banda',
      throwInPlay: 'Jugada de saque de banda',
      gkThrow: 'Saque de Portero',
      gkKick: 'Saque de Puerta',
      kickOff: 'Saque de Inicio',
      actionEnding: 'Tipo de Finalización',
      pass: 'Pase',
      shot: 'Tiro',
      foul: 'Falta',
      other: 'Otro',
      threat: 'Peligro',
      legendSumOfXT: 'Suma de xT',
      legendPass: 'Pase',
      legendShot: 'Tiro',
      legendCarryAndAction: 'Conducción y Acción',
      legendCarryAndPass: 'Conducción y Pase',
      legendOnlyShowing: '· Solo mostrando acciones individuales con xT > ',
      legendOnlyShowingPart1: 'Solo mostrando acciones',
      legendOnlyShowingPart2: 'individuales con xT > ',
      legendOnlyShowingSetPiece: '· Solo mostrando acciones a balón parado con xT > ',
      legendOnlyShowingOpenPlay: '· Solo mostrando acciones en juego con xT > ',
      legendPlays: 'Acciones',
      legendPerPlay: 'por acción',
      legendCarry: 'Conducción',
      penaltyPlay: 'Penalti',
      freeKickTakenPlay: 'Jugada de falta directa',
      cornerTakenPlay: 'Jugada de corner',
      fromCornerPlay: 'Jugada de corner',
      keeperThrowPlay: 'Lanzamiento del portero',
      fastBreakPlay: 'Contrataque',
      indirectPlay: 'Libre Indirecto',
      minutes: 'Minutos',
      games: 'Partidos',
      xT: 'xT',
      xTPer90: 'xT por 90\''
    },
    preGameAnalysis: {
      showExpectations: 'Mostrar Predicciones',
      hideExpectations: 'Ocultar Predicciones',
      goalsPeriods: 'Períodos con Goles',
      synergyIndex: 'Índice de Sinergia',
      synergyIndexSubtitle: 'Fuerza general de la conexión pasador-finalizador'
    },
    gameAnalysis: {
      next: 'Siguiente',
      previous: 'Anterior',
      phaseLabel: 'Fase',
      phasesLabel: 'Fases',
      dot: '. ',
      comma: ', ',
      from: 'Del',
      to: 'Al',
      and: ' y ',
      steps: {
        finishingMapFullGame: 'Mapa Finalización',
        keyPassMapFullGame: 'Mapa Pases Clave',
        gameFlow: 'Control Partido',
        finishingMapPerPhases: 'Finalización Fases',
        keyPassMapPerPhases: 'Pases Clave Fases',
        passMapPerPhases: 'Mapa de Pases Fases'
      },
      step1: {
        table: {
          draw: 'Empate',
          win: 'Victoria',
          lose: 'Derrota',
          possession: 'Posesión',
          xP: 'Puntos Esperados',
          directness: 'Verticalidad',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG en Juego',
          xGSetPiece: 'xG a Balón Parado',
          xA: 'xA',
          xAOpenPlay: 'xA en Juego'
        },
        text: {
          firstParagraph: {
            1: 'El mapa de la derecha muestra los goles esperados generados por el home_team_name y el away_team_name. Los circulos rellenos son remates que han acabado en gol. El tamaño de los círculos depende del valor de xG de cada tiro.'
          },
          lastParagraph: {
            1: 'La probabilidad de victoria y el número de puntos esperados son calculados a partir de los remates (100,000 simulaciones de cada tiro tomando su probabilidad de gol).'
          },
          targetHighTeamXG: {
            1: 'target_team_name, como también rival_team_name, han generado un alto volumen de Goles Esperados'
          },
          targetHighTeamOpenPlayXG: {
            1: 'En este partido, la mayoría de las ocasiones de target_team_name provienen de jugadas'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'En este encuentro, la mayoría de las ocasiones de target_team_name provienen de jugadas (a diferencia de rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'En este partido, la mayoría de las ocasiones de target_team_name han sido generadas a balón parado'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'En este enfrentamiento, la mayoría de las ocasiones de target_team_name han sido generadas a balón parado (a diferencia de rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'En este encuentro, la mayoría de las ocasiones de target_team_name han sido creadas en los saques de esquina'
          },
          targetLowTeamGoalConversion: {
            1: ' pero la conversión de goles fue baja'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name ha creado un alto volumen de goles esperados, tanto en jugadas como a balón parado'
          },
          targetHighTeamGoalConversion: {
            1: ' teniendo también una alta capacidad de convertir esas ocasiones en goles. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', siendo incapaz de marcar alguna de las ocasiones creadas'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' pero creó peligro para marcar más goles'
          },
          targetHighTeamXGvsGameRival: {
            1: 'En este encuentro, target_team_name generó más peligro que rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' y podría haber anotado más goles. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' pero fue incapaz de aprovechar las ocasiones creadas para marcar gol. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' con una oportunidad de ganar de team_winning_chance según nuestra simulación post-partido. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' La mayoría de las oportunidades de target_team_name provienen de jugadas. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' La mayoría de las ocasiones creadas de target_team_name nacen a balón parado. '
          },
          startTargetHighTeamCornerXG: {
            1: ' La mayoría de las ocasiones han sido generadas gracias a los saques de esquina. '
          },
          targetSimilarTeamXG: {
            1: 'Durante este partido, en cuanto a Goles Esperados se refiere, ambos equipos le generaron al rival un xG similar, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'pero target_team_name lo hizó mejor a la hora de finalizar estas ocasiones. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Sin hacer caso al resultado, target_team_name no le generó mucho peligro al rival en cuanto a Goles Esperados se refiere. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name no generó suficiente peligro al rival hablando en términos de Goles Esperados para ganar el encuentro'
          },
          rivalHighTeamXG: {
            1: 'y permitió a rival_team_name generarle demasiado peligro. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Este es un partido que target_team_name ganaría solamente un team_winning_chance de las veces según nuestra simulación post-partido. '
          },
          targetHighTeamGoalConversion2: {
            1: ' teniendo un alto coeficiente de conversión de goles'
          },
          winningChance: {
            1: ' Dado el número de disparos y xG de ambos equipos, target_team_name debería haber ganado este partido team_winning_chance de las veces. '
          },
          highPlayerXGManyShots: {
            1: ' Es interesante observar que player_name generó xg_value xG en shots_value remates'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' necesitando xg_value xG para marcar un gol. '
          },
          highPlayerXGOneGoal: {
            1: ' para marcar el gol. '
          },
          highPlayerXGAnyGoal: {
            1: ', aunque no pudo marcar ningún gol. '
          },
          highPlayerXGNotManyShots: {
            1: 'Es interesante observar que player_name generó xg_value xG en unos pocos remates'
          },
          highManyPlayerXG: {
            1: 'Es interesante observar que el player_name y el player_name2 generaron xg_value y xg_value2 <b>xG</b> respectivamente. '
          },
          highTeamXGPerShot: {
            1: 'En cuanto a la selección de disparos realizados por target_team_name, fueron muy buenos en términos de probabilidad de convertirse en gol, con una media de xG por disparo de xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'La selección de disparos de target_team_name fue mucho mejor que la de rival_team_name, teniendo una media de xg_per_shot_value xG por disparo. '
          },
          xGTimesNotAfter70xG: {
            1: 'A pesar del alto XG generado, target_team_name tuvo problemas para crear peligro al final del partido. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name creó mucho peligro sobre todo al principio de las dos mitades. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name creó mucho peligro sobre todo al final de ambas partes. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name creó la mayor parte del peligro al principio del primer tiempo. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name creó la mayor parte del peligro al final del primer tiempo. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name creó la mayor parte del peligro al principio de la segunda parte. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name creó la mayor parte del peligro al final del segundo tiempo. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name empezó el partido muy fuerte con ocasiones que generaron xg_value <b>goles esperados</b>. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name terminó la primera mitad del partido con ocasiones que generaron xg_value goles esperados. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name salió del descanso con ocasiones que generaron xg_value goles esperados. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name terminó la segunda parte con ocasiones que generaron xg_value goles esperados. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name creó mucho peligro al final del segundo tiempo. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name creó mucho peligro al principio de la segunda parte. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name creó mucho peligro al final del primer tiempo. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name creó mucho peligro al principio del primer tiempo. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name generó la mayor parte de su peligro en la primera mitad, mientras que rival_team_name hizo lo propio en la segunda. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name generó la mayor parte de su peligro en el segundo tiempo mientras que rival_team_name hizo lo mismo en el primer tiempo. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Es un partido en el que la mayor parte del peligro en términos de goles esperados se generó durante la primera mitad. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Es un partido en el que la mayor parte del peligro en términos de goles esperados se generó durante la segunda mitad. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name logró crear la mayor parte del peligro en el primer tiempo. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name consiguió crear la mayor parte del peligro durante la segunda parte. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name permitió la mayor parte del peligro en términos de goles esperados en la primera mitad. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name permitió la mayor parte del peligro en términos de goles esperados durante la segunda mitad. '
          },
          highInBoxXG: {
            1: ' Podemos ver en el mapa de disparos cómo la mayor parte del peligro vino de disparos dentro del área. '
          },
          highOutOfBoxXG: {
            1: 'Podemos ver en el mapa de disparos que, en este partido, target_team_name generó mucho peligro desde fuera del área. '
          },
          highInBoxXGRival: {
            1: 'Queremos señalar que la mayor parte del peligro concedido por target_team_name provino de disparos dentro del área. '
          },
          highInBoxXGRival2: {
            1: ' También es interesante señalar que la mayor parte del peligro concedido por target_team_name provino de disparos dentro del área. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name lo hizo bien al evitar el peligro dentro del área. '
          },
          highTeamChancesHighPPDARival: {
            1: 'La falta de presión de target_team_name, permitiendo ppda_value pases por acción defensiva, fue una de las claves para que rival_team_name creara un alto número de ocasiones. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name sólo permitió ppda_value pases por acción defensiva siendo ésta una de las claves de la victoria. '
          },
          lowPPDA: {
            1: 'target_team_name hizo un gran trabajo interrumpiendo las jugadas de rival_team_name permitiendo sólo una media de ppda_value pases por acción defensiva. '
          },
          highPossession: {
            1: 'target_team_name tenía el control del balón con un possession_value de posesión'
          },
          highPPDARival: {
            1: ' así como una distribución fluida del balón'
          },
          chancesCreated: {
            1: ', lo que les permitió tener un alto número de oportunidades de juego abierto (chances_value). '
          },
          chancesCreatedRival: {
            1: ', aunque rival_team_name fue capaz de crear un gran número de ocasiones de juego abierto (chances_value). '
          },
          xGPerShotRival: {
            1: ', aunque rival_team_name fue capaz de crear más ocasiones de peligro con un valor xg_per_shot_value <b>xG por tiro</b>. '
          },
          winGame: {
            1: ' siendo una de las claves para ganar el juego. '
          },
          notEnoughWinGame: {
            1: ' no siendo suficiente para ganar el juego. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'El primer gol vino de un error de player_error_name aprovechado por player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'El primer y único gol vino de un error de player_error_name aprovechado por player_name'
          },
          lastPhaseOfGame: {
            1: ' en la última fase del juego. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'El gol final para ganar el partido vino de un error del player_error_name que llevó al gol de player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'El gol final para empatar el partido vino de un error del player_error_name que llevó al gol de player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Un error del player_error_name llevó a una oportunidad de empatar el partido para target_team_name'
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name se adelantó aprovechando un error de player_error_name'
          },
          xGChance: {
            1: ' con una posibilidad de xg_value <b>xG</b>. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'El gol final de rival_team_name para ganar el partido vino de un error de player_error_name que llevó al gol de player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Un error del player_error_name llevó a una oportunidad de empatar el partido para rival_team_name'
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name se adelantó aprovechando un error de player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name marcó la única gran ocasión que se creó durante el partido, es decir, el gol de player_name que vemos en el mapa Goles Esperados con un <b>xG</b> de xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name pasó a marcar todas las grandes ocasiones que creó durante el partido'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name tuvo la única gran ocasión de gol de target_team_name con un <b>xG</b> de xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name no fue capaz de marcar ninguna de las chances_value ocasiones por encima del 40% de probabilidad de convertirse en gol. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name tuvo una gran oportunidad de xg_value <b>xG</b> para adelantarse en el marcador. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name tuvo chances_value ocasiones con <b>xG</b> superior al 40% para adelantarse en el marcador. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name tuvo chances_value ocasiones con alto <b>xG</b> para adelantarse en el marcador. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name tuvo una oportunidad de adelantarse en el marcador de xg_value <b>xG</b> que dio en el poste. '
          },
          beforeEndOfGame: {
            1: 'Antes de finalizar el partido, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name tuvo una oportunidad de xg_value <b>xG</b> para llevarse el partido. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name tuvo chances_value ocasiones con una probabilidad de gol superior al 40% para hacerse con los 3 puntos. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name tuvo chances_value ocasiones con un alto <b>xG</b> para ganar el partido. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name difrutó de una gran ocasión de xg_value <b>xG</b> para poner por delante a su equipo. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name tuvo chances_value oportunidades con un <b>xG</b> por encima del <b>40%</b> para poder adelantarse en el partido. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name disfrutó chances_value ocasiones con alto xG para adelantarse en el marcador. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name disfrutó de una ocasión con un xg_value <b>xG</b> para adelantar a su equipo en el marcador pero estrelló el balón en el poste. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name tuvo una oportunidad de xg_value <b>xG</b> para empatar el partido pero no tuvo suerte. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name tuvo chances_value oportunidades para empatar el encuentro con una probabilidad de anotar gol por encima del 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name tuvo una ocasión de xg_value <b>xG</b> para empatar el partido pero estrelló el esférico contra el poste. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Empate',
          win: 'Victoria',
          possession: 'Posesisón',
          xP: 'Puntos Esperados',
          directness: 'Verticalidad',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA en Juego',
          xASetPiece: 'xA a Balón Parado',
          chancesCreated: 'Ocasiones Creadas',
          shotsOnTarget: 'Remates a Puerta'
        },
        text: {
          firstParagraph: {
            1: 'La imagen muestra las <b>Asistencias Esperadas</b> de <b>home_team_name</b> y <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA por cada Pase Clave. '
          },
          keyPassesGeneratedFrom: {
            1: ', especialmente pases claves generados desde '
          },
          highTeamXAvsXG: {
            1: 'Como podemos ver en el mapa de xA, la mayoría del peligro creado por target_team_name proviene de jugadas combinadas más que de acciones individuales'
          },
          openPlay: {
            1: 'en juego'
          },
          setPiece: {
            1: 'a balón parado'
          },
          cornerKicks: {
            1: 'en saques de esquina'
          },
          combinationPlays: {
            1: 'jugadas combinadas'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'En este partido, target_team_name creó peligro tanto en jugadas combinadas'
          },
          individualActions: {
            1: ' como en acciones individuales.'
          },
          dangerFromIndividualActions: {
            1: 'En este encuentro, la mayoría del peligro generado por target_team_name nace de jugadas individuales.'
          },
          highTeamXAvsXGRival: {
            1: ' Las oportunidades que target_team_name concedió durante el partido provienen de jugadas combinadas, tal como podemos apreciar en el mapa de xA.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name se mostró fuerte en pases claves generados '
          },
          manyPlayerKeyPasses: {
            1: 'Es interesante anotar que <b>player_name</b> generó <b>xa_value xA</b> en <b>key_passes pases clave</b>'
          },
          playerAssists: {
            1: ' necesitando <b>xa_per_assist xA per assist</b>.'
          },
          giveAssist: {
            1: ' para dar la asistencia.'
          },
          noAssists: {
            1: ', aunque ninguno de sus pases acabó siendo una asistencia.'
          },
          highXANotManyShots: {
            1: 'Es interesante anotar que <b>player_name</b> created <b>xa_value xA</b> en pocos pases'
          },
          manyPlayersHighXA: {
            1: 'Es interesante anotar que <b>player_name</b> y <b>player_name2</b> generaron <b>xa_value</b> y <b>xa_value2 xA</b> respectivamente.'
          },
          xATimes: {
            1: 'target_team_name creó la mayoría de su peligro en la primera parte mientras que rival_team_name hizo lo mismo en la '
          },
          firstHalf: {
            1: ' primer parte.'
          },
          secondHalf: {
            1: ' segunda parte.'
          },
          left: {
            1: 'lado izquierdo '
          },
          center: {
            1: 'centro '
          },
          right: {
            1: 'lado derecho '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Es un encuentro donde la gran parte del peligro, en cuanto a Goles Esperados se refiere, fue generado durante la '
          },
          xAFirstHalf: {
            1: 'target_team_name ocasionó la mayoría de su peligro en la '
          },
          xATimesXARival: {
            1: 'target_team_name concedió demasiado peligro en términos de Goles Esperados en la '
          },
          xASides: {
            1: ' La mayoría del peligro generado por target_team_name fue producido desde el side_name (<b>xa_value xA</b>)'
          },
          xASidesRival: {
            1: 'mientras rival_team_name generó la mayoría desde el side_name (<b>xa_value xA</b>)'
          },
          dangerCreationRival: {
            1: 'La creación de peligro de rival_team_name viene, especialmente, desde el side_name (<b>xa_value xA</b>).'
          },
          speciallyEffective: {
            1: 'target_team_name fue especialmente efectivo en '
          },
          xAPerChanceCreated: {
            1: ' con un promedio de <b>xa_value xA</b>'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name fue especialmente efectivo en '
          }
        }
      },
      step3: {
        text: {
          chance: ' ocasión',
          chances: ' ocasiones',
          goal: ' gol',
          goals: ' goles',
          home: 'local',
          away: 'visitante',
          last: 'última',
          first: 'primera',
          goalScorer: 'quien marcó el gol',
          goalScorers: 'quienes marcaron los goles',
          lastPhase: 'En la recta final del partido, ',
          phase: {
            1: 'En esta phase_position fase del partido, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> ha generado más peligro (<b style=\'color:more_color\'>more_xt_team_value xT</b>) que <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'y lo ha hecho durante más minutos de juego (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> frente a <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> de su rival)'
          },
          rivalTeamMoreMinutes: {
            1: 'sin embargo, fue el oponente el que generó peligro durante más tiempo (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> del rival) en este periodo del partido'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> fue el equipo que generó más peligro (<b style=\'color:max_color\'>max_xt_team_value xT</b>) en <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', mientras que <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> generó su máximo peligro (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) en <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Ambos equipos consiguieron batir la portería rival con <b>number_of_goals_each_team</b> cada uno. El equipo local a través de <b style=\'color:#3366FF\'>home_player_name_goals</b> y el equipo visitante a través de <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'En términos de goles, <b style=\'color:replace_color\'>goal_scored_team_name</b> derrotó al rival por <b style=\'color:replace_color\'>difference_number_of_goals</b> de diferencia, siendo <b style=\'color:replace_color\'>home_player_name_goals</b> goal_scorer_word del equipo'
          }
        }
      },
      step4: {
        table: {
          team: 'Equipo',
          period: 'Periodo',
          possession: 'Pos.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OP',
          tooltip: {
            team: 'Equipo',
            period: 'Periodo',
            possession: 'Posesión',
            ppda: 'pases por acción defensiva',
            xGOpenPlay: 'xG en Juego'
          }
        },
        text: {
          clearly: 'claramente',
          very: 'muy ',
          haveGotText1: 'únicamente consiguió',
          haveGotText2: 'debería haber conseguido más de',
          gaveUpPoss: 'cedió la posesión',
          lostPoss: 'perdió la posesión de la pelota',
          too: 'también ',
          possession: {
            1: 'Durante esta fase del partido, <b style=\'color:team_color\'>team_name</b> clearly_text controló la posesión del balón'
          },
          equalPossession: {
            1: 'En este tramo del partido, ningún equipo dominó al otro ya que el manejo del balón ha estado bastante equilibrado, aunque fijándonos en los números, <b style=\'color:team_color\'>team_name</b> ha superado ligeramente a su rival con un <b style=\'color:team_color\'>possession_value%</b> de posesión'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> con una mala presión permitió al <b style=\'color:rival_team_color\'>rival_team_name</b> dar <b style=\'color:target_team_color\'>ppda_value pases por acción defensiva</b>'
          },
          lowPossessionLowPPDA: {
            1: ', pero <b style=\'color:target_team_color\'>target_team_name</b> presionó bien la pelota cuando rival_team_name tuvo la posesión, con un <b>PPDA</b> de <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' y fue capaz de jugar debido a very_textbaja intensidad en la presión del rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ' aunque la intensidad en la presión del rival_team_name fue very_textalta'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> se apoderó de una alta posesión dando <b>pft_value</b> <b>Pases en el Último Tercio del Campo</b> del campo. '
          },
          highPossessionMidLowPFT: {
            1: 'Independientemente de la alta posesión, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Pases en el Último Tercio del Campo</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Aunque <b style=\'color:target_team_color\'>target_team_name</b> possession_text durante esta fase, fue capaz de dar <b>pft_value</b> <b>Pases en el Último Tercio del Campo</b>. '
          },
          midPossessionHighPFT: {
            1: 'Una posesión bastante igualada durante esta fase no impidió que <b style=\'color:target_team_color\'>target_team_name</b> diera <b>pft_value</b> <b>Pases en el Último Tercio del Campo</b>. '
          },
          highPFTHighTouchesIOB: {
            1: 'Además de controlar el juego en el último tercio, <b style=\'color:target_team_color\'>target_team_name</b> también tuvo mucha presencia en el área rival'
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> controló el balón en el último tercio, pero no pudo introducir muchos balones en el área rival'
          },
          highPFTMidTouchesIOB: {
            1: 'Dado el número de <b>Pases en el Último Tercio del Campo</b>, <b style=\'color:target_team_color\'>target_team_name</b> debería haber creado más peligro en el área rival'
          },
          lowPFTHighTouchesIOB: {
            1: 'Aunque <b style=\'color:target_team_color\'>target_team_name</b> no completó muchos pases en el último tercio, fue capaz de llegar al área rival en múltiples ocasiones. '
          },
          midPFTHighTouchesIOB: {
            1: 'Dado el número de pases completados en el último tercio, <b style=\'color:target_team_color\'>target_team_name</b> fue capaz de llegar al área rival en múltiples ocasiones. '
          },
          maxDirectness: {
            1: 'Cabe destacar que esta es la fase del juego en la que <b style=\'color:max_dir_color\'>target_team_name</b> jugaba más ofensivamente con una <b>Verticalidad</b> de <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> fue capaz de generar más xG que en otra fase del partido. '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> consiguió generar un volumen alto de Goles Esperados'
          },
          highXG: {
            1: 'generó un buen volumen de Goles Esperados'
          },
          highXGLowPossession: {
            1: ' a pesar de no tener el control de la pelota'
          },
          highXGLowShots: {
            1: ' sólo en unos pocos remates, teniendo un <b>xG por Tiro</b> de <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' aunque el xG por Tiro fue too_textbajo. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> no fue capaz de generar peligro al rival'
          },
          lowXGMinXG: {
            1: 'En términos de generación de Goles Esperados, ésta fue una etapa pobre para <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> generó un volumen muy pequeño de Goles Esperados'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> no fue capaz de generar un buen volumen de Goles Esperados'
          },
          lowXGHighPossession: {
            1: ' aunque ellos tuvieron el control de la pelota. '
          },
          lowXGHighShots: {
            1: ' a pesar de disparar múltiples remates'
          },
          lowXGHighPFT: {
            1: ' a pesar de completar <b>pft_value</b> <b>Pases en el Último Tercio del Campo</b>. '
          },
          midXGQuintileMinXG: {
            1: 'Aunque la generación de xG no fue mala, ésta fue la etapa más débil del partido para <b style=\'color:target_team_color\'>target_team_name</b> en ese apartado'
          },
          midXGQuintileMaxXG: {
            1: 'Esta fue la fase durante la cual <b style=\'color:target_team_color\'>target_team_name</b> fue capaz de generar el máximo <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Team',
          period: 'Period',
          possession: 'Poss.',
          directness: 'Vert.',
          passesFinalThird: 'PF ⅓',
          tooltip: {
            team: 'Team',
            period: 'Period',
            possession: 'Possession',
            directness: 'Verticalidad',
            passesFinalThird: 'Passing Final Third'
          }
        },
        text: {
          last: 'última',
          goal: 'gol',
          goals: 'goles',
          chance: 'ocasión',
          chances: 'ocasiones',
          first: 'primera',
          homeTeam: 'equipo local',
          awayTeam: 'equipo visitante',
          home: 'local',
          away: 'visitante',
          clearly: 'claramente',
          slightly: 'ligeramente',
          firstOrLastPhase: {
            1: 'En esta phase_position fase del encuentro, ',
            2: 'En cuanto a la phase_position fase del partido, '
          },
          phase: {
            1: 'Durante este tramo del partido, '
          },
          bothZeroGoalsScored: {
            1: 'sin lograr modificar el marcador ninguno de los dos equipos.'
          },
          equalGoalsScored: {
            1: 'consiguiendo marcar <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'consiguiendo marcar'
          },
          equalPossesion: {
            1: 'ambos equipos han tenido el balón exactamente un <b>poss_value%</b> del tiempo'
          },
          morePossesion: {
            1: '<b>more_poss_team_name</b> tuvo el esférico durante más minutos (<b>more_poss_team_value%</b> del tiempo) que su oponente (<b>less_poss_team_value%</b> del tiempo)'
          },
          equalDirectness: {
            1: 'los dos equipos han desarrollado un juego con la misma verticalidad (<b>directness_value</b> cada uno)'
          },
          moreDirectnessSameTeam: {
            1: 'además también han sido más verticales que su adversario, desarrollando un juego con una verticalidad de <b>more_dir_team_value</b> frente a <b>less_dir_team_value</b>.'
          },
          moreDirectnessDifferentTeam: {
            1: 'sin embargo, ha sido el equipo home_away quien ha jugado de manera más vertical (<b>more_dir_team_value</b>) frente a <b>less_dir_team_value</b>.'
          },
          equalChancesCreated: {
            1: 'Tanto locales como visitantes han creado el mismo número de ocasiones, concretamente <b>chances_created_value</b> ocasiones.'
          },
          moreChancesCreated: {
            1: '<b>less_cc_team_name</b> ha creado tan solo <b>less_cc_team_value ocasiones</b> por lo que se ha visto superado adverb_text por su adversario (<b>more_cc_team_value ocasiones creadas</b>). '
          },
          equalXA: {
            1: 'Tanto locales como visitantes han dispuesto de las mismas oportunidades, así lo refleja el <b>xa_value de Asistencias Esperadas</b>, '
          },
          moreXA: {
            1: 'home_away han generado <b>diff_xa_team_value Asistencias Esperadas</b> (<b>more_xa_team_value</b> frente a <b>less_xa_team_value</b>) más que su oponente, '
          },
          xAOpenPlay: {
            1: 'generando, respectivamente, <b>more_xa_op_value</b> y <b>less_xa_op_value</b> con el balón en juego.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' cada uno ',
          respectively: ', respectivamente',
          with: ' (junto con <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'quien fue',
          playerWere: 'quienes fueron',
          firstPhase: {
            1: 'En este primer tramo del partido, resaltar a ',
            2: 'Respecto a la primera parte del encuentro, cabe destacar a '
          },
          otherPhase: {
            1: 'Entre el <b style=\'color:replace_color\'>min_from\'</b> y el <b style=\'color:replace_color\'>min_to\'</b> hay que mencionar a '
          },
          lastPhase: {
            1: 'En el último tramo del encuentro, mencionar a ',
            2: 'En cuanto a la última fase del partido, citar a '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b> con el mayor número de pases satisfactorios de su equipo, concretamente <b style=\'color:replace_color\'>successfull_passes_value pases</b> '
          },
          playerMaxTotalPasses: {
            1: 'lo cual cobra aún más valor al ver que ha sido también'
          },
          playerMaxTotalPasses2: {
            1: 'with_text quien más pases ha intentado (<b style=\'color:replace_color\'>total_passes_value pases</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'aunque no ha sido quien más pases ha intentado (<b style=\'color:replace_color\'>player_name</b> con <b style=\'color:replace_color\'>total_passes_value pases</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'intentando durante este periodo <b style=\'color:replace_color\'>total_passes_value pases</b> cada cual. '
          },
          playerMaxPctPasses: {
            1: 'En cuanto al <b style=\'color:replace_color\'>% de Pases Completados</b> destacar a <b style=\'color:replace_color\'>player_name</b> con un alto <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'En referencia al porcentaje de éxito de los pases, hay que mencionar a <b style=\'color:replace_color\'>player_name</b> con un <b style=\'color:replace_color\'>max_pct_passes_value%</b> de efectividad en sus pases. '
          },
          playerSumTotalXG: {
            1: 'En este tramo, el equipo ha generado un total de <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Durante este periodo, el <b style=\'color:replace_color\'>team_name</b> ha creado un <b style=\'color:replace_color\'>xG</b> de <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'A pesar de realizar un total de <b style=\'color:replace_color\'>all_team_total_passes pases</b> entre todo el equipo, ha sido en vano ya que no ha conseguido crear ni una ocasión. ',
            2: 'Los <b style=\'color:replace_color\'>all_team_total_passes pases</b> realizados en este periodo no han servido para nada ya que no han generado ni una sola oportunidad de gol. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'siendo <b style=\'color:replace_color\'>player_xg_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> y <b style=\'color:replace_color\'>player_xa_name</b> con <b style=\'color:replace_color\'>xa_value xA</b> las figuras más destacadas en cuanto a creación de ocasiones se refiere. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'siendo <b style=\'color:replace_color\'>player_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> y <b style=\'color:replace_color\'>xa_value xA</b> quien estuvo en el origen de gran parte de las ocasiones creadas de su equipo. '
          },
          playersMaxXGMaxXA: {
            1: 'gracias entre otros a <b style=\'color:replace_color\'>players_name</b> que han provocado <b style=\'color:replace_color\'>xa_value xA</b> cada cual con sus pases clave. '
          },
          playerMaxXGZeroXA: {
            1: 'siendo <b style=\'color:replace_color\'>player_xg_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> quien ha tenido todo el peso de las ocasiones, teniendo que crearlas por su cuenta ya que no ha recibido ningún pase clave. '
          },
          playersMaxXGZeroXA: {
            1: 'siendo <b style=\'color:replace_color\'>player_xg_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> quienes han tenido todo el peso de las ocasiones, teniendo que crearlas por su cuenta ya que no han recibido ningún pase clave. '
          },
          oneMaxConnections: {
            1: 'La pareja que más pases ha efectuado entre ellos durante este tramo del partido ha sido la formada por <b style=\'color:replace_color\'>couple_name</b>, con un total de <b style=\'color:replace_color\'>connections_value pases</b>. ',
            2: 'El dúo formado por <b style=\'color:replace_color\'>couple_name</b> se han intercambiado <b style=\'color:replace_color\'>connections_value</b> veces el esférico. ',
            3: 'La dupla <b style=\'color:replace_color\'>couple_name</b> ha sido quienes más se han pasado la pelota en este tramo de partido, haciéndolo hasta en <b style=\'color:replace_color\'>connections_value</b> ocasiones. '
          },
          twoMaxConnections: {
            1: 'Las dos parejas formadas por <b style=\'color:replace_color\'>couple_name</b> y <b style=\'color:replace_color\'>couple_name2</b> han sido las conexiones más repetidas para este período, pasándose el balón hasta en <b style=\'color:replace_color\'>connections_value</b> ocasiones. '
          },
          moreThanTwoMaxConnections: {
            1: 'Varias parejas de jugadores, como por ejemplo <b style=\'color:replace_color\'>couple_name</b>, han realizado hasta <b style=\'color:replace_color\'>connections_value pases</b> entre ellos. '
          },
          oneMinConnections: {
            1: 'Por el contrario, han sido <b style=\'color:replace_color\'>couple_name</b> quienes menos se han pasado el balón entre ellos, solamente <b style=\'color:replace_color\'>connections_value pases</b>. ',
            2: 'En el otro extremo tenemos al tándem compuesto por <b style=\'color:replace_color\'>couple_name</b> que tan solo han conectado <b style=\'color:replace_color\'>connections_value</b> veces. '
          },
          twoMinConnections: {
            1: 'Por otro lado, decir que <b style=\'color:replace_color\'>couple_name</b> y <b style=\'color:replace_color\'>couple_name2</b> apenas han intercambiado pases entre ellos (<b style=\'color:replace_color\'>connections_value pases</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Varias han sido las combinaciones que no han conectado lo suficiente, como es el caso entre otros del dúo <b style=\'color:replace_color\'>couple_name</b> que con <b style=\'color:replace_color\'>connections_value pases</b> son de las combinaciones menos comunes.'
          }
        }
      },
      step7: {
        ballPossession: 'Posesión de Balón',
        gamePossessionDist: 'Distribución de Posesión de Balón'
      }
    },
    gamePossessionMap: {
      of: 'de',
      to: 'a',
      and: 'y',
      endsWith: 'Termina con',
      time: 'Tiempo',
      touches: 'Toques',
      passes: 'Pases',
      threat: 'Peligro',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minutos',
      duration: 'Duración',
      endsGoal: 'Acaba en Gol',
      endsInBox: 'Termina en el Área',
      with: 'con',
      withShot: 'Con Tiro',
      withCross: 'Con Centro',
      possession: 'Posesión',
      events: 'Eventos',
      filters: 'Filtros',
      filtersWarning: 'Peligro solo aplica a posesiones sin remates',
      sumWarning: 'El filtro aplica a la suma de xG de todos los remates de la secuencia, por eso puede ser mayor de 1',
      show: 'Mostrar',
      sequenceNumbers: 'Número de Secuencia',
      jerseyNumbers: 'Dorsales',
      pass: 'Pase',
      carryAndPass: 'Conducción y Pase',
      carryAndAction: 'Conducción y Acción',
      carryAndShot: 'Conducción y Tiro',
      shotFailed: 'Tiro Fallado',
      goal: 'Gol',
      savedShot: 'Tiro Parado',
      missedShot: 'Tiro Fallado',
      shotOnPost: 'Tiro al Poste',
      headerGoal: 'Gol de Cabeza',
      headerFailed: 'Remate de Cabeza Fallado',
      failed: 'fallado'
    },
    report: {
      title: 'Informe de Partido',
      pDReportTitle: 'Informe Físico de Partido',
      maps: 'Mapas',
      xGRace: 'xG Gráfico',
      lineups: 'Alineaciones',
      button: 'Genera un informe completo en PDF del partido',
      mobileButton: 'Informe PDF',
      mobileButtonXY: 'Informe XY',
      mobileButtonPD: 'Informe PD',
      most: 'Más',
      topXPlayers: 'Top {x} Jugadores'
    }
  },
  general: {
    1: 'Uno',
    2: 'Dos',
    3: 'Tres',
    4: 'Cuatro',
    5: 'Cinco',
    create: 'Crear',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    reset: 'Reiniciar',
    go: 'Ir',
    formErrors: {
      required: 'El campo es obligatorio',
      passwordMatch: 'La contraseña no coincide',
      minLength: 'No alcanza el mínimo de carácteres',
      maxLength: 'Máxima longitud',
      emailValid: 'Debe ser una dirreción de correo válida',
      youthAge: 'La edad debe estar entre 10 y 23',
      seasonYear: 'El año debe estar entre 2016 y 2050',
      integer: 'No se permiten números decimales'
    },
    confirmationTitle: '¿Está seguro?',
    confirmationMessage: 'Confirme si desea realizar la acción',
    yes: 'Sí',
    no: 'No',
    search: 'Buscar',
    clearFilters: 'Limpiar filtros',
    minimum: 'Mínimo',
    maximum: 'Máximo',
    minimumPercent: 'Porcentaje (%)mínimo',
    period: 'Periodo',
    exclude: 'Excluir',
    team: 'Equipo',
    currentTeam: 'Equipo Actual',
    clear: 'Limpiar',
    all: 'Todo',
    ground1: 'Todo',
    ground2: 'Casa',
    ground3: 'Fuera',
    filter: 'Filtrar',
    noData: 'No se encontraron resultados',
    noDataGivenFilters: 'No se encontraron resultados para los filtros seleccionados',
    similarityMinutesWarning: 'Sin datos porque hay menos de 450 minutos jugados',
    templateOnlyEditable: 'Plantilla solo editable por ',
    close: 'Cerrar',
    load: 'Cargar',
    filters: 'Filtros',
    players: 'jugadores',
    teams: 'teams',
    compare: 'Comparar',
    seeMore: 'Ver más',
    seeLess: 'Ocultar',
    request: 'Solicitar',
    notes: 'Notas',
    closeSession: 'Cerrar sesión',
    settings: 'Configuración',
    player: 'Jugador',
    state: 'Estado',
    updated: 'Actualizado',
    file: 'Archivo',
    uploadFile: 'Subir archivo',
    reports: 'Informes',
    download: 'Descargar',
    new: 'Nuevo',
    comparison: 'Comparación',
    scout: 'Búsqueda',
    favorites: 'Favoritos',
    moreOptions: 'Más opciones',
    lessOptions: 'Menos opciones',
    today: 'Hoy',
    home: 'Casa',
    away: 'Fuera',
    until: 'hasta',
    firstHalf: '1º tiempo',
    secondHalf: '2º tiempo',
    firstPeriodOT: 'Prórroga 1ºP',
    secondPeriodOT: 'Prórroga 2ºP',
    postponed: 'Aplazado',
    stats: 'Estadísticas',
    yesterday: 'Ayer',
    last: 'Último',
    startDate: 'Fecha inicio',
    active: 'Activo',
    playerLimit: 'Límite de Jugadores',
    type: 'Tipo',
    successMessage: 'Operación realizada con éxito',
    failMessage: 'La operación ha fallado',
    by: 'Por',
    checkYourInbox: 'Revisa tu correo',
    faq: 'Documentación',
    globalSearch: 'Búsqueda global',
    gamesLost: 'Partidos perdidos',
    outOf: 'de',
    avgSeason: 'Media de la temporada',
    leftDays: 'días restantes',
    notifyError: 'Notificar error',
    notify: 'Notificar',
    comments: 'Comentarios',
    searches: 'Búsquedas',
    now: 'Ahora',
    twoHoursAgo: 'Hace dos horas',
    incomings: 'Llegadas',
    departures: 'Salidas',
    transferLoans: 'Cesiones',
    transfers: 'Trasferencias',
    movements: 'Movimientos',
    incomes: 'Ingresos',
    expenditures: 'Gastos',
    action: 'Acción',
    target: 'Objetivo',
    uses: 'Usos',
    users: 'Usuarios',
    since: 'desde',
    mediaMode: 'Modo media',
    white: 'Blanco',
    enabled: 'Activado',
    disabled: 'Desactivado',
    left: 'Izquierda',
    right: 'Derecha',
    both: 'Ambas',
    'left-both': 'Izquierda Ambas',
    'right-both': 'Derecha Ambas',
    'left foot': 'Izquierda',
    'right foot': 'Derecha',
    8: 'Izquierdo',
    9: 'Ambos',
    10: 'Derecho',
    files: 'Archivos',
    confirm: 'Confirmar',
    currentStep: 'Paso Actual',
    phases: 'Fases',
    entries: 'Entradas',
    none: 'Ninguno',
    times: 'veces',
    darkMode: 'Modo noche',
    client: 'Cliente',
    visits: 'Visitas',
    lastVisit: 'Última visita',
    strong: 'Fuerte',
    medium: 'Normal',
    weak: 'Débil',
    goal: 'Portería',
    list: 'Lista',
    map: 'Mapa',
    copiedToClipboard: 'Copiado al portapapeles',
    division: 'División',
    many: 'Más',
    few: 'Menos',
    median: 'Mediana',
    topRight: 'Arriba derecha',
    topLeft: 'Arriba izquierda',
    bottomRight: 'Abajo derecha',
    bottomLeft: 'Abajo izquierda',
    library: 'Biblioteca',
    mediaLibrary: 'Biblioteca de medios',
    for: 'Durante',
    stat: 'Estadística',
    position: 'Posición',
    order: 'Orden',
    add: 'Añadir',
    visualization: 'Visualización',
    orientation: 'Orientación',
    basic: 'Básica',
    selectAll: 'Marcar Todos',
    unselectAll: 'Desmarcar Todos',
    distribution: 'Distribución',
    end: 'Final',
    accuracy: 'precisión',
    opponent: 'Oponente',
    ownTeam: 'Equipo Propio',
    center: 'Centro',
    line: 'Línea',
    live: 'Directo',
    unavailable: 'no disponible',
    calendar: 'Calendario',
    activeLeague: 'Liga activa (en curso)',
    similarity: 'Similares',
    emptyForSelectAll: 'Vaciar selecciona todo',
    size: 'Tamaño',
    selectPlayersRestriction: 'Selecciona entre 1 y {x} jugadores',
    group: 'Grupo',
    alerts: 'Alertas',
    shortcuts: 'Atajos',
    share: 'Compartir',
    dataAvailable: 'Los datos estarán disponibles pronto',
    someStatsAvailableSoon: 'Algunas estadísticas estarán disponibles pronto',
    monthGamesWarning: 'Los partidos del mes seleccionado estarán disponibles pronto',
    metrics: 'Métricas',
    competition: 'Competición',
    code: 'Código',
    alias: 'Alias',
    never: 'Nunca',
    unlimited: 'Ilimitado',
    user: 'Usuario',
    warning: 'Aviso',
    requests: 'Solicitudes',
    contactSales: 'Contactar con ventas',
    comingSoon: '¡Próximamente!',
    firstPost: '1º Palo',
    secondPost: '2º Palo',
    dZone: 'Frontal',
    penaltySpot: 'Punto Penalti',
    secondPlay: '2ª Jugada',
    otherZone: 'Otra Zona',
    baseline: 'Línea de Fondo',
    youth: 'Juvenil',
    male: 'Masculino',
    direct: 'Directo',
    indirect: 'Indirecto',
    processing: 'Procesando',
    addNew: 'Añadir Nuevo',
    createdBy: 'Creado por',
    downloading: 'Descargando',
    displayType: 'Tipo de presentación',
    alreadyExists: 'ya existe',
    aggregation: 'Agregado',
    unavailableLeagues: 'No tienes acceso a ninguna de las ligas en las que ha jugado el jugador',
    meters: 'Metros',
    quantity: 'Cantidad',
    allTime: 'Todos los tiempos',
    games: 'Partidos',
    unit: 'Unidad',
    categories: 'Categorías',
    maintenanceWarning: 'Mantenimiento en curso',
    maintenanceMessage: 'Estamos haciendo algunas actualizaciones. Los cambios que hagas ahora no se guardarán. ¡Gracias por tu paciencia!',
    seeAll: 'Ver Todo',
    from: 'De',
    to: 'a',
    showFilters: 'Mostrar filtros',
    hideFilters: 'Ocultar filtros',
    horizontal: 'Horizontal',
    vertical: 'Vertical',
    sideBySide: "Frente a Frente",
    goalProbability: 'Probabilidad Gol',
    assistProbability: 'Probabilidad Asistencia',
    attackingDirection: 'Dirección de Ataque',
    fieldLayout: 'Distribución del campo',
    searchPlaceholder: 'Escribe al menos {x} letras para buscar',
  },
  playerScout: {
    dlabDatabase: 'Base de datos Driblab',
    warningRegularSeason: 'Mostrando solo la última liga regular',
    league: 'Liga',
    top5: 'Top 5',
    topCountries: 'Países',
    tier: 'Nivel',
    division1: 'Primera división',
    division2: 'Segunda división',
    division3: 'Tercera división',
    division4: 'Cuarta división',
    division5: 'Quinta división',
    division6: 'Sexta División',
    summary: 'Resumen',
    offensive: 'Of',
    defensive: 'Def',
    gk: 'GK',
    all: 'Todo',
    physical: 'Físico',
    arrigo: 'Arrigo',
    yearTooltip: 'Solo se permite un año',
    expectedThreat: 'Peligro Esperado',
    expectedThreatTooltip: 'Peligro añadido a todas las posesiones',
    expectedThreatOP: 'Peligro Esperado OP',
    expectedThreatOPTooltip: 'Peligro añadido a todas las posesiones en jugada',
    expectedThreatInTeam: '% Peligro Esperado en Equipo',
    expectedThreatInTeamTooltip: 'Pct. de Peligro añadido al equipo',
    ballProgression: 'Progresions de Balón',
    ballProgressionTooltip: 'Progresiones de más de 10 metros',
    deepProgression: 'Profundidad',
    deepProgressionTooltip: 'Progresiones de Balón al último quinto',
    ballRetention: '% Retención de Balón',
    ballRetentionTooltip: 'Pct. de las veces que tienes la posesión de balón y no la terminas perdiendo',
    ballRetentionOppHalf: '% Retención de Balón CC',
    ballRetentionOppHalfExplicit: 'Pct. de las veces que tienes la posesión de balón y no la terminas perdiendo dentro del campo rival',
    finishing: 'Finalización',
    finishingTooltip: 'Pct. de Remates que acaban en Gol',
    scoringContribution: 'Contribución Goleadora',
    scoringContributionTooltip: 'Asistencias + Goles',
    xgPerShot: 'xG por Tiro',
    xgPerGoal: 'xG por Gol',
    headerPerCross: 'Remates de Cabeza por Centro',
    completedCrosses: 'Centros Completados',
    crossingPct: 'Centros %',
    crossingEfficiency: 'Eficiencia Centros',
    crossingEfficiencyTooltip: 'Eficiencia en Centros (Mide Calidad y Cantidad)',
    longBalls: 'Pases Largos',
    longPassing: 'Pases Largos %',
    dribblingPct: 'Regates %',
    throughBalls: 'Pases al Hueco',
    oppBoxTouches: 'Toques en Área Rival',
    oppBoxTouchesTooltip: 'Touches in Opponent Box',
    openPlayKeyPasses: 'Pases Clave en Jugada',
    openPlayKeyPassesTooltip: 'Open Play Passes ending in Shot',
    xGBuildup: 'Construcción xG',
    xGBuildupTooltip: 'xG de secuencias acabadas en tiro en las que participó el jugador (excluyendo xG del tiro y pase)',
    Assists: 'Asistencias',
    passPercentage: '% de Pase',
    passPerLongBall: 'Pases por BL',
    passPerLongBallExplicit: 'Pases por cada Balón Largo',
    nonPenaltyGoals: 'Goles sin penaltis',
    xG: 'xG',
    xGExplicit: 'Goles Esperados',
    shots: 'Remates',
    xGShot: 'xG por Tiro',
    xGChain: 'Participación xG',
    xGChainTooltip: 'xG de secuencias acabadas en tiro en las que participó el jugador',
    chancesCreated: 'Ocasiones creadas',
    chances: 'Ocasiones',
    dribbles: 'Regates',
    dribblesSuccessfull: 'Regates con éxito',
    touches: 'Toques en el área contraria',
    xA: 'xA',
    xAExplicit: 'Asistencias esperadas',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Asistencias esperadas en jugada',
    passesOpponentBox: 'Pases en el área contraria',
    passesOB: 'Pases en el AC',
    passesFinalThirdTooltip: 'Pases último tercio',
    passesSuccessful: 'Pases con Éxito',
    passesSuccessfulTooltip: 'Pases completados con éxito',
    ballProgressionPassing: 'PB con Pase',
    ballProgressionPassingTooltip: 'Progresión de balón con pase',
    ballProgressionDribbling: 'PB con Conducc.',
    ballProgressionDribblingTooltip: 'Progresión de balón con conducción',
    passesTotal: 'Pases',
    passesTotalTooltip: 'Total de pases intentados',
    shortPassesSuccessful: 'PC con Éxito',
    shortPassesSuccessfulTooltip: 'Pases cortos completados con éxito',
    shortPassesTotal: 'Pases Cortos',
    shortPassesTotalTooltip: 'Total de pases cortos intentados',
    tackles: 'Entradas *',
    adjustedTackles: 'Entradas ajustadas',
    interceptions: 'Intercepciones *',
    adjustedInterceptions: 'Intercepciones ajustadas',
    aerials: 'Aéreos',
    aerialsPercent: '% de aéreos',
    aerialEfficiency: 'Ef. Aérea.',
    aerialEfficiencyTooltip: 'Eficiencia Aérea (Mide Calidad y Cantidad)',
    twd: 'Tackles / fue Robado',
    tacklesWasDribbled: '1vs1 Defensivos Ganados',
    fouls: 'Faltas',
    indPressure: 'Presión individual',
    pressure: 'Presión',
    dispossessed: 'Perdidas de Balón',
    recoveries: 'Recuperaciones',
    primary: 'Primaria',
    secondary: 'Secundaria',
    tertiary: 'Terciaria',
    position: 'Posición',
    nationality: 'Nacionalidad',
    height: 'Altura (cm)',
    minHeight: 'Altura mín.',
    maxHeight: 'Altura max.',
    age: 'Edad',
    minAge: 'Edad min.',
    maxAge: 'Edad max.',
    games: 'Partidos',
    minGames: 'Partidos min.',
    maxGames: 'Partidos max.',
    minutes: 'Minutos',
    minMinutes: 'Minutos min.',
    maxMinutes: 'Minutos max.',
    minPercentMinutes: 'Porcentaje de minutos min.',
    dates: 'Fechas',
    marketValue: 'Valor (€)',
    teams: 'Equipos',
    contractEnd: 'Fin de contrato',
    minValue: 'Valor min.',
    maxValue: 'Valor max.',
    excludeTeams: 'Excluir equipos',
    recentSearches: 'Últimas búsquedas',
    saveSearch: 'Guardar búsqueda',
    loadSearch: 'Cargar búsqueda',
    loadCollection: 'Cargar Colección',
    collection: 'Colección',
    search: 'Buscar',
    searchesList: 'Listado de búsquedas',
    mySearches: 'Mis búsquedas',
    mySearchesDescription: 'Aquellas que has guardado anteriormente',
    recentSearchesDescription: 'Las últimas 10 busquedas que has realizado',
    searchToLoad: 'Búsqueda a cargar',
    recentSearch: 'Búsqueda reciente',
    saveSearchSuccess: 'Búsqueda guardada correctamente',
    removeSearch: 'Eliminar búsqueda',
    removeSearchMessage: '¿Está seguro que desea eliminar la búsqueda?',
    updateSearch: 'Actualizar búsqueda',
    updateSearchMessage: '¿Estás seguro de que quieres actualizar la búsqueda?',
    deleteSearchSuccess: 'Búsqueda eliminada con éxito',
    playersFound: 'encontrados',
    addToCollection: 'Añadir a la colección',
    npg: 'NPG',
    goals: 'Goles',
    value: 'Valor',
    nationalTeams: 'Selecciones',
    gbeScore: 'GBE',
    dlIndex: 'Score',
    minGbe: 'GBE min.',
    goalsConceded: 'Goles Recibidos',
    npgConceded: 'NPG Recibidos',
    npgConcededTooltip: 'Goles sin Penaltis Recibidos',
    xGOTConceded: 'xG a Puerta Recibidos',
    xGOTConcededTooltip: 'xG de los remates a puerta recibidos',
    goalsPrevented: 'Goles Evitados',
    xGFacedPerShotOnTarget: 'xG por Tiro a Puerta',
    xGFacedPerShotOnTargetTooltip: 'xG recibido por cada tiro a puerta',
    xGSavedPerxGFacedOnTarget: 'xG Paradas',
    xGSavedPerxGFacedOnTargetTooltip: 'Porcentaje de paradas teniendo en cuenta el xG',
    savesPct: '% Paradas',
    savesOutOfBoxPct: '% Paradas fuera del Área',
    savesInBoxPct: '% Paradas dentro del Área',
    xGFacedPerGoal: 'xG Recibido por Gol',
    xGFacedPerGoalTooltip: 'xG Necesario para marcar un Gol',
    catchingPct: '% Atrapados',
    catchingTooltip: 'Porcentaje de Balones Atrapados',
    passingOwnHalfPct: '% Pases Campo Propio',
    passingOwnHalfPctTooltip: 'Porcentaje de Pases Acertados a Campo Propio',
    passingOppHalfPct: '% Pases Campo Contrario',
    passingOppHalfPctTooltip: 'Porcentaje de Pases Acertados a Campo Contrario',
    passingContribution: '% Cont. de Pase',
    passingContributionTooltip: 'Contribución al Peligro de una jugada a través de Pases por encima de la media',
    shotsPerGoal: 'Remates por Gol',
    passesFinalThird: 'Pases Tercio Final',
    passingFinalThird: '% Pases Tercio Final',
    claimAccuracy: 'Precisión en Centros',
    claimAccuracyTooltip: 'Centros atrapados por encima de la media',
    highTurnovers: 'Pérdidas Peligrosas',
    highTurnoversTooltip: 'Pérdidas a 40 metros de portería',
    shotEndingHighTurnovers: 'PP y Tiro',
    shotEndingHighTurnoversTooltip: 'Pérdidas Peligrosas que acaban en tiro',
    goalEndingHighTurnovers: 'PP y Gol',
    goalEndingHighTurnoversTooltip: 'Pérdidas Peligrosas que acaban en gol',
    avgCarriesProgress: 'Progreso Medio',
    avgCarriesProgressTooltip: 'Distancia media conduciendo el balón hacía porteria (metros)',
    carriesChance: 'Conducc. y Ocasión',
    carriesChanceTooltip: 'Conducción seguido de Pase Clave',
    carriesAssist: 'Conducc. y Asistencia',
    carriesAssistTooltip: 'Conducción seguido de Asistencia',
    carriesShot: 'Conducc. y Tiro',
    carriesShotTooltip: 'Conducción seguido de Tiro',
    carriesGoal: 'Conducc. y Gol',
    carriesGoalTooltip: 'Conducción seguido de Gol',
    shotEndingSequence: 'Acaba en Tiro',
    shotEndingSequenceTooltip: 'Posesión acabada en Tiro participada por el jugador',
    goalEndingSequence: 'Acaba en Gol',
    goalEndingSequenceTooltip: 'Posesión acabada en Gol participada por el jugador',
    gbeScoreTooltip: 'FA Football\'s Governing Body Endorsement',
    goalsPreventedTooltip: 'Goles (Excluyendo Penaltis) salvador por el portero (xG Recibidos - NPG Concedidos)',
    freePlayers: 'Jugadores libres',
    index: 'Índice',
    playerName: 'Nombre',
    teamName: 'Equipo',
    secondPos: 'Pos. Secundaria',
    side: 'Lado',
    onlyOnLoan: 'Solo cedidos',
    dob: 'Nacimiento',
    countryName: 'País',
    secondCountryName: 'Segundo País',
    seasonYear: 'Temporada',
    assists: 'Asistencias',
    placeholder: 'Puede comenzar añadiendo algunos filtros de ligas',
    placeholder2: 'Pulsa en el botón de Buscar para mostrar resultados',
    passesPct: '% de Pases',
    passingPct: '% de Pases',
    oppBoxPasses: 'Pases en área contraria',
    adjustedClearances: 'Despejes ajustados',
    aerialsPct: '% de Aéreos',
    leagueCountryCode: 'Código país de la liga',
    shooting: '% de Remates a puerta',
    xtPassing: 'xT Pases',
    xtPassingTooltip: 'Peligro añadido a través de pases',
    xtDribbling: 'xT Conducción',
    xtDribblingTooltip: 'Peligro añadido a través de conducciones',
    foot: 'Pie bueno',
    aggressiveActions: 'Acc. Agresivas',
    aggressiveActionsTooltip: 'Entradas intentadas en los siguientes 2 segundos después de pérdida',
    tacklesAttempted: 'Tackles Intentados',
    highDefensiveActionPct: '% AD Altas',
    highDefensiveActionPctTooltip: 'Porcentaje de Acciones Defensivas (Tackles, Intercepciones, Bloqueos, Faltas Cometidas y 1vs1) del total por encima de 40m de la línea de fondo propia',
    individualPressureOppHalf: 'Presión Campo Rival',
    individualPressureOppHalfTooltip: 'Modelo que cuantifica el número de esfuerzos con éxito de un jugador ejerce en campo del rival durante presión',
    xGBuildUp5Pass: 'Construcc. xG 5p',
    xGBuildUp5PassTooltip: 'Construcción xG en los últimos 5 pases (excluyendo remates y pases que preceden al tiro)',
    chancesCreatedOpenPlay: 'Ocasiones Creadas en Jugada',
    chancesCreatedOpenPlayTooltip: 'Número de pases en jugada, que finalizan en un tiro a portería',
    fmf: {
      Defender: 'Defensas',
      aerial: 'Aéreos',
      goodDefender: 'Buena defensa',
      goodPresence: 'Buena presencia',
      playmaking: 'Creación',
      Fullback: 'Laterales',
      defensiveness: 'Defensa',
      offensiveness: 'Ataque',
      fast: 'Rapidez',
      Forward: 'Delanteros',
      goalChances: 'Oportunidades',
      goodDecissions: 'Buenas decisiones',
      individualTechnique: 'Calidad',
      Goalkeeper: 'Porteros',
      footWork: 'Manejo de pies',
      leadership: 'Liderazgo',
      Midfielder: 'Mediocentro Defensivos',
      balance: 'Equilibrio',
      ballRetention: '% Retención de balón',
      offensivePasses: 'Pases ofensivos',
      recoveries: 'Recuperaciones',
      shotToGoal: 'Remates a puerta',
      'Attacking-Midfielder': 'Mediapunta',
      defensiveGame: 'Juego defensivo',
      offensiveGame: 'Juego ofensivo',
      Winger: 'Extremos',
      crossing: 'Centros',
      deepProgressions: 'Progresiones',
      defendingEffort: 'Ayudas en defensa',
      facing: 'Encara'
    },
    yellowCards: 'Tarjetas Amarillas',
    redCards: 'Tarjetas Rojas',
    alert: 'Alerta',
    yearOfBirth: 'Año de nacimiento',
    minYearOfBirth: 'Año de nacimiento min.',
    maxYearOfBirth: 'Año de nacimiento max.',
    women: 'Femenino',
    continental: 'Continental',
    countryCup: 'Copa Nacional',
    statsName: 'Nombre',
    abbreviation: 'Abreviatura',
    starts: "Titularidades",
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    gamesWith60PlusMinsTooltip: 'Mínimo de juegos jugados con más de 60 minutos',
    minGPI: 'GPI min.',
    maxGPI: 'GPI max.',
  },
  playerComparison: {
    upTo5Players: 'Compara hasta 5 jugadores',
    requestReport: 'Solicitar informe',
    searchBarPlaceholder: 'Busca jugador o equipo',
    allStats: 'Todas las estadísticas',
    placeholder: 'Puede comenzar añadiendo algunos jugadores'
  },
  reports: {
    detailedInsights: 'Obtenga información detallada',
    features: 'Contenido del informe',
    performance: 'Rendimiento',
    evolution: 'Evolución',
    compareWithMyTeam: 'Comparar con mi equipo',
    similarPlayers: 'Jugadores similares',
    potentialTeams: 'Equipos potenciales',
    requestSuccess: 'Solicitud enviada con éxito',
    requestAt: 'Solicitado',
    reportConversation: 'Conversación del informe',
    writeYourMessage: 'Escribe tu mensaje...',
    you: 'Tú'
  },
  state: {
    requested: 'Solicitado',
    inProgress: 'En progreso',
    delivered: 'Entregado'
  },
  langs: {
    es: 'Español',
    en: 'Inglés',
    fr: 'Francés',
    de: 'Alemán',
    it: 'Italiano',
    pt: 'Portugués',
    tr: 'Turco',
    jp: 'Japonés',
    cn: 'Chino',
    sa: 'Árabe',
    nl: 'Holandés',
    pl: 'Polaco',
    sv: 'Sueco',
    cs: 'Checo',
    ko: 'Coreano',
    hu: 'Húngaro',
    ru: 'Ruso'
  },
  langsArea: {
    europe: 'Europa',
    asia: 'Asia',
    arabic: 'Árabe'
  },
  inbox: {
    subtitle: 'Mantente actualizado',
    new_injury_alert: 'Nueva Alerta de Lesión',
    new_contract_alert: 'Nueva Alerta de Contrato',
    new_team_alert: 'Nueva Alerta de Fichaje',
    new_marketValue_alert: 'Nueva Alerta de Valor de Mercado',
    new_game_alert: 'Nueva Alerta de Partido Jugado',
    receive_mail: 'Recibir Correo',
    receive_mail_subtitle: 'Recibe Correo Diario con los jugadores que pasen el filtro',
    receive_notifications: 'Notificaciones',
    receive_notifications_subtitle: 'Recibe notificaciones en la aplicación con los jugadores que pasen el filtro',
    changedTo: 'Cambia a',
    alerts: 'Alertas',
    includedIn: 'Incluido en',
    noContract: 'Sin contrato',
    newMessages: 'Mensajes nuevos',
    reply: {
      reply: 'Respuesta',
      replyTitle: 'Proporciona feedback al cliente:',
      replyPlaceholder: 'El usuario recibirá la respuesta junto con la actualización del estado'
    }
  },
  gameAnalysis: {
    subtitle: 'Profundiza en los últimos partidos',
    subtitle2: 'Mostrando partidos de los siguientes siete días',
    subtitle3: 'Profundiza en los últimos partidos y explora los siguientes',
    seeDetail: 'Ver detalles'
  },
  statsNaming: {
    Possession: 'Posesión',
    TimePossession: 'Tiempo de Posesión',
    PassesPerShots: 'Pases por Remate',
    PPDA: 'PPDA',
    ExpectedPoints: 'Puntos Esperados',
    Points: 'Puntos',
    Directness: 'Verticalidad',
    PassesPerLongBall: 'Pases por cada Balón Largo',
    CrossingPerXG: 'Centros por xG',
    PenaltySavedPenaltyFaced: 'Penalty Parado / Penalty Recibido',
    Goals: 'Goles',
    PenaltyShots: 'Remates de penalti',
    PenaltyGoals: 'Goles de penalti',
    NonPenaltyGoals: 'Goles sin Penaltis',
    NPGOpenPlay: 'Goles sin Penaltis en Juego',
    NPGSetPiece: 'Goles sin Penaltis a Balón Parado',
    Shooting: '% Remates a Puerta',
    Finishing: 'Finalización',
    xGEfficiency: 'Eficiencia xG',
    HeaderPerShot: 'Remate de Cabeza por Tiro',
    HeaderPerCross: 'Remate de Cabeza por Centro',
    HeadedGoals: 'Goles de cabeza',
    HeadedShots: 'Remates de cabeza',
    HeadedXG: 'xG de cabeza',
    HeadedSetPieceTooltip: 'Mostrando solo los jugadores que tienen tiros de cabeza en jugadas a balón parado',
    GoalsConceded: 'Goles encajados',
    SavesInBox: 'Paradas Dentro del Área',
    SavesOutBox: 'Paradas Fuera del Área',
    Assists: 'Asistencias',
    ThroughBalls: 'Pases entre Líneas',
    CrossEfficiency: 'Eficiencia de Centros',
    ScoringContribution: 'Contribución Goleadora',
    xAssistsOpenPlay: 'xA en Jugada',
    xAssistsSetPiece: 'xA a Balón Parado',
    xAssistsOpenPlayInTeam: 'xA en Jugada en su Equipo',
    xAssistsSetPieceInTeam: 'xA a Balón Parado en su Equipo',
    xGBuildupFinalThird: 'Construcción xG Último ⅓',
    xGChainFinalThird: 'Participación xG Último ⅓',
    BallProgressionPassing: 'Progresión de Balón con Pase',
    BallProgressionDribbling: 'Progresión de Balón con Conducción',
    TacklesWasDribbled: '1vs1 Defensivos Ganados',
    TacklesSuccessful: 'Tackles con Éxito',
    Interceptions: 'Intercepciones',
    Clearances: 'Despejes',
    Fouls: 'Faltas',
    Recoveries: 'Recuperaciones',
    recoveriesRate: 'Ratio de Recuperaciones',
    turnoversRate: 'Ratio de Pérdidas',
    Shots: 'Remates',
    ShotsPerGoal: 'Remates por Gol',
    ShortPassesSuccessful: 'Pases Cortos Completados',
    PassingSuccessForwardPct: '% Pases Adelante Completados',
    PassingSuccessBackwardPct: '% Pases Atrás Completados',
    PassingForwardBackwardPct: '% Pases Adelante por Pase Atrás',
    LongBallPerPassesPct: '% Pases Largos por Pases Completados',
    LongBallReceived: 'Pases Largos Recibidos',
    LongBallReceivedOppHalf: 'Pases Largos Rec. Campo Cont.',
    OffensiveActions: 'Acciones Ofensivas',
    DribblesAttempted: 'Regates Intentados',
    SuccessfulDribblesPct: '% Regates Completados',
    OffensiveTouchesOutBoxPct: '% Toques Ofensivos Fuera del Área',
    BallRetention: '% Retención del Balón',
    PassingPct: '% Pases',
    PassingOwnHalfPct: '% Pases en Campo Propio',
    PassingOppHalfPct: '% Pases en Campo Contrario',
    PassingFinalThird: 'Pases Último ⅓',
    PassesFinalThirdTotal: 'Pases Totales Último ⅓',
    PassingFinalThirdPct: '% Pases Último ⅓',
    LongBallSuccessful: 'Pases Largos Completados',
    LongBallPct: '% Pases Largos',
    LongBallTotal: 'Pases Largos Totales',
    SavesPct: '% Paradas',
    SavesInBoxPct: '% Paradas Dentro del Área',
    SavesOutOfBoxPct: '% Paradas Fuera del Área',
    xGSavedPerXGFacedOnTarget: 'xG Parados / xG Recibidos',
    xGFacedOnTargetPerGoalReceived: 'xG Recibidos por Gol',
    xGFacedOnTargetEfficiency: 'Goles Evitados',
    xGFacedOnTarget: 'xG Recibido',
    IndividualPressure: 'Presión Individual',
    AerialEfficiency: 'Eficiencia Aérea',
    AerialWins: 'Duelos Aéreos Ganados',
    AerialWinsPct: '% Duelos Aéreos Ganados',
    xG: 'Goles Esperados',
    xGDiff: 'xG Diferencia',
    xGOpenPlay: 'xG en Juego',
    xGSetPiece: 'xG a Balón Parado',
    xGPerShot: 'xG por Remate',
    ChancesCreated: 'Ocasiones Creadas',
    CompletedCrosses: 'Centros Completados',
    Crossing: '% Centros Completados',
    OpenPlayKeyPasses: 'Pases Clave en Juego',
    OpenPlayKeyPassesInTeam: '% Pases Clave en Juego en su Equipo',
    OpenPlayPassesIntoOpponentBox: 'Pases Totales al Área en Juego',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Pases Completados al Área en Juego',
    xAssists: 'Asistencias Esperadas',
    xGChain: 'Participación xG',
    xGBuildup: 'Construcción xG',
    xGBuildupInTeam: 'Construcción xG en su Equipo',
    BallProgression: 'Progresión de Balón',
    SuccessfulDribbles: 'Regates Completados',
    Dispossessed: 'Pérdidas de Balón',
    TouchesInOpponentBox: 'Toques en Área Rival',
    xGSavedPerShot: 'xG Parados por Remate',
    BallRetentionOppHalf: '% Retención del Balón en Campo Rival',
    DeepProgression: 'Profundidad',
    DeepProgressionFinalThird: 'Profundidad en el Último ⅓',
    FoulsTaken: 'Faltas Recibidas',
    PenaltiesTaken: 'Penaltis Recibidos',
    BlockedCrosses: 'Centros Interceptados',
    BlockedShots: 'Remates Interceptados',
    Blocks: 'Bloqueos',
    NonPenaltyGoalsAgainst: 'Goles Sin Penaltis en Contra',
    Headers: 'Remates de Cabeza',
    AveragePassDistance: 'Distancia Media de Pases',
    ProgressiveRuns: 'Conducciones Progresivas',
    xT: 'Peligro Esperado (xT)',
    xTOpenPlay: 'xT en Juego',
    xTSetPiece: 'xT a Balón Parado',
    xGOT: 'Goles esperados a puerta',
    BadActions: 'Acciones Fallidas',
    BadActionsOwnHalf: 'Acciones Fallidas en Campo Propio',
    AerialsWonOwnBox: 'Duelos Aéreos Ganados en AP',
    AerialsWonOppBox: 'Duelos Aéreos Ganados en AR',
    AerialsTotalOppBox: 'Total de Duelos Aéreos en AR',
    AerialsTotalOwnBox: 'Total de Duelos Aéreos en AP',
    FoulsOwnHalfPct: '% Faltas en Campo Propio',
    RecoveriesOppHalf: 'Recuperaciones en Campo Contrario',
    DuelsPct: '% Duelos Exitosos',
    TacklesUnsuccessful: 'Tackles Fallados',
    TacklesWasDribbledFirstThird: '1vs1 Defensivos Ganados ⅓',
    TacklesWasDribbledSecondThird: '1vs1 Defensivos Ganados ⅔',
    TacklesWasDribbledFinalThird: '1vs1 Defensivos Ganados Último ⅓',
    BallProgressionFinalThird: 'Prog. de Balón Último ⅓',
    DuelsTotal: 'Duelos',
    QuickRecoveries: 'Recuperaciones Rápidas',
    ShotsPerNPG: 'Remates por Goles sin Penaltis',
    ShotsOutBox: 'Remates Fuera del Área',
    GoalsOutBox: 'Goles Fuera del Área',
    ShootingOutBox: '% Remates a Puerta Fuera del Área',
    HandPassing: '% Pases con la Mano',
    Catching: '% Paradas Atrapadas',
    Caught: 'Paradas Atrapadas',
    ClaimAccuracy: 'Precisión en Centros',
    HighTurnovers: 'Pérdidas Peligrosas',
    ShotEndingHighTurnovers: 'Pérdidas Peligrosas y Tiro',
    GoalEndingHighTurnovers: 'Pérdidas Peligrosas y Gol',
    AverageCarriesProgress: 'Progreso Medio de Conducciones',
    ChanceEndingCarries: 'Conducción y Ocasión',
    AssistEndingCarries: 'Conducción y Asistencia',
    ShotEndingCarries: 'Conducción y Tiro',
    GoalEndingCarries: 'Conducción y Gol',
    ShotEndingSequence: 'Secuencia acabada en tiro',
    GoalEndingSequence: 'Secuencia acabada en gol',
    xGPerNPG: 'xG por Goles sin Penaltis',
    AerialWonOffensive: 'Duelos Aéreos Ofensivos Ganados',
    AerialWonDefensive: 'Duelos Aéreos Defensivos Ganados',
    xGAgainst: 'xG Concedido',
    xGDiffAgainst: 'xG Dif concedido',
    xGPerNPGAgainst: 'xG por Goles sin Penaltis Concedidos',
    xGSetPieceAgainst: 'xG a Balón Parado Concedido',
    xGOpenPlayAgainst: 'xG Juego abierto concedido',
    xGPerShotAgainst: 'xG por Remate Concedido',
    ShotsAgainst: 'Remates Concedidos',
    ShotsOnTargetAgainst: 'Remates a Puerta Concedidos',
    ShotsOnTargetInBoxAgainst: 'Remates a puerta en el área concedidos',
    ShotsOnTargetOutBoxAgainst: 'Remates a puerta fuera del área concedidos',
    RivalPossession: 'Posesión del Rival',
    AerialDefensivePct: '% Duelos Aéreos Defensivos',
    HighRecoveries: 'Recuperaciones Peligrosas',
    HighDefensiveActions: 'Acciones Defensivas Altas',
    HighDefensiveActionPct: '% Acciones Defensivas Altas',
    HighDefensiveDistance: 'Distancia Defensiva Altas',
    PassesPerPossession: 'Pases por Posesión',
    LengthPerPossession: 'Distancia por Posesión',
    xTNet: 'xT Neto',
    AvgCarriesDistance: 'Distancia Media de Conducción',
    PassesForwardPct: '% Pases hacia Delante',
    PassesForwardSuccessful: 'Pases hacia Delante Completados',
    PassesForwardTotal: 'Total Pases hacia Delante',
    TacklesAttempted: 'Tackles Intentados',
    DuelsLost: 'Duelos Perdidos',
    Carries: 'Conducciones',
    CarriesPct: '% Conducciones',
    Aerials: 'Duelos Aéreos',
    ProgressivePassesReceivedIntoBox: 'Pases Progresivos Recibidos en el Área',
    PassesOppHalf: 'Pases Campo Contrario',
    ShotsOnTarget: 'Remates a Puerta',
    AggressiveActions: 'Acciones Agresivas',
    Crosses: 'Centros',
    xGBuildup5pass: 'Construcción xG 5 pases',
    SpeedSequence: 'Velocidad de Posesión',
    Touches: 'Toques',
    AerialsTotalOppHalf: 'Duelos Aéreos Totales Campo Rival',
    AerialsWonOppHalf: 'Duelos Aéreos Ganados Campo Rival',
    AerialsWonOppHalfPct: '% Duelos Aéreos Ganados Campo Rival',
    AerialsPctOppBox: '% Duelos Aéreos Ganados Área Rival',
    AerialsPctOwnBox: '% Duelos Aéreos Ganados Área Propia',
    AerialDefensive: 'Duelos Aéreos Defensivos',
    AerialOffensive: 'Duelos Aéreos Ofensivos',
    AerialOffensivePct: '% Duelos Aéreos Ofensivos',
    IndividualPressureOppHalf: 'Presión Individual Campo Rival',
    ChancesCreatedOP: 'Ocasiones Creadas en Jugada',
    TouchesPerShot: 'Toques por Remate',
    PassesFinalThirdTotalPct: '% Pases Último ⅓',
    xACrosses: 'xA de Centros',
    Passes: 'Pases',
    PassesSuccessful: 'Pases Completados',
    TacklesWasDribbledFouls: '% Duelos por Bajo',
    OffsidesCaught: 'Fueras de Juego',
    ProgressivePassesReceivedFinalThird: 'Pases Progresivos Recibidos Último ⅓',
    ProgressivePassesReceived: 'Pases Progresivos Recibidos',
    Breadth: 'Amplitud',
    DuelsDefTotal: 'Duelos Defensivos',
    DefensiveActions: 'Acciones Defensivas',
    ProgressivePassesReceivedOppHalf: 'Pases Progresivos Recibidos en Campo Rival',
    CompletedCrossesOP: 'Centros Completados en Jugada',
    CrossingOP: '% Centros Completados en Jugada',
    CrossesOP: 'Total Centros en Jugada',
    PassingContribution: '% Contribución de Pase',
    BallProgressionOppHalfInTeam: '% Progresión de Balón en Campo Rival en su Equipo',
    PassesOPIntoBoxInTeam: '% Pases en Juego al Área Rival en su Equipo',
    TouchesOppBoxInTeam: '% Toques de Balón en el Área Rival en su Equipo',
    xGOPInTeam: '% xG en Juego en su Equipo',
    DeepPasses: 'Pases en Profundidad Completados',
    DeepPassesTotal: 'Pases en Profundidad',
    DefensiveDuelsPct: '% Duelos Defensivos',
    DefensiveDistance: 'Distancia Defensiva',
    QuickRecoveriesPct: '% Recuperaciones Rápidas',
    DiffDefensiveDistanceTeam: 'Diferencia Distancia Defensiva con el Equipo',
    xTPassing: 'xT Pases',
    xTPassing100Passes: 'xT Pases por 100 Pases',
    ProgressivePassesAccurate: 'Pases Progresivos Completados',
    PassAbility: 'Habilidad Pases',
    OPPassesIntoOppBoxPct: '% Pases al Área en Jugada',
    EntriesOppBox: 'Entradas al Área',
    Crosses6yardBox: 'Centros al Área Pequeña',
    Cutbacks: 'Pases de la Muerte',
    xTDribbling: 'xT Regates',
    AvgShotDistance: 'Distancia Media Remates',
    xGOnTarget: 'xG a Puerta',
    FinishingxGOT: 'Finalizacion xG a Puerta',
    DribblesWonOwnHalf: 'Regates Completados Campo Propio',
    DribblesOwnHalf: 'Regates Intentados Campo Propio',
    DribblesOwnHalfPct: '% Regates Completados Campo Propio',
    DribblesWonOppHalf: 'Regates Completados Campo Contrario',
    DribblesOppHalf: 'Regates Intentados Campo Contrario',
    DribblesOppHalfPct: '% Regates Completados Campo Contrario',
    DribblesWonFinalThird: 'Regates Completados Último ⅓',
    DribblesFinalThird: 'Regates Intentados Último ⅓',
    DribblesFinalThirdPct: '% Regates Completados Último ⅓',
    ShotEndingHighRecoveries: 'Recuperaciones Peligrosas y Tiro',
    PassingFinalThirdAgainst: 'Pases al Último ⅓ Concedidos',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Pases Totales al Área en Juego Concedidos',
    EntriesOppBoxAgainst: 'Entradas al Área Concedidas',
    DeepProgressionAgainst: 'Profundidad Concedida',
    TouchesInOpponentBoxAgainst: 'Toques en Área Propia Concedidos',
    Score: 'Puntuación',
    scoreDifference: 'Diferencia de Puntuación: Indica si el rendimiento en este partido estuvo por encima o por debajo de la media de la temporada',
    PDScore: 'Puntuación Física',
    SpeedScore: 'Puntuación de Velocidad y Potencia',
    EnduranceScore: 'Puntuación de Resistencia',
    OrlegiScore: 'Puntuación Orlegi',
    SirScore: 'Puntuación Sirius',
    ExcScore: 'Puntuación Excelsior',
    xTOPInTeam: 'xT en Juego en su Equipo',
    YellowCards: 'Tarjetas Amarillas',
    RedCards: 'Tarjetas Rojas',
    xTOpenPlayAgainst: 'xT en Juego Concedido',
    xTSetPieceAgainst: 'xT a Balón Parado Concedido',
    NPGOpenPlayAgainst: 'GSP en Juego Concedido',
    NPGSetPieceAgainst: 'GSP a Balón Parado Concedido',
    PassesOppHalfPerPossession: 'Pases Campo Contrario por Posesión',
    AverageTimeRecovery: 'Tiempo Medio Recuperación',
    ExpectedPassing: '% Passes Esperados',
    NumPossession10Passes: 'Posesiones 10 Pases',
    PassesReceived: 'Pases Recibidos',
    PassesReceivedFinalThird: 'Pases Recibidos Último ⅓',
    ProgressivePassesTotalPct: '% Pases Progresivos',
    ShortPassesPct: '% Pases Cortos',
    TouchesOppBoxOppTeam: 'Toques en Área Propia Concedidos con él Jugando',
    ShotsOnTargetOppTeam: 'Remates a Puerta Concedidos con él Jugando',
    NPGOppTeam: 'GSP del Rival con él Jugando',
    ShotsOpenPlay: 'Remates en jugada',
    xGSetPiecePerxG: 'xG a balón parado por xG',
    ShotsOpenPlayAgainst: 'Remates en jugada recibidos',
    ShotsFromDribble: 'Disparos tras Regate',
    GoalsFromDribble: 'Goles tras Regate',
    PassesIntoFinalThird: 'Pases al Último ⅓',
    PassesIntoFinalThirdTotal: 'Total Pases al Último ⅓',
    PassesInsideFinalThird: 'Pases dentro del Último ⅓',
    PassesInsideFinalThirdTotal: 'Total Pases dentro del Último ⅓',
    PassesFinalThirdNoArea: 'Pases Último ⅓ (no Área)',
    PassesIntoOppBox: 'Pases al Área Rival',
    CarriesFinalThird: 'Conducciones Último ⅓',
    CarriesInsideFinalThird: 'Conducciones dentro del Último ⅓',
    CarriesFinalThirdNoBox: 'Conducciones Último ⅓ (no Área)',
    CarriesIntoOppBox: 'Conducciones al Área Rival',
    TimePossessionAgainst: 'Posesión del Rival',
    TimePossessionTotal: 'Posesión Total',
    PassesInBox: 'Pases en el Área',
    LongThrowInSuccessful: 'Saque de Banda Largo Exitoso',
    LongThrowInTotal: 'Total de Saques de Banda Largos',
    LongThrowInPct: '% Saques de Banda Largos',
    Games: 'Partidos',
    PointsPerGame: 'Puntos por Partido',
    ExpectedPointsDiff: 'Diferencia de puntos esperada',
    PassesTotalOwnHalf: 'Total Pases Campo Propio',
    PassesOwnHalf: 'Pases Exitosos Campo Propio',
    PassesTotalOppHalf: 'Total Pases Campo Rival',
    ProgressivePassesTotal: 'Total Pases Progresivos',
    DuelsWon: 'Duelos Ganados',
    NonPenaltySaves: 'Paradas sin Penaltis',
    BadActionsOppHalf: 'Acciones Fallidas en Campo Rival',
    CarriesSuccessful: 'Conducciones Exitosas',
    CarriesIntoFinalThird: 'Conducciones Hacia Último ⅓',
    ShotsOnTargetOutBox: 'Remates a Puerta Fuera del Área',
    SwitchPlaySuccessful: 'Cambios de Juego Exitosos',
    SwitchPlayTotal: 'Cambios de Juego Totales',
    PassesInsideOppHalf: 'Pases en Campo Rival',
    PassesInsideOppHalfSuccessful: 'Pases Exitosos en Campo Rival',
    TacklesAttemptedFirstThird: 'Tackles Intentados en Primer ⅓',
    TacklesAttemptedSecondThird: 'Tackles Intentados en Segundo ⅓',
    TacklesFirstThird: 'Tackles Exitosos en Primer ⅓',
    TacklesSecondThird: 'Tackles Exitosos en Segundo ⅓',
    FoulsOwnHalf: 'Faltas en Campo Propio',
    TouchesOppHalf: 'Toques en Campo Rival',
    TacklesAttemptedNotAdjusted: 'Tackles Intentados sin Ajustar',
    TacklesSuccessfulNotAdjusted: 'Tackles Exitosos sin Ajustar',
    // Physical Stats
    TotalDistance: 'Distancia',
    DistanceTIP: 'Distancia TIP',
    DistanceOTIP: 'Distancia OTIP',
    SprintsNumber: 'Cantidad Sprints',
    SprintsDistance: 'Distancia Sprints',
    WalkingDistance: 'Distancia Caminando',
    JoggingDistance: 'Distancia Trotando',
    RunningDistance: 'Distancia Corriendo',
    ExtremeAccelerations: 'Aceleraciones Extremas',
    NumberOfRuns: 'Carreras',
    HsrNumber: 'Cantidad HSR',
    HsrDistance: 'Distancia HSR',
    SprintNumberDeclinePct: '% Disminución de Sprints',
    SprintDistanceDeclinePct: '% Disminución Distancia Sprints',
    SprintNumberDecline: 'Disminución de Sprints',
    SprintDistanceDecline: 'Disminución Distancia Sprints',
    HsrDistancePct: '% Distancia HSR',
    SprintDistancePct: '% Distancia Sprints',
    Accelerations: 'Aceleraciones',
    ExplosiveDistance: 'Distancia Explosiva',
    MaxSpeed: 'Velocidad Max.',
    AvgMaxSpeed: 'Velocidad Max. Media',
    MaxAccelerations: 'Aceleraciones Max.',
    HsrDistanceIP: 'Distancia HSR en Posesión',
    HsrDistanceOOP: 'Distancia HSR sin Posesión',
    JoggingDistanceIP: 'Distancia Trotando en Posesión',
    JoggingDistanceOOP: 'Distancia Trotando sin Posesión',
    RunningDistanceIP: 'Distancia Corriendo en Posesión',
    RunningDistanceOOP: 'Distancia Corriendo sin Posesión',
    SprintsDistanceIP: 'Distancia Sprints en Posesión',
    SprintsDistanceOOP: 'Distancia Sprints sin Posesión',
    WalkingDistanceIP: 'Distancia Caminando en Posesión',
    WalkingDistanceOOP: 'Distancia Caminando sin Posesión',
    // Arrigo
    BypassedPlayersByPasses: 'Jugadores Superados por Pases',
    BypassedDefendersByPasses: 'Defensores Superados por Pases',
    PassesBypassingPlayers: 'Pases que Superan Jugadores',
    PassesBypassingDefenders: 'Pases que Superan Defensores',
    BypassedPlayersPerPass: 'Jugadores Superados por Pase',
    BypassedDefendersPerPass: 'Defensores Superados por Pase',
    LineBreakingPasses: 'Pases entre Líneas',
    LineBreakingPassesMD: 'Pases entre Líneas Media y Defensiva',
    LineBreakingPassesM: 'Pases entre Línea Media',
    LineBreakingThroughBalls: 'Balones en Profundidad entre Líneas',
    LineBreakingPassesPerPass: '% Pases entre Líneas por Pase',
    TotalPassesUnderStrongPressure: 'Total de Pases Bajo Alta Presión',
    TotalPassesUnderLightPressure: 'Total de Pases Bajo Presión',
    SuccessfulPassesUnderStrongPressure: 'Pases Bajo Alta Presión Completados',
    SuccessfulPassesUnderLightPressure: 'Pases Bajo Presión Completados',
    PassingUnderStrongPressure: '% Pases Bajo Alta Presión',
    PassingUnderLightPressure: '% Pases Bajo Presión',
    PassReceiptsInSpaceCompleted: 'Pases Completados Recibidos al Espacio',
    PassReceiptsInSpace: 'Pases Recibidos al Espacio',
    PassReceiptsInSpaceCompletedFirstThird: 'Pases Completados Recibidos al Espacio Primer ⅓',
    PassReceiptsInSpaceCompletedSecondThird: 'Pases Completados Recibidos al Espacio Segundo ⅓',
    PassReceiptsInSpaceCompletedFinalThird: 'Pases Completados Recibidos al Espacio Último ⅓',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Pases Completados Recibidos al Espacio Campo Rival Derecha',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Pases Completados Recibidos al Espacio Campo Rival Centro',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Pases Completados Recibidos al Espacio Campo Rival Izquierda',
    PassReceiptsInSpaceFirstThird: 'Pases Recibidos al Espacio Primer ⅓',
    PassReceiptsInSpaceSecondThird: 'Pases Recibidos al Espacio Segundo ⅓',
    PassReceiptsInSpaceFinalThird: 'Pases Recibidos al Espacio Último ⅓',
    PassReceiptsInSpaceOppHalfRight: 'Pases Recibidos al Espacio Campo Rival Derecha',
    PassReceiptsInSpaceOppHalfCenter: 'Pases Recibidos al Espacio Campo Rival Centro',
    PassReceiptsInSpaceOppHalfLeft: 'Pases Recibidos al Espacio Campo Rival Izquierda',
    TotalStrongOnBallPressures: 'Total de Presiones Fuertes al Balón',
    TotalLightOnBallPressures: 'Total de Presiones al Balón',
    SuccessfulStrongOnBallPressures: 'Presiones Fuertes al Balón Completados',
    SuccessfulLightOnBallPressures: 'Presiones al Balón Completados',
    StrongOnBallPressuresPct: '% Presiones Fuertes al Balón',
    LightOnBallPressuresPct: '% Presiones al Balón',
    TimesBypassedByPasses: 'Veces Superado por Pases',
    TimesBypassedByCarries: 'Veces Superado por Conducciones',
    TimesBypassedByActions: 'Veces Superado por Acciones',
    BypassedPlayersByCarries: 'Jugadores Superados por Conducciones',
    BypassedDefendersByCarries: 'Defensores Superados por Conducciones',
    BypassedPlayersByActions: 'Jugadores Superados por Acciones',
    BypassedDefendersByActions: 'Defensores Superados por Acciones',
    CarriesBypassingPlayers: 'Conducciones que Superan Jugadores',
    CarriesBypassingDefenders: 'Conducciones que Superan Defensores',
    BypassedPlayersPerCarry: 'Jugadores Superados por Conducción',
    BypassedDefendersPerCarry: 'Defensores Superados por Conducción',
    LineBreakingCarries: 'Conducciones entre Líneas',
    LineBreakingCarriesMD: 'Conducciones entre Líneas Defensores y Medios',
    LineBreakingCarriesM: 'Conducciones entre Línea Medios',
    LineBreakingCarriesD: 'Conducciones entre Línea Defensores',
    LineBreakingCarriesPerCarry: 'Conducciones entre Líneas por Conducción',
    LineBreakingActions: 'Acciones entre Líneas',
    LineBreakingActionsMD: 'Acciones entre Línea Defensores y Medios',
    LineBreakingActionsM: 'Acciones entre Línea Medios',
    LineBreakingActionsD: 'Acciones entre Línea Defensores',
    PassesPerLineBreakingPass: 'Pases por Pase entre Líneas',
    CarriesPerLineBreakingCarry: 'Conducciones por Conducción entre Líneas',
    LinesBrokenByPasses: 'Líneas Superadas con Pase',
    LinesBrokenByCarries: 'Líneas Superadas con Conducciones',
    LinesBrokenByActions: 'Líneas Superadas con Acciones',
    LinesBrokenPerPass: 'Líneas Superadas por Pase',
    LinesBrokenPerCarry: 'Líneas Superadas por Conducción',
    AvgLastDefenderDistanceIP: 'Distancia Último Defensor con Posesión',
    AvgLastDefenderDistanceOOP: 'Distancia Último Defensor sin Posesión',
    AvgDefensiveLineDistanceIP: 'Distancia Línea Defensiva con Posesión',
    AvgDefensiveLineDistanceOOP: 'Distancia Línea Defensiva sin Posesión',
    AvgRBDistanceIP: 'Distancia LD con Posesión',
    AvgRBDistanceOOP: 'Distancia LD sin Posesión',
    AvgLBDistanceIP: 'Distancia LI con Posesión',
    AvgLBDistanceOOP: 'Distancia LI sin Posesión',
    AvgBlockDistanceIP: 'Distancia del Bloque con Posesión',
    AvgBlockDistanceOOP: 'Distancia del Bloque sin Posesión',
    AvgBlockAreaIP: 'Área del Bloque con Posesión',
    AvgBlockAreaOOP: 'Área del Bloque sin Posesión',
    AvgDefensiveLineWidthOOP: 'Anchura Línea Defensiva sin Posesión',
    AvgOffensiveLineLastThirdWidthIP: 'Anchura Línea Ofensiva Último ⅓ con Posesión',
    AvgLByIP: 'Posición LI con Posesión',
    AvgRByIP: 'Posición LD con Posesión',
    AvgOffensiveLineDistanceIP: 'Distancia Línea Ofensiva con Posesión',
    AvgOffensiveLineLastThirdDistanceIP: 'Distancia Línea Ofensiva Último ⅓ con Posesión',
    AvgOffensiveLineWidthIP: 'Anchura Línea Ofensiva con Posesión',
    OffBallRuns: 'Desmarques Totales',
    OffBallRunsOverlap: 'Desmarques por Fuera',
    OffBallRunsUnderlap: 'Desmarques por Dentro',
    OffBallRunsRunAhead: 'Desmarques en Profundidad',
    OffBallRunsRunBehind: 'Desmarques a la Espalda',
    OffBallRunsCrossReceiver: 'Desmarques para Rematar',
    OffBallRunsSupport: 'Desmarques de Apoyo',
    OffBallRunsComingShort: 'Desmarques de Apoyo Cercano',
    AvgTop5MaxSpeed: 'Media Top 5 Velocidades',
    LBPReceived: 'Pases entre Líneas Recibidos',
    LBPMReceived: 'Pases entre Línea Media Recibidos',
    LBPMDReceived: 'Pases entre Líneas Media y Defensiva Recibidos',
    ThroughBallReceived: 'Balones en Profundidad entre Líneas Recibidos',
    description: {
      Possession: 'Porcentaje de posesión del equipo',
      TimePossession: 'Tiempo de posesión del equipo',
      PassesPerShots: 'Número de pases realizados por cada tiro',
      PPDA: 'Pases por Acción Defensiva. Mide el número de pases que han sido dados por el equipo rival hasta que la jugada ha sido interrumpida por una acción defensiva. A mayor PPDA, menor es la presión ejercida al rival.',
      Directness: 'Mide como de directo es un equipo en sus pases, premiando pases hacia la porteria rival',
      ExpectedPoints: 'Número de puntos esperados de un equipo, calculado a partir de los Goles Esperados generados y recibidos en cada partido. Este cálculo permite conocer el rendimiento de un equipo respeto a un partido (o acumulado de partidos) al compararlo con los puntos que realmente ha conseguido.',
      PassesPerLongBall: 'Número de pases realizados por cada pase largo',
      CrossingPerXG: 'Porcentaje de Goles Esperados que vienen de centros al área',
      PenaltySavedPenaltyFaced: 'Porcentaje de penaltis salvados por penaltis recibidos',
      Goals: 'Número de goles anotados',
      PenaltyShots: 'Número total de remates desde el punto de penalti',
      PenaltyGoals: 'Número total de goles desde el punto de penalti',
      NonPenaltyGoals: 'Goles marcados, excluyendo goles de penalti',
      NPGOpenPlay: 'Goles marcados en jugada',
      NPGSetPiece: 'Goles marcados generados a balón parado, excluyendo goles de penalti',
      Shooting: 'Porcentaje de remates a puerta',
      Finishing: 'Porcentaje de remates que acaban en gol',
      xGEfficiency: 'Cantidad de Goles Esperados necesarios para que el jugador marque un gol',
      HeaderPerShot: 'Número de remates de cabeza',
      HeaderPerCross: 'Porcentaje de centros rematados de cabeza por el jugador del total de centros completados por el equipo',
      Assists: 'Número de asistencias',
      ThroughBalls: 'Pases al hueco',
      CrossEfficiency: 'Número de centros completados del total de centros intentados',
      ScoringContribution: 'Número de asistencias y goles',
      xAssistsOpenPlay: 'Número de Asistencias Esperadas que provienen de jugadas y no a balón parado',
      xAssistsSetPiece: 'Número de Asistencias Esperadas que provienen de jugadas a balón parado',
      xAssistsOpenPlayInTeam: 'Número de Asistencias Esperadas que provienen de jugadas y no a balón parado en su Equipo',
      xAssistsSetPieceInTeam: 'Número de Asistencias Esperadas que provienen de jugadas a balón parado en su Equipo',
      xGChainFinalThird: 'Cantidad de Goles Esperados en las que ha participado el jugador en el último tercio',
      xGBuildupFinalThird: 'Cantidad de Goles Esperados en las que ha participado el jugador en el último tercio (excluyendo remates y pases que le preceden)',
      BallProgressionPassing: 'Número de veces que el jugador avanza el balón 10 metros o más, mediante pases',
      BallProgressionDribbling: 'Número de veces que el jugador avanza el balón 10 metros o más, a través de conducción',
      TacklesWasDribbled: 'Métrica que tiene en cuenta el porcentaje de veces que el jugador recupera el balón vía tackling vs. las veces que fue rebasado/regateado. Cuanto más alta sea el indicador, mejor',
      TacklesSuccessful: 'Número de tackles realizadas con éxito',
      Interceptions: 'Número de veces que el jugador intercepta un pase',
      Clearances: 'Número de veces que el jugador despeja un pase',
      Fouls: 'Número de faltas realizadas por el jugador',
      Recoveries: 'Número de balones recuperados por el jugador',
      Shots: 'Número total de remates',
      ShotsPerGoal: 'Número de remates necesarios hasta marcar un gol al jugador',
      ShortPassesSuccessful: 'Número de pases cortos (menos de 12 metros) completados',
      PassingSuccessForwardPct: 'Porcentaje de pases hacia delante con éxito',
      PassingSuccessBackwardPct: 'Porcentaje de pases hacia atrás con éxito',
      PassingForwardBackwardPct: 'Ratio de pases hacia delante respecto a pases hacia atrás',
      LongBallPerPassesPct: 'Porcentaje de balones largos respecto del total de pases',
      LongBallReceived: 'Balones largos de más de 32 metros recibidos',
      LongBallReceivedOppHalf: 'Números de balones largos recibidos en el campo rival',
      OffensiveActions: 'Acciones ofensivas',
      DribblesAttempted: 'Número de regates intentados',
      SuccessfulDribblesPct: 'Regates con éxito/ total de intentos de regate realizados',
      OffensiveTouchesOutBoxPct: '% de toques ofensivos fuera del cuadro',
      BallRetention: 'Porcentaje de las veces que tienes la posesión de balón y no la terminas perdiendo',
      PassingPct: 'Porcentaje de pases completados del total de pases realizados por el jugador',
      PassingOwnHalfPct: 'Porcentaje de acierto en pases que acaban en campo propio',
      PassingOppHalfPct: 'Porcentaje de acierto en pases  que acaban en campo rival',
      PassingFinalThird: 'Número de pases completados que terminan en el último tercio del campo',
      PassesFinalThirdTotal: 'Número de pases intentados que terminan en el último tercio del campo',
      PassingFinalThirdPct: 'Porcentaje de acierto en pases que terminan en último tercio del campo',
      LongBallSuccessful: 'Número de pases completados de más de 32 metros',
      LongBallPct: 'Porcentaje de pases largos completados (más de 32 metros) con éxito',
      LongBallTotal: 'Número total de pases de más de 32 metros.',
      SavesPct: 'Porcentaje de paradas respecto al total de remates recibidos',
      SavesInBoxPct: 'Porcentaje de paradas a remates realizados dentro del área',
      SavesOutOfBoxPct: 'Porcentaje de paradas a remates realizados fuera del área',
      xGSavedPerXGFacedOnTarget: 'Coeficiente que indica el porcentaje de los xG esperados detenidos por el portero. Cuanto más cerca de 1, más difícil es marcar',
      xGFacedOnTargetPerGoalReceived: 'Métrica que indica cuántos Goles Esperados son necesarios para hacer un gol al portero. Una puntuación alta en esta métrica significa que para convertir un gol a este Portero es necesario tener un alto xG',
      xGFacedOnTargetEfficiency: 'Número de goles evitados por el portero. Número de Goles Esperados (solo remates a portería) menos los goles encajados por el portero. Indicate el número de goles evitados gracias al portero.',
      xGFacedOnTarget: 'Total de xG (parado y encajado) recibido por el portero',
      IndividualPressure: 'Modelo que cuantifica la presión que el jugador sin balón ejerce sobre el oponente. El modelo mide el número de esfuerzos que hace el jugador del equipo defensor al oponente en las últimas tres quintas partes del campo, tanto como si se recupera el balón como si no. Cuanto mayor es el número de presión, menos se le permite crear al oponente y por lo tanto la presión es mayor.',
      AerialEfficiency: 'Modelo que combina porcentaje de éxito en duelos aéreos junto con el volumen de duelos aéreos ganados',
      AerialWins: 'Número de duelos aéreos ganados por el jugador',
      AerialWinsPct: 'Número de duelos aéreos que el jugador gana del total de duelos aéreos realizados',
      xG: 'Goles Esperados generados. Esta métrica mide el porcentaje de probabilidad de un tiro en acabar en gol basado en las diferentes variables de dicho tiro.',
      xGDiff: 'Diferencia entre xG y los goles marcados',
      xGOpenPlay: 'Goles Esperados generados en jugadas',
      xGSetPiece: 'Goles esperados creados solamente en jugadas a balón parado',
      xGPerShot: 'Goles Esperados por tiro. Esta métrica mide la peligrosidad media del disparo recibido. Cuanto mayor sea, más probabilidades hay de que los disparos terminen siendo gol. Un valor alto implica que el jugador elige bien sus remates si provienen de dentro del área y van a puerta',
      ChancesCreated: 'Número de pases que finalizan en un tiro a portería',
      CompletedCrosses: 'Centros completados',
      Crossing: 'Porcentaje de centros completos con éxito',
      OpenPlayKeyPasses: 'Número de pases completados en juego que acaban en tiro (excluyendo asistencias)',
      OpenPlayKeyPassesInTeam: 'Porcentaje del número de pases completados en juego que acaban en tiro (excluyendo asistencias) respecto al total de su equipo',
      OpenPlayPassesIntoOpponentBox: 'Pases totales al área rival en juego',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Pases completados al área rival en juego',
      xAssists: 'Utilizamos xA, para darle un valor a la asistencia de remate creada por un compañero. Si un jugador da un pase de remate a otro a un metro de la portería, el xA será muy alto pues la peligrosidad del pase es muy alta. Utilizamos el diferencia (xA generados menos xA realizados por el equipo rival para analizar cuantos de los xG son generados por los equipos gracias al juego grupal o al nivel individual. Asistencias Esperadas (xA)',
      xGChain: 'Cantidad de Goles Esperados en los que ha participado el jugador. Si el jugador ha participado en una jugada que acaba en tiro, el xG de la jugada se sumará a esta métrica',
      xGBuildup: 'Similar a Participación xG, pero sin tener en cuenta los dos últimos jugadores de la secuencia (último pasador y rematador)',
      xGBuildupInTeam: 'Similar a Participación xG, pero sin tener en cuenta los dos últimos jugadores de la secuencia (último pasador y rematador) en su equipo',
      BallProgression: 'Número de veces que el jugador avanza el balón 10 metros o más, tanto por pase como por conducción del balón, o por combinación de ambas',
      SuccessfulDribbles: 'Número de regates realizados correctamente',
      Dispossessed: 'Número de pérdidas de balón del jugador (tiene el balón controlado y se lo quitan)',
      TouchesInOpponentBox: 'Número de acciones del jugador dentro del área rival',
      xGSavedPerShot: 'Peligrosidad medio de los remates recibidos a puerta',
      BallRetentionOppHalf: 'Porcentaje de las veces que tienes la posesión de balón y no la terminas perdiendo dentro del campo rival',
      DeepProgression: 'Número de veces que el jugador alcanza el último quinto del campo más el número de veces que el jugador tiene el control del balón en el último quinto',
      DeepProgressionFinalThird: 'Número de veces que el jugador alcanza el último tercio del campo más el número de veces que el jugador tiene el control del balón en el último tercio',
      FoulsTaken: 'Faltas recibidas',
      PenaltiesTaken: 'Penaltis provocados',
      BlockedCrosses: 'Centros bloqueados',
      BlockedShots: 'Remates bloqueados',
      NonPenaltyGoalsAgainst: 'Goles recibidos (excluyendo penaltis)',
      GoalsConceded: 'Número de goles encajados',
      Headers: 'Remates de Cabeza',
      HeadedGoals: 'Número de goles marcados con la cabeza',
      Points: 'Número de puntos conseguidos por el equipo.',
      SavesInBox: 'Número de paradas de remates dentro del área de juego',
      SavesOutBox: 'Número de paradas de remates fuera del área',
      ShotsOnTargetInBoxAgainst: 'Número de remates a puerta desde dentro del área concedidos',
      ShotsOnTargetOutBoxAgainst: 'Número de remates a puerta desde fuera del área concedidos',
      AveragePassDistance: 'Distancia Media de Pases',
      ProgressiveRuns: 'Conducciones que te acercan al área rival. Se considera progresiva si el jugador avanza 30 metros cuando comienza y finaliza en su propio campo; si avanza 15 metros comenzando en su campo y finalizando en el del oponente, o si avanza 10 metros comenzando y finalizando en campo rival',
      xT: 'Peligro Esperado (xT). Es una métrica que mide el peligro que un jugador crea al equipo rival llevando el balón, tanto por conducción como por pases, a áreas donde la probabilidad de que la posesión acabe en gol es mayor',
      xTOpenPlay: 'Peligro Esperado que proviene de jugadas y no a balón parado',
      xTSetPiece: 'Peligro Esperado que proviene de balón parado y no de jugadas',
      xGOT: 'Goles esperados a puerta. Número de goles esperados afrontados por el portero. Está métrica solo tiene en cuenta remates a puerta (Remates fuera y al palo se excluyen)',
      BadActions: 'Conjunto de acciones fallidas (pase, regate, pérdida de balón, pase a fuera de juego, toque de balón) que provocan pérdidas',
      BadActionsOwnHalf: 'Conjunto de acciones fallidas (pase, regate, pérdida de balón, pase a fuera de juego, toque de balón) que provocan pérdidas en campo propio',
      AerialsWonOwnBox: 'Duelos Aéreos Ganados en Área Propia',
      AerialsWonOppBox: 'Duelos Aéreos Ganados en Área Rival',
      AerialsTotalOppBox: 'Total de Duelos Aéreos en Área Rival',
      AerialsTotalOwnBox: 'Total de Duelos Aéreos en Área Propia',
      FoulsOwnHalfPct: '% Faltas en Campo Propio',
      RecoveriesOppHalf: 'Número de balones recuperados por el jugador en campo contrario',
      DuelsPct: '% Duelos Exitosos',
      TacklesUnsuccessful: 'Número de veces que un jugador es regateado en un duelo',
      TacklesWasDribbledFirstThird: '1vs1 Defensivos Ganados en el último tercio',
      TacklesWasDribbledSecondThird: '1vs1 Defensivos Ganados ⅔',
      TacklesWasDribbledFinalThird: '1vs1 Defensivos Ganados Último ⅓',
      BallProgressionFinalThird: 'Progresiones de Balón en el Último tercio',
      DuelsTotal: 'Número total de Entradas, Duelos Aéreos, Toques de Balón, Regates y Faltas cometidas',
      QuickRecoveries: 'Recuperaciones a 40 metros o más de la propia portería en los siguientes 8 segundos después de pérdida',
      ShotsPerNPG: 'Número de Remates por Gol sin Penaltis',
      ShotsOutBox: 'Remates desde Fuera del Área',
      GoalsOutBox: 'Goles desde Fuera del Área',
      ShootingOutBox: 'Porcentaje de Remates a Puerta  de remates desde Fuera del Área',
      HandPassing: 'Porcentaje de Pases completados con la Mano',
      Catching: 'Porcentaje de Paradas Atrapadas',
      Caught: 'Paradas donde el portero atrapa y retiene el balón, impidiendo cualquier segunda jugada',
      ClaimAccuracy: 'Mide como de bueno es un Portero por el aire. Un número mayor que uno indica que el Portero intercepta más balones aéreos de los esperados',
      HighTurnovers: 'Pérdidas a menos de 40 metros de la propia portería',
      ShotEndingHighTurnovers: 'Pérdidas a menos de 40 metros de la portería propia que acaban en tiro',
      GoalEndingHighTurnovers: 'Pérdidas a menos de 40 metros de la portería propia que acaban en tiro que acaban en gol',
      AverageCarriesProgress: 'Distancia media de conducciones verticales (en metros)',
      ChanceEndingCarries: 'Conducciones de al menos 7 metros que acaban en pase seguido de tiro',
      AssistEndingCarries: 'Conducciones de al menos 7 metros que acaban en pase asistencia',
      ShotEndingCarries: 'Conducciones de al menos 7 metros que acaban en pase tiro',
      GoalEndingCarries: 'Conducciones de al menos 7 metros que acaban en pase gol',
      ShotEndingSequence: 'Posesión acabada en Tiro participada por el jugador',
      GoalEndingSequence: 'Posesión acabada en Gol participada por el jugador',
      xGPerNPG: 'Goles esperados generados a favor por cada gol anotado sin contabilizar penaltis',
      AerialWonOffensive: 'Número de duelos aéreos ganadados en jugadas ofensivas',
      AerialWonDefensive: 'Número de duelos aéreos ganadados en jugadas defensivas',
      xGAgainst: 'Goles esperados generados por el rival',
      xGDiffAgainst: 'Diferencia entre goles esperados concedidos y goles concedidos',
      xGPerNPGAgainst: 'Goles esperados recibidos en contra por cada gol recibido sin contabilizar penaltis',
      xGSetPieceAgainst: 'Goles Esperados Recibidos a Balón Parado',
      xGOpenPlayAgainst: 'Goles esperados generados por juego abierto concedidos',
      xGPerShotAgainst: 'xG Medio de cada remate recibido',
      ShotsAgainst: 'Remates en contra',
      ShotsOnTargetAgainst: 'Remates a puerta en contra',
      RivalPossession: 'Posesión del Rival',
      AerialDefensivePct: 'Porcentaje de duelos aéreos defensivos ganados',
      HighRecoveries: 'Recuperaciones de balón a menos de 40 metros del área rival',
      HighDefensiveActions: 'Acciones Defensivas (Tackles, Intercepciones, Bloqueos, Faltas Cometidas y 1vs1) del total por encima de 40m de la línea de fondo propia',
      HighDefensiveActionPct: 'Porcentaje de Acciones Defensivas (Tackles, Intercepciones, Bloqueos, Faltas Cometidas y 1vs1) del total por encima de 40m de la línea de fondo propia',
      HighDefensiveDistance: 'Distancia media respecto de la propia portería de todas las acciones defensivas',
      PassesPerPossession: 'Pases por Posesión',
      LengthPerPossession: 'Distancia por Posesión',
      xTNet: 'Peligro Esperado Neto',
      AvgCarriesDistance: 'Distancia media de conducciones',
      PassesForwardPct: 'Porcentaje de pases hacia delante sobre el total',
      PassesForwardSuccessful: 'Pases hacia delante realizados con éxito',
      PassesForwardTotal: 'Total de pases hacia delante intentados',
      TacklesAttempted: 'Número total de tackles intentados',
      DuelsLost: 'Duelos Perdidos',
      Carries: 'Conducciones',
      CarriesPct: '% Conducciones',
      Aerials: 'Duelos Aéreos',
      ProgressivePassesReceivedIntoBox: 'Pases Progresivos Recibidos en el Área',
      PassesOppHalf: 'Número total de pases exitosos que finalizan en campo contrario',
      ShotsOnTarget: 'Remates a puerta',
      AggressiveActions: 'Tackles intentados en los siguientes 2 segundos después de pérdida',
      Crosses: 'Centros totales',
      xGBuildup5pass: 'Construcción xG en los últimos 5 pases (excluyendo remates y pases que preceden al tiro)',
      DefensiveDistance: 'Promedio de la distancia respecto a la propia portería de los duelos defensivos realizados',
      SpeedSequence: 'Velocidad del movimiento del balón en la posesión',
      Touches: 'Número de acciones del jugador',
      AerialsTotalOppHalf: 'Duelos aéreos totales en campo del rival',
      AerialsWonOppHalf: 'Duelos aéreos ganados en campo del rival',
      AerialsWonOppHalfPct: 'Porcentaje de duelos aéreos ganados respecto al total de duelos aéreos producidos en campo del rival',
      AerialsPctOppBox: 'Porcentaje de duelos aéreos ganados respecto al total de duelos aéreos producidos en el área rival',
      AerialsPctOwnBox: 'Porcentaje de duelos aéreos ganados respecto al total de duelos aéreos producidos en el área propia',
      AerialDefensive: 'Número total de duelos aéreos cuando el equipo contrario tiene la posesión',
      AerialOffensive: 'Número total de duelos aéreos cuando el equipo propio tiene la posesión',
      AerialOffensivePct: 'Porcentaje de duelos aéreos ganados cuando el equipo propio tiene la posesión',
      IndividualPressureOppHalf: 'Modelo que cuantifica el número de esfuerzos con éxito de un jugador ejerce en campo del rival durante presión',
      ChancesCreatedOP: 'Número de pases en jugada, que finalizan en un tiro a portería',
      TouchesPerShot: 'Número de acciones realizadas por cada remate',
      PassesFinalThirdTotalPct: 'Porcentaje de pases (exitosos y no) realizados en el último tercio del campo',
      xACrosses: 'Asistencias esperadas generadas a partir de centros',
      Passes: 'Total de pases realizados',
      PassesSuccessful: 'Pases Completados con Éxito',
      TacklesWasDribbledFouls: 'Porcentaje de tackles ganados respecto al total de tackles y faltas cometidas',
      OffsidesCaught: 'Fueras de Juego',
      ProgressivePassesReceivedFinalThird: 'Pases Progresivos Recibidos Último ⅓',
      ProgressivePassesReceived: 'Pases Progresivos Recibidos',
      Breadth: 'Número total de tackles, regates recibidos, intercepciones y faltas cometidas, en los laterales del campo',
      DuelsDefTotal: 'Suma de tackles totales, duelos aéreos defensivos y faltas cometidas',
      DefensiveActions: 'Acciones defensivas cuando un oponente intenta regatear (Tackles totales, intercepciones y faltas)',
      ProgressivePassesReceivedOppHalf: 'Pases Progresivos Recibidos en Campo Rival',
      CompletedCrossesOP: 'Centros Completados en Jugada',
      CrossingOP: 'Porcentaje de centros completados respecto al total de ellos en jugada',
      CrossesOP: 'Total de centros intenatados en jugada',
      PassingContribution: 'Porcentaje que mide la peligrosidad y valor añadido de los pases teniendo en cuenta la posición del receptor',
      BallProgressionOppHalfInTeam: 'Porcentaje de Progresión de balón en campo rival del total de su equipo',
      PassesOPIntoBoxInTeam: 'Porcentaje de Pases en juego al área rival del total de su equipo',
      TouchesOppBoxInTeam: 'Porcentaje de toques de balón en el área rival del total de su equipo',
      xGOPInTeam: 'Porcentaje de goles esperados generados en juego del total de su equipo',
      DeepPasses: 'Pases desde fuera de un radio de 20 metros de la portería rival que finalizan con éxito dentro del mismo',
      DeepPassesTotal: 'Total de pases intentados desde fuera de un radio de 20 metros de la portería rival que finalizan dentro del mismo',
      DefensiveDuelsPct: 'Porcentaje de duelos defensivos ganados entre duelos defensivos totales',
      QuickRecoveriesPct: 'Porcentaje de recuperaciones rápidas entre intercepciones y tackles intentados',
      DiffDefensiveDistanceTeam: 'Diferencia entre la distancia defensiva del jugador y la de su equipo',
      xTPassing: 'Peligro esperado generado solamente a partir de pases',
      xTPassing100Passes: 'Peligro esperado generado solamente a partir de pases y por cada 100 pases',
      ProgressivePassesAccurate: 'Pases completados de 10 o más metros hacia la portería rival',
      PassAbility: 'Relación entre los pases completados y los pases esperados (xP)',
      OPPassesIntoOppBoxPct: 'Porcentaje de pases al área rival en jugada completados y los totales',
      EntriesOppBox: 'Suma de pases y conducciones al área rival',
      Crosses6yardBox: 'Número total de centros que terminan en el área pequeña',
      Cutbacks: 'Pases desde línea de fondo hacia atrás y al área',
      xTDribbling: 'xT generado solamente a partir de regates',
      AvgShotDistance: 'Promedio de la distancia del total de remates efectuados',
      xGOnTarget: 'Goles Esperados a puerta. A diferencia de los Goles Esperados, este modelo mide la probabilidad de que un tiro acabe en gol teniendo en cuenta de la dirección del tiro',
      FinishingxGOT: 'Porcentaje de remates a puerta sobre la media que acaban en gol utilizando el modelo de Goles Esperados a Puerta. Esta métrica mide cuánto valor añadido suma el delantero con la calidad de sus disparos, midiendo el porcentaje de goles convertidos en relación a sus disparos a puerta',
      DribblesWonOwnHalf: 'Número de regates con éxito realizados en campo propio',
      DribblesOwnHalf: 'Número de regates intentados en campo propio',
      DribblesOwnHalfPct: 'Porcentaje de regates con éxito respecto del total realizados en campo propio',
      DribblesWonOppHalf: 'Número de regates exitosos realizados en campo contrario',
      DribblesOppHalf: 'Número de regates intentados en campo contrario',
      DribblesOppHalfPct: 'Porcentaje de regates con éxito respecto del total realizados en campo contrario',
      DribblesWonFinalThird: 'Número de regates realizados correctamente en el último tercio del campo',
      DribblesFinalThird: 'Número de regates intentados en el último tercio del campo',
      DribblesFinalThirdPct: 'Porcentaje de regates exitosos respecto del total realizados en el último tercio del campo',
      ShotEndingHighRecoveries: 'Recuperaciones de balón a menos de 40 metros del área rival que terminan en tiro',
      PassingFinalThirdAgainst: 'Número de pases completados concedidos que acaban en el primer tercio del campo propio',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Pases intentados concedidos al área propia sin contar a balón parado',
      EntriesOppBoxAgainst: 'Suma de pases y conducciones concedidas al área propia',
      DeepProgressionAgainst: 'Número de veces que el rival alcanza el primer quinto del campo propio mediante conducciones o control del balón',
      TouchesInOpponentBoxAgainst: 'Número de acciones del rival concedidas dentro del área propia',
      Score: 'Rendimiento del jugador basado en diferentes métricas',
      PDScore: 'Rendimiento físico del jugador basado en diferentes métricas físicas',
      SpeedScore: 'Rendimiento físico del jugador basado en diferentes métricas de velocidad y potencia',
      EnduranceScore: 'Rendimiento físico del jugador basado en diferentes métricas de resistencia',
      OrlegiScore: 'Rendimiento del jugador basado en diferentes métricas',
      SirScore: 'Rendimiento del jugador basado en diferentes métricas',
      ExcScore: 'Rendimiento del jugador basado en diferentes métricas',
      xTOPInTeam: 'Peligro esperado (xT) generado en juego respecto al total de su equipo',
      YellowCards: 'Tarjetas amarillas recibidas',
      RedCards: 'Tarjetas rojas recibidas',
      xTOpenPlayAgainst: 'Peligro Esperado concedido que proviene de jugadas y no a balón parado',
      xTSetPieceAgainst: 'Peligro Esperado concedido que proviene de balón parado y no de jugadas',
      NPGOpenPlayAgainst: 'Goles sin penaltis concedidos en jugada',
      NPGSetPieceAgainst: 'Goles sin penaltis concedidos generados a balón parado, excluyendo goles de penalti',
      PassesOppHalfPerPossession: 'Pases Campo Contrario por Posesión',
      AverageTimeRecovery: 'Tiempo Medio Recuperación',
      ExpectedPassing: 'Porcentaje de pases que se deberían haber completado',
      NumPossession10Passes: 'Posesiones 10 Pases',
      PassesReceived: 'Pases Recibidos',
      PassesReceivedFinalThird: 'Pases Recibidos Último ⅓',
      ProgressivePassesTotalPct: 'Porcentaje de pases progresivos completados respecto al total de pases progresivos',
      ShortPassesPct: 'Porcentaje Pases Cortos',
      TouchesOppBoxOppTeam: 'Número de acciones del rival concedidas dentro del área propia cuando el jugador está en el campo',
      ShotsOnTargetOppTeam: 'Remates a puerta concedidos cuando el jugador está en el campo',
      NPGOppTeam: 'Goles sin contar penaltis recibidos cuando el jugador está en el campo',
      xGSetPiecePerxG: 'Goles esperados generados a balón parado necesarios para generar un gol esperado',
      ShotsOpenPlay: 'Número de remates generados en jugada',
      ShotsOpenPlayAgainst: 'Número de remates recibidos en jugada',
      ShotsFromDribble: 'Disparos realizados tras regatear a un oponente',
      GoalsFromDribble: 'Goles marcados tras regatear a un oponente',
      PassesIntoFinalThird: 'Pases exitosos desde fuera hacia dentro del tercio final',
      PassesIntoFinalThirdTotal: 'Total de pases intentados desde fuera hacia dentro del tercio final',
      PassesInsideFinalThird: 'Pases exitosos dentro del tercio final (inicio y fin en el tercio final)',
      PassesInsideFinalThirdTotal: 'Total de pases intentados dentro del tercio final (inicio y fin en el tercio final)',
      PassesFinalThirdNoArea: 'Pases exitosos que terminan en el tercio final (excluyendo el área)',
      PassesIntoOppBox: 'Pases exitosos que terminan en el área rival',
      CarriesFinalThird: 'Conducciones de al menos 7 metros que terminan en el tercio final',
      CarriesInsideFinalThird: 'Conducciones de al menos 7 metros dentro del tercio final (inicio y fin en el tercio final',
      CarriesFinalThirdNoBox: 'Conducciones de al menos 7 metros que terminan en el tercio final (excluyendo el área)',
      CarriesIntoOppBox: 'Conducciones de al menos 7 metros que terminan en el área rival',
      TimePossessionAgainst: 'Tiempo de posesión del balón del equipo rival',
      TimePossessionTotal: 'Tiempo de posesión del balón de ambos equipos',
      PassesInBox: 'Pases exitosos con origen dentro del área rival',
      LongThrowInSuccessful: 'Saque de banda largo exitoso desde la banda, diseñado para lanzar el balón más de 20 metros',
      LongThrowInTotal: 'Total de saques de banda largos desde la banda, diseñados para lanzar el balón más de 20 metros',
      LongThrowInPct: 'Porcentaje de saques de banda largos (más de 20 metros) que son exitosos',
      Games: 'Juegos jugados',
      PointsPerGame: 'Puntos por juego',
      ExpectedPointsDiff: 'Diferencia de puntos esperada',
      PassesTotalOwnHalf: 'Número total de pases que terminan en el propio campo',
      PassesOwnHalf: 'Número de pases exitosos que terminan en el propio campo',
      PassesTotalOppHalf: 'Número total de pases intentados que finalizan en campo contrario',
      ProgressivePassesTotal: 'Número total de pases de 10 metros o más en el eje X',
      DuelsWon: 'Duelos exitosos (Entradas, Aéreos, Toques de Balón, Regates y Faltas cometidas)',
      NonPenaltySaves: 'Paradas excluyendo remates de penalti',
      BadActionsOppHalf: 'Suma de todas las malas acciones cometidas (pase fallido, recepción fallida, desposeimiento, pase en fuera de juego, toque de balón fallido) en el campo contrario',
      CarriesSuccessful: 'Número de conducciones de al menos 7 metros que finalizan con un evento exitoso',
      CarriesIntoFinalThird: 'Conducciones de al menos 7 metros desde fuera hacia dentro del tercio final',
      ShotsOnTargetOutBox: 'Disparos a portería desde fuera del área',
      SwitchPlaySuccessful:'Número de pases completados de más de 32 metros en los que el desplazamiento lateral del balón es mayor que el desplazamiento en dirección a la portería contraria',
      SwitchPlayTotal:'Número total de pases intentados de más de 32 metros en los que el desplazamiento lateral del balón es mayor que el desplazamiento en dirección a la portería contraria',
      PassesInsideOppHalf:'Número total de pases que comienzan y terminan en campo contrario',
      PassesInsideOppHalfSuccessful:'Número de pases completados que comienzan y terminan en campo contrario',
      TacklesAttemptedFirstThird:'Número total de tackles intentados en el primer tercio del terreno de juego',
      TacklesAttemptedSecondThird:'Número total de tackles intentados en el segundo tercio del terreno de juego',
      TacklesFirstThird:'Número de tackles realizados con éxito en el primer tercio del terreno de juego',
      TacklesSecondThird:'Número de tackles realizados con éxito en el segundo tercio del terreno de juego',
      FoulsOwnHalf:'Número de faltas cometidas en campo propio',
      TouchesOppHalf:'Número de toques de balón realizados en campo contrario',
      TacklesAttemptedNotAdjusted:'Número total de tackles intentados, sin ajuste en función de la posesión',
      TacklesSuccessfulNotAdjusted:'Número total de tackles realizados con éxito, sin ajuste en función de la posesión',
      // Physical Stats
      TotalDistance: 'Distancia total recorrida por el jugador durante un partido',
      WalkingDistance: 'Distancia total recorrida por el jugador durante un partido a una velocidad menor de 2 m/s (7.2 km/h)',
      JoggingDistance: 'Distancia total recorrida por el jugador durante un partido a una velocidad entre 2 m/s (7.2 km/h) y 4 m/s (14.4 km/h)',
      RunningDistance: 'Distancia total recorrida por el jugador durante un partido a una velocidad entre 4 m/s (14.4 km/h) y 5.5 m/s (19.8 km/h)',
      ExtremeAccelerations: 'Número de veces que el jugador acelera a más de 3 m/s²',
      NumberOfRuns: 'Número de carreras completadas a una velocidad entre 4 m/s (14.4 km/h) y 5.5 m/s (19.8 km/h)',
      DistanceTIP: 'Distancia (Equipo en Posesión) que el jugador ha recorrido durante un partido con posesión',
      DistanceOTIP: 'Distancia OTIP (Equipo Oponente en Posesión) que el jugador ha recorrido durante un partido sin posesión',
      HsrNumber: 'Número de veces que el jugador se mueve a una velocidad igual o superior a 5.5 m/s (19.8 km/h) pero inferior a 7 m/s (25.2 km/h) durante al menos 1 segundo',
      HsrDistance: 'Distancia total recorrida por el jugador durante un partido a una velocidad igual o superior a 5.5 m/s (19.8 km/h) pero inferior a 7 m/s (25.2 km/h)',
      HsrDistancePct: 'Porcentaje de la distancia de carrera a alta velocidad (HSR) respecto a la distancia total recorrida',
      SprintsNumber: 'Número de veces que el jugador se mueve a una velocidad igual o superior a 7 m/s (25.2 km/h) durante al menos 1 segundo',
      SprintsDistance: 'Distancia total recorrida por el jugador durante un partido a una velocidad igual o superior a 7 m/s (25.2 km/h)',
      SprintNumberDeclinePct: 'Porcentaje de disminución en el número de sprints realizados en comparación con la segunda mitad del partido',
      SprintDistanceDeclinePct: 'Porcentaje de disminución en la distancia recorrida durante los sprints en comparación con la segunda mitad del partido',
      SprintNumberDecline: 'Disminución en el número de sprints realizados en comparación con la segunda mitad del partido',
      SprintDistanceDecline: 'Disminución en la distancia recorrida durante los sprints en comparación con la segunda mitad del partido',
      SprintDistancePct: 'Porcentaje de la distancia de sprint respecto a la distancia total recorrida',
      Accelerations: 'Número de veces que el jugador acelera entre 1.5 m/s² y 3 m/s²',
      ExplosiveDistance: 'Distancia explosiva',
      MaxSpeed: 'Velocidad máxima alcanzada por el jugador',
      AvgMaxSpeed: 'Promedio de la velocidad máxima alcanzada por el jugador',
      MaxAccelerations: 'Máxima aceleración en metros/segundo² lograda por el jugador',
      // Arrigo
      BypassedPlayersByPasses: 'Número de jugadores del lado del gol del portador del balón al comienzo del evento de toque, menos el número de jugadores del lado del gol al final del evento',
      BypassedDefendersByPasses: 'Número de defensores del lado del gol del portador del balón al comienzo del evento de toque, menos el número de defensores del lado del gol al final del evento',
      PassesBypassingPlayers: 'Número de pases que superaron a jugadores',
      PassesBypassingDefenders: 'Número de pases que superaron a defensores',
      BypassedPlayersPerPass: 'Número total de jugadores superados por pase',
      BypassedDefendersPerPass: 'Número total de defensores superados por pase',
      LineBreakingPasses: 'Pases completados que avanzan el balón al menos un 10% más cerca de la portería contraria e intersectan un par de defensores en proximidad o pasan detrás de la línea defensiva',
      LineBreakingPassesMD: 'Pases completados que atraviesan las líneas media y defensiva',
      LineBreakingPassesM: 'Pases completados que atraviesan la línea de mediocampistas',
      LineBreakingThroughBalls: 'Pases completados que atraviesan la línea defensiva',
      LineBreakingPassesPerPass: 'Porcentaje de pases completados entre líneas por cada pase realizado',
      TotalPassesUnderStrongPressure: 'Número total de pases realizados bajo fuerte presión (dentro de 0-2 metros del oponente más cercano)',
      TotalPassesUnderLightPressure: 'Número total de pases realizados bajo presión (dentro de 2-4 metros del oponente más cercano)',
      SuccessfulPassesUnderStrongPressure: 'Número de pases exitosos realizados bajo fuerte presión (dentro de 0-2 metros del oponente más cercano)',
      SuccessfulPassesUnderLightPressure: 'Número de pases exitosos realizados bajo presión (dentro de 2-4 metros del oponente más cercano)',
      PassingUnderStrongPressure: 'Porcentaje de pases exitosos y totales realizados bajo fuerte presión (dentro de 0-2 metros del oponente más cercano)',
      PassingUnderLightPressure: 'Porcentaje de pases exitosos y totales realizados bajo presión (dentro de 2-4 metros del oponente más cercano)',
      PassReceiptsInSpaceCompleted: 'Pases completados donde el receptor está en la mitad de ataque y no tiene defensores a un radio de 5 metros en dirección a la portería',
      PassReceiptsInSpace: 'Pases recibidos en la mitad de ataque sin defensores a un radio de 5 metros en dirección al gol',
      PassReceiptsInSpaceCompletedFirstThird: 'Pases realizados donde el receptor está en el primer tercio y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedSecondThird: 'Pases realizados donde el receptor está en el segundo tercio y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedFinalThird: 'Pases realizados donde el receptor está en el último tercio y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Pases realizados donde el receptor está en campo rival (lado derecho) y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Pases realizados donde el receptor está en campo rival (zona central) y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Pases realizados donde el receptor está en campo rival (lado izquierdo) y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceFirstThird: 'Pases recibidos en el primer tercio donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceSecondThird: 'Pases recibidos en el segundo tercio donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceFinalThird: 'Pases recibidos en el último tercio donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceOppHalfRight: 'Pases recibidos en campo rival (lado derecho) donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceOppHalfCenter: 'Pases recibidos en campo rival (zona central) donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceOppHalfLeft: 'Pases recibidos en campo rival (lado izquierdo) donde no hay defensores a menos de 5 metros en dirección a la portería',
      TotalStrongOnBallPressures: 'Número de presiones fuertes sobre el balón (dentro de 0-2 metros del portador del balón)',
      TotalLightOnBallPressures: 'Número de presiones sobre el balón (dentro de 2-4 metros del portador del balón)',
      SuccessfulStrongOnBallPressures: 'Número de presiones fuertes exitosas sobre el balón (dentro de 0-2 metros)',
      SuccessfulLightOnBallPressures: 'Número de presiones exitosas sobre el balón (dentro de 2-4 metros)',
      StrongOnBallPressuresPct: 'Porcentaje de presiones fuertes exitosas y totales sobre el balón (dentro de 0-2 metros del oponente más cercano)',
      LightOnBallPressuresPct: 'Porcentaje de presiones exitosas y totales sobre el balón (dentro de 2-4 metros del oponente más cercano)',
      TimesBypassedByPasses: 'Número total de veces que ha sido superado por pase',
      TimesBypassedByCarries: 'Número total de veces que ha sido superado por conducción',
      TimesBypassedByActions: 'Número total de veces que ha sido superado por pases y conducciones',
      BypassedPlayersByCarries: 'Número total de rivales (defensores y mediocampistas) superados mediante conducciones',
      BypassedDefendersByCarries: 'Número total de rivales (defensores) superados mediante conducciones',
      BypassedPlayersByActions: 'Número total de rivales (defensores y mediocampistas) superados mediante pases y conducciones combinados',
      BypassedDefendersByActions: 'Número total de rivales (defensores) superados mediante pases y conducciones combinados',
      CarriesBypassingPlayers: 'Número de conducciones que superaron jugadores',
      CarriesBypassingDefenders: 'Número de conducciones que superaron defensores',
      BypassedPlayersPerCarry: 'Promedio de rivales superados por conducción',
      BypassedDefendersPerCarry: 'Promedio de defensores superados por conducción',
      LineBreakingCarries: 'Número de conducciones que penetraron con éxito una o más líneas defensivas',
      LineBreakingCarriesMD: 'Número de conducciones que penetraron con éxito líneas de mediocampistas y defensores',
      LineBreakingCarriesM: 'Número de conducciones que penetraron con éxito la línea de mediocampistas',
      LineBreakingCarriesD: 'Número de conducciones que penetraron con éxito la línea defensiva',
      LineBreakingCarriesPerCarry: 'Porcentaje de conducciones entre líneas por conducción',
      LineBreakingActions: 'Número de pases y conducciones combinados que penetraron con éxito una o más líneas defensivas',
      LineBreakingActionsMD: 'Número de pases y conducciones combinados que penetraron con éxito líneas de mediocampistas y defensores',
      LineBreakingActionsM: 'Número de pases y conducciones combinados que penetraron con éxito la línea de mediocampistas',
      LineBreakingActionsD: 'Número de pases y conducciones combinados que penetraron con éxito la línea defensiva',
      PassesPerLineBreakingPass: 'Relación entre el número total de pases por pase entre líneas',
      CarriesPerLineBreakingCarry: 'Relación entre el número total de conducciones por conducción entre líneas',
      LinesBrokenByPasses: 'Número total de líneas superadas mediante pases',
      LinesBrokenByCarries: 'Número total de líneas superadas mediante conducciones',
      LinesBrokenByActions: 'Número total de líneas superadas mediante pases y conducciones combinados',
      LinesBrokenPerPass: 'Relación entre el número total de líneas superadas por cada pase realizado',
      LinesBrokenPerCarry: 'Relación entre el número total de líneas superadas por cada conducción realizada',
      AvgLastDefenderDistanceIP: 'Distancia entre el último defensor (más cercano a la propia portería) y la línea de gol con posesión',
      AvgLastDefenderDistanceOOP: 'Distancia entre el último defensor (más cercano a la propia portería) y la línea de gol sin posesión',
      AvgDefensiveLineDistanceIP: 'Distancia entre la posición de la línea defensiva más profunda y la portería con posesión',
      AvgDefensiveLineDistanceOOP: 'Distancia entre la posición de la línea defensiva más profunda y la portería sin posesión',
      AvgRBDistanceIP: 'Distancia del lateral derecho a su propia portería cuando está con posesión',
      AvgRBDistanceOOP: 'Distancia del lateral derecho a su propia portería cuando está sin posesión',
      AvgLBDistanceIP: 'Distancia del lateral izquierdo a su propia portería cuando está con posesión',
      AvgLBDistanceOOP: 'Distancia del lateral izquierdo a su propia portería cuando está sin posesión',
      AvgBlockDistanceIP: 'Distancia entre el jugador de campo más profundo y el más adelantado con posesión',
      AvgBlockDistanceOOP: 'Distancia entre el jugador de campo más profundo y el más adelantado sin posesión',
      AvgBlockAreaIP: 'El área que rodea a todos los jugadores de campo (una medida de cuánto espacio ocupan los jugadores de campo) con posesión',
      AvgBlockAreaOOP: 'El área que rodea a todos los jugadores de campo (una medida de cuánto espacio ocupan los jugadores de campo) sin posesión',
      AvgDefensiveLineWidthOOP: 'Anchura de la línea de jugadores más atrasada (más cerca de su propia portería) cuando defienden',
      AvgOffensiveLineLastThirdWidthIP: 'Anchura horizontal de la línea ofensiva cuando están con posesión',
      AvgLByIP: 'Posición del lateral izquierdo cuando está con posesión',
      AvgRByIP: 'Posición del lateral derecho cuando está con posesión',
      AvgOffensiveLineDistanceIP: 'Distancia entre la propia portería y la línea ofensiva cuando está con posesión',
      AvgOffensiveLineLastThirdDistanceIP: 'Distancia entre el último tercio del campo y la línea ofensiva cuando está con posesión',
      AvgOffensiveLineWidthIP: 'Anchura horizontal de la línea ofensiva cuando está con posesión',
      OffBallRuns: 'Movimientos intencionados del jugador sin balón (desmarques), con la intención de apoyar la fase de ataque',
      OffBallRunsOverlap: 'Desmarques en los que el jugador corre alrededor de su compañero por el exterior (más cerca de la línea de banda) mientras ese compañero tiene el balón',
      OffBallRunsUnderlap: 'Desmarques en los que el jugador corre por dentro de su compañero, pasando por el lado interior (más cerca del centro del campo)',
      OffBallRunsRunAhead: 'Carrera hacia delante que avanza más allá del portador del balón, pero se mantiene delante del último defensor',
      OffBallRunsRunBehind: 'Carrera hacia delante que penetra en la última línea defensiva, posicionándose entre los defensas y el portero',
      OffBallRunsCrossReceiver: 'Un jugador corre hacia el área y se coloca en posición de recibir un centro de un compañero',
      OffBallRunsSupport: 'El jugador corre para unirse a la línea del portador del balón, ofreciendo una opción de pase cercana en ataque',
      OffBallRunsComingShort: 'El jugador corre hacia el portador del balón para ofrecer un apoyo cercano o una opción de pase lejos de la portería',
      AvgTop5MaxSpeed:'Promedio de las cinco velocidades máximas más altas alcanzadas por el jugador',
      LBPReceived:'Número de pases de ruptura de líneas recibidos. Se consideran aquellos pases completados que acercan el balón al menos un 10% a la portería contraria e intersectan un par de defensores próximos entre sí o superan la línea defensiva',
      LBPMReceived:'Número de pases recibidos que atraviesan la línea de mediocampistas rival',
      LBPMDReceived:'Número de pases recibidos que atraviesan tanto la línea de mediocampistas como la línea defensiva rival',
      ThroughBallReceived:'Número de pases recibidos que atraviesan la última línea defensiva rival',
      HsrDistanceIP: 'Distancia en sprints >21 km/h en posesión',
      HsrDistanceOOP: 'Distancia en sprints >21 km/h sin posesión',
      JoggingDistanceIP: 'Distancia trotando en posesión',
      JoggingDistanceOOP: 'Distancia trotando sin posesión',
      RunningDistanceIP: 'Distancia corriendo en posesión',
      RunningDistanceOOP: 'Distancia corriendo sin posesión',
      SprintsDistanceIP: 'Distancia en sprints >24 km/h en posesión',
      SprintsDistanceOOP: 'Distancia en sprints >24 km/h sin posesión',
      WalkingDistanceIP: 'Distancia caminando en posesión',
      WalkingDistanceOOP: 'Distancia caminando sin posesión'
    },
    subtitles: {
      Possession: 'Porcentaje de posesión del equipo',
      TimePossession: 'Tiempo de posesión del equipo',
      PassesPerShots: 'Número de pases realizados por cada tiro',
      PPDA: 'Número de pases del equipo rival hasta la pérdida de posesión',
      Directness: 'Verticalidad, como de directo es un equipo en sus pases',
      ExpectedPoints: 'Número de puntos esperados por un equipo, calculados en base a los goles esperados',
      PassesPerLongBall: 'Número de pases realizados por cada pase largo',
      CrossingPerXG: 'Porcentaje de Goles Esperados que vienen de centros al área',
      PenaltySavedPenaltyFaced: 'Porcentaje de penaltis salvados por penaltis recibidos',
      Goals: 'Número de goles anotados',
      PenaltyShots: 'Número total de remates desde el punto de penalti',
      PenaltyGoals: 'Número total de goles desde el punto de penalti',
      NonPenaltyGoals: 'Goles (excluyendo Penaltis)',
      AerialWins: 'Duelos aéreos ganados',
      AerialEfficiency: 'Modelo que combina duelos aéreos ganados con duelos aéreos totales',
      AerialWinsPct: 'Porcentaje de duelos aéreos ganados',
      Assists: 'Número de asistencias',
      Catching: 'Porcentaje de paradas en las que el portero atrapa el balón',
      Caught: 'Parada donde el portero atrapa y retiene el balón, impidiendo cualquier segunda jugada',
      ChancesCreated: 'Número de pases que acaban en tiro',
      ClaimAccuracy: 'Eficiencia a la hora de atajar los centros recibidos',
      CompletedCrosses: 'Centros completados',
      Crossing: 'Porcentaje de centros completados',
      Dispossessed: 'Pérdidas de posesión',
      Finishing: 'Porcentaje de remates que acaban en Gol',
      xGEfficiency: 'Cantidad de Goles Esperados necesarios para que el jugador marque un gol',
      Fouls: 'Faltas cometidas',
      DeepProgression: 'Número de veces que se llega al último quinto del terreno de juego con la posesión del balón, más el número de veces que se tiene la posesión del balón en el último quinto',
      DeepProgressionFinalThird: 'Veces que el jugador tiene posesión en el último tercio',
      FoulsTaken: 'Faltas recibidas',
      IndividualPressure: 'Número de presiones con éxito',
      Interceptions: 'Pases interceptados',
      LongBallPct: 'Porcentaje de pases de al menos 32 metros completados',
      LongBallTotal: 'Número total de pases de más de 32 metros',
      LongBallSuccessful: 'Pases de al menos 32 metros completados',
      NPGOpenPlay: 'Goles marcados en jugada',
      NPGSetPiece: 'Goles marcados generados a balón parado, excluyendo goles de penalti',
      OpenPlayKeyPasses: 'Pases en jugada que acaban en tiro (excluyendo asistencias)',
      OpenPlayKeyPassesInTeam: 'Porcentaje de pases en jugada que acaban en tiro (excluyendo asistencias) respecto al total de su equipo',
      PassingFinalThird: 'Número de pases completados que terminan en el tercio final',
      PassesFinalThirdTotal: 'Número de pases intentados que terminan en el último tercio del campo',
      PassingFinalThirdPct: 'Porcentaje de pases hechos que terminan en el tercio final',
      PassingOppHalfPct: 'Porcentaje de pases con éxito en campo rival',
      PassingOwnHalfPct: 'Porcentaje de pases con éxito en campo propio',
      PassingPct: 'Porcentaje de pases completados con éxito',
      Recoveries: 'Número de balones recuperados por el jugador',
      SavesInBoxPct: 'Porcentaje de paradas dentro del área',
      SavesOutOfBoxPct: 'Porcentaje de paradas fuera del área',
      SavesPct: 'Porcentaje de paradas',
      ScoringContribution: 'Número de Asistencias y Goles',
      xAssistsOpenPlay: 'Número de Asistencias Esperadas que provienen de jugadas y no a balón parado',
      xAssistsSetPiece: 'Número de Asistencias Esperadas que provienen de jugadas a balón parado',
      xAssistsOpenPlayInTeam: 'Número de Asistencias Esperadas que provienen de jugadas y no a balón parado en su Equipo',
      xAssistsSetPieceInTeam: 'Número de Asistencias Esperadas que provienen de jugadas a balón parado en su Equipo',
      xGChainFinalThird: 'Cantidad de Goles Esperados en las que ha participado el jugador en el último tercio',
      xGBuildupFinalThird: 'Cantidad de Goles Esperados en las que ha participado el jugador en el último tercio (excluyendo remates y pases que le preceden)',
      BallProgressionPassing: 'Progresiones de balón a través de pases',
      BallProgressionDribbling: 'Progresiones de balón a través de conducción',
      Shooting: 'Porcentaje de Remates a puerta (excluyendo Penaltis)',
      Shots: 'Número Total de Remates (excluyendo Penaltis)',
      ShotsPerGoal: 'Número medio de Remates a puerta para marcar un Gol',
      ShortPassesSuccessful: 'Número de pases cortos (menos de 12 metros) completados',
      PassingSuccessForwardPct: 'Porcentaje de pases hacia delante con éxito',
      PassingSuccessBackwardPct: 'Porcentaje de pases hacia atrás con éxito',
      PassingForwardBackwardPct: 'Ratio de pases hacia delante respecto a pases hacia atrás',
      LongBallPerPassesPct: 'Porcentaje de balones largos respecto del total de pases',
      LongBallReceived: 'Balones largos de más de 32 metros recibidos',
      LongBallReceivedOppHalf: 'Números de balones largos recibidos en el campo rival',
      OffensiveActions: 'Acciones ofensivas',
      DribblesAttempted: 'Número de regates intentados',
      SuccessfulDribblesPct: 'Regates con éxito/ total de intentos de regate realizados',
      OffensiveTouchesOutBoxPct: '% de toques ofensivos fuera del cuadro',
      SuccessfulDribbles: 'Regates Completados con Éxito',
      TacklesSuccessful: 'Número Total de Tackles con éxito',
      TacklesWasDribbled: 'Porcentaje de duelos ganados con Tackles',
      ThroughBalls: 'Número de Pases cruzando la última línea defensiva',
      TouchesInOpponentBox: 'Número de controles de balón en área rival',
      xAssists: 'Asistencias Esperadas generadas',
      xG: 'Goles Esperados generados',
      xGDiff: 'Diferencia entre xG y los goles marcados',
      xGOpenPlay: 'Goles Esperados generados en jugadas',
      xGSetPiece: 'Goles esperados creados solamente en jugadas a balón parado',
      xGBuildup: 'Construcción xG',
      xGBuildupInTeam: 'Construcción xG en su Equipo',
      BallProgression: 'Progresiones por pases o conducción de más de 10 metros',
      xGChain: 'Participación xG',
      xGPerNPG: 'Media de xG que se necesita para marcar gol (excluyendo penaltis)',
      xGPerShot: 'Media de xG por remate',
      xGSavedPerShot: 'Media de xG parados por remate recibido',
      xGSavedPerXGFacedOnTarget: 'Media de xG parados por xG recibidos a puerta',
      xGFacedOnTargetPerGoalReceived: 'Goles Esperados necesarios para hacer un gol al portero',
      xGFacedOnTargetEfficiency: 'Número de goles evitados por el portero',
      xGFacedOnTarget: 'Total de xG (parado y encajado) recibido por el portero',
      HighTurnovers: 'Pérdidas a menos de 40 metros de la propia portería',
      OpenPlayPassesIntoOpponentBox: 'Pases totales al área rival en juego',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Pases completados al área rival en juego',
      ChancesCreatedOP: 'Número de pases en jugada, que finalizan en un tiro a portería',
      PenaltiesTaken: 'Penaltis provocados',
      BlockedCrosses: 'Centros bloqueados',
      BlockedShots: 'Remates bloqueados',
      NonPenaltyGoalsAgainst: 'Goles recibidos (excluyendo penaltis)',
      Headers: 'Remates de Cabeza',
      AveragePassDistance: 'Distancia Media de Pases',
      ProgressiveRuns: 'Conducciones que te acercan al área rival',
      xT: 'Peligro generado al desplazar el balón a zonas peligrosas',
      xTOpenPlay: 'Peligro Esperado que proviene de jugadas y no a balón parado',
      xTSetPiece: 'Peligro Esperado que proviene de balón parado y no de jugadas',
      xGOT: 'Goles esperados a puerta. Número de goles esperados afrontados por el portero. Está métrica solo tiene en cuenta remates a puerta (remates fuera y al palo se excluyen).',
      BadActions: 'Conjunto de acciones fallidas que provocan pérdidas',
      BadActionsOwnHalf: 'Conjunto de acciones fallidas que provocan pérdidas en campo propio',
      AerialsWonOwnBox: 'Duelos Aéreos Ganados en Área Propia',
      AerialsWonOppBox: 'Duelos Aéreos Ganados en Área Rival',
      AerialsTotalOppBox: 'Total de Duelos Aéreos en Área Rival',
      AerialsTotalOwnBox: 'Total de Duelos Aéreos en Área Propia',
      FoulsOwnHalfPct: '% Faltas en Campo Propio',
      RecoveriesOppHalf: 'Número de balones recuperados por el jugador en campo contrario',
      DuelsPct: '% Duelos Exitosos',
      TacklesUnsuccessful: 'Número de veces que un jugador es regateado en un duelo',
      TacklesWasDribbledFirstThird: '1vs1 Defensivos Ganados en el último tercio',
      TacklesWasDribbledSecondThird: '1vs1 Defensivos Ganados ⅔',
      TacklesWasDribbledFinalThird: '1vs1 Defensivos Ganados Último ⅓',
      BallProgressionFinalThird: 'Progresiones de Balón en el Último tercio',
      DuelsTotal: 'Número total de entradas, duelos aéreos, toques de balón, regates y faltas cometidas',
      QuickRecoveries: 'Recuperaciones a 40 metros o más de la propia portería en los siguientes 8 segundos después de pérdida',
      ShotsPerNPG: 'Número de Remates por Gol sin Penaltis',
      ShotsOutBox: 'Remates desde Fuera del Área',
      GoalsOutBox: 'Goles desde Fuera del Área',
      ShootingOutBox: 'Porcentaje de Remates a Puerta  de remates desde Fuera del Área',
      HandPassing: 'Porcentaje de Pases completados con la Mano',
      ShotEndingHighTurnovers: 'Pérdidas a menos de 40 metros de la portería propia que acaban en tiro',
      GoalEndingHighTurnovers: 'Pérdidas a menos de 40 metros de la portería propia que acaban en tiro que acaban en gol',
      AverageCarriesProgress: 'Distancia media de conducciones verticales (en metros)',
      ChanceEndingCarries: 'Conducciones de al menos 7 metros que acaban en pase seguido de tiro',
      AssistEndingCarries: 'Conducciones de al menos 7 metros que acaban en asistencia',
      ShotEndingCarries: 'Conducciones de al menos 7 metros que acaban en tiro',
      GoalEndingCarries: 'Conducciones de al menos 7 metros que acaban en gol',
      ShotEndingSequence: 'Posesión acabada en Tiro participada por el jugador',
      GoalEndingSequence: 'Posesión acabada en Gol participada por el jugador',
      AerialWonOffensive: 'Número de duelos aéreos ganadados en jugadas ofensivas',
      AerialWonDefensive: 'Número de duelos aéreos ganadados en jugadas defensivas',
      xGAgainst: 'Goles esperados generados por el rival',
      xGDiffAgainst: 'Diferencia entre goles esperados concedidos y goles concedidos',
      xGPerNPGAgainst: 'Goles esperados recibidos en contra por cada gol recibido sin contabilizar penaltis',
      xGOpenPlayAgainst: 'Goles esperados generados por el juego abierto concedidos',
      xGSetPieceAgainst: 'Goles Esperados Recibidos a Balón Parado',
      xGPerShotAgainst: 'xG Medio de cada remate recibido',
      ShotsAgainst: 'Remates en contra',
      ShotsOnTargetAgainst: 'Remates a puerta en contra',
      RivalPossession: 'Posesión del Rival',
      AerialDefensivePct: 'Porcentaje de duelos aéreos defensivos ganados',
      HighRecoveries: 'Recuperaciones de Balón a menos de 40 metros del área rival',
      HighDefensiveActions: 'Acciones Defensivas (Tackles, Intercepciones, Bloqueos, Faltas Cometidas y 1vs1) del total por encima de 40m de la línea de fondo propia',
      HighDefensiveActionPct: 'Porcentaje de Acciones Defensivas (Tackles, Intercepciones, Bloqueos, Faltas Cometidas y 1vs1) del total por encima de 40m de la línea de fondo propia',
      HighDefensiveDistance: 'Distancia media respecto de la propia portería de todas las acciones defensivas',
      PassesPerPossession: 'Pases por Posesión',
      LengthPerPossession: 'Distancia por Posesión',
      xTNet: 'Peligro Esperado Neto',
      AvgCarriesDistance: 'Distancia media de conducciones',
      PassesForwardPct: 'Porcentaje de Pases hacia delante sobre el total',
      PassesForwardSuccessful: 'Pases hacia delante realizados con éxito',
      PassesForwardTotal: 'Total de pases hacia delante intentados',
      TacklesAttempted: 'Número total de tackles intentados',
      DuelsLost: 'Duelos Perdidos',
      Carries: 'Conducciones',
      CarriesPct: '% Conducciones',
      Aerials: 'Duelos Aéreos',
      ProgressivePassesReceivedIntoBox: 'Pases Progresivos Recibidos en el Área',
      PassesOppHalf: 'Número total de pases exitosos que finalizan en campo contrario',
      ShotsOnTarget: 'Remates a puerta',
      AggressiveActions: 'Tackles intentados en los siguientes 2 segundos después de pérdida',
      Crosses: 'Centros totales',
      xGBuildup5pass: 'Construcción xG en los últimos 5 pases (excluyendo remates y pases que preceden al tiro)',
      DefensiveDistance: 'Promedio de la distancia respecto a la propia portería de los duelos defensivos realizados',
      SpeedSequence: 'Velocidad del movimiento del balón en la posesión',
      Touches: 'Número de acciones del jugador',
      AerialsTotalOppHalf: 'Duelos aéreos totales en campo del rival',
      AerialsWonOppHalf: 'Duelos aéreos ganados en campo del rival',
      AerialsWonOppHalfPct: 'Porcentaje de duelos aéreos ganados respecto al total de duelos aéreos producidos en campo del rival',
      AerialsPctOppBox: 'Porcentaje de duelos aéreos ganados respecto al total de duelos aéreos producidos en el área rival',
      AerialsPctOwnBox: 'Porcentaje de duelos aéreos ganados respecto al total de duelos aéreos producidos en el área propia',
      AerialDefensive: 'Número total de duelos aéreos cuando el equipo contrario tiene la posesión',
      AerialOffensive: 'Número total de duelos aéreos cuando el equipo propio tiene la posesión',
      AerialOffensivePct: 'Porcentaje de duelos aéreos ganados cuando el equipo propio tiene la posesión',
      IndividualPressureOppHalf: 'Modelo que cuantifica el número de esfuerzos con éxito de un jugador ejerce en campo del rival durante presión',
      TouchesPerShot: 'Número de acciones realizadas por cada remate',
      PassesFinalThirdTotalPct: 'Porcentaje de pases (exitosos y no) realizados en el último tercio del campo',
      xACrosses: 'Asistencias esperadas generadas a partir de centros',
      Passes: 'Total de pases realizados',
      PassesSuccessful: 'Pases Completados con Éxito',
      TacklesWasDribbledFouls: 'Porcentaje de tackles ganados respecto al total de tackles y faltas cometidas',
      OffsidesCaught: 'Fueras de Juego',
      ProgressivePassesReceivedFinalThird: 'Pases Progresivos Recibidos Último ⅓',
      ProgressivePassesReceived: 'Pases Progresivos Recibidos',
      Breadth: 'Tackles, regates recibidos, intercepciones y faltas cometidas, en los laterales del campo',
      DuelsDefTotal: 'Suma de tackles totales, duelos aéreos defensivos y faltas cometidas',
      DefensiveActions: 'Acciones defensivas cuando un oponente intenta regatear (Tackles totales, intercepciones y faltas)',
      ProgressivePassesReceivedOppHalf: 'Pases Progresivos Recibidos en Campo Rival',
      CompletedCrossesOP: 'Centros Completados en Jugada',
      CrossingOP: 'Porcentaje de centros completados respecto al total de ellos en jugada',
      CrossesOP: 'Total de centros intenatados en jugada',
      PassingContribution: 'Porcentaje que mide la peligrosidad y valor añadido de los pases teniendo en cuenta la posición del receptor',
      BallProgressionOppHalfInTeam: 'Porcentaje de Progresión de balón en campo rival del total de su equipo',
      PassesOPIntoBoxInTeam: 'Porcentaje de Pases en juego al área rival del total de su equipo',
      TouchesOppBoxInTeam: 'Porcentaje de toques de balón en el área rival del total de su equipo',
      xGOPInTeam: 'Porcentaje de goles esperados generados en juego del total de su equipo',
      DeepPasses: 'Pases desde fuera de un radio de 20 metros de la portería rival que finalizan con éxito dentro del mismo',
      DeepPassesTotal: 'Total de pases intentados desde fuera de un radio de 20 metros de la portería rival que finalizan dentro del mismo',
      DefensiveDuelsPct: 'Porcentaje de duelos defensivos ganados entre duelos defensivos totales',
      QuickRecoveriesPct: 'Porcentaje de recuperaciones rápidas entre intercepciones y tackles intentados',
      DiffDefensiveDistanceTeam: 'Diferencia entre la distancia defensiva del jugador y la de su equipo',
      xTPassing: 'Peligro esperado generado solamente a partir de pases',
      xTPassing100Passes: 'Peligro esperado generado solamente a partir de pases y por cada 100 pases',
      ProgressivePassesAccurate: 'Pases completados de 10 o más metros hacia la portería rival',
      PassAbility: 'Relación entre los pases completados y los pases esperados (xP)',
      OPPassesIntoOppBoxPct: 'Porcentaje de pases al área rival en jugada completados y los totales',
      EntriesOppBox: 'Suma de pases y conducciones al área rival',
      Crosses6yardBox: 'Número total de centros que terminan en el área pequeña',
      Cutbacks: 'Pases desde línea de fondo hacia atrás y al área',
      xTDribbling: 'xT generado solamente a partir de regates',
      AvgShotDistance: 'Promedio de la distancia del total de remates efectuados',
      xGOnTarget: 'Goles Esperados a Puerta',
      FinishingxGOT: 'Porcentaje de goles convertidos en relación a sus disparos a puerta',
      DribblesWonOwnHalf: 'Número de regates con éxito realizados en campo propio',
      DribblesOwnHalf: 'Número de regates intentados en campo propio',
      DribblesOwnHalfPct: 'Porcentaje de regates con éxito respecto del total realizados en campo propio',
      DribblesWonOppHalf: 'Número de regates exitosos realizados en campo contrario',
      DribblesOppHalf: 'Número de regates intentados en campo contrario',
      DribblesOppHalfPct: 'Porcentaje de regates con éxito respecto del total realizados en campo contrario',
      DribblesWonFinalThird: 'Número de regates realizados correctamente en el último tercio del campo',
      DribblesFinalThird: 'Número de regates intentados en el último tercio del campo',
      DribblesFinalThirdPct: 'Porcentaje de regates exitosos respecto del total realizados en el último tercio del campo',
      ShotEndingHighRecoveries: 'Recuperaciones de balón a menos de 40 metros del área rival que terminan en tiro',
      PassingFinalThirdAgainst: 'Número de pases completados concedidos que acaban en el primer tercio del campo propio',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Pases intentados concedidos al área propia sin contar a balón parado',
      EntriesOppBoxAgainst: 'Suma de pases y conducciones concedidas al área propia',
      DeepProgressionAgainst: 'Número de veces que el rival alcanza el primer quinto del campo propio mediante conducciones o control del balón',
      TouchesInOpponentBoxAgainst: 'Número de acciones del rival concedidas dentro del área propia',
      Score: 'Rendimiento del jugador basado en diferentes métricas',
      PDScore: 'Rendimiento físico del jugador basado en diferentes métricas físicas',
      SpeedScore: 'Rendimiento físico del jugador basado en diferentes métricas de velocidad y potencia',
      EnduranceScore: 'Rendimiento físico del jugador basado en diferentes métricas de resistencia',
      OrlegiScore: 'Rendimiento del jugador basado en diferentes métricas',
      SirScore: 'Rendimiento del jugador basado en diferentes métricas',
      ExcScore: 'Rendimiento del jugador basado en diferentes métricas',
      xTOPInTeam: 'Peligro esperado (xT) generado en juego respecto al total de su equipo',
      YellowCards: 'Tarjetas amarillas recibidas',
      RedCards: 'Tarjetas rojas recibidas',
      xTOpenPlayAgainst: 'Peligro Esperado concedido que proviene de jugadas y no a balón parado',
      xTSetPieceAgainst: 'Peligro Esperado concedido que proviene de balón parado y no de jugadas',
      NPGOpenPlayAgainst: 'Goles sin penaltis concedidos en jugada',
      NPGSetPieceAgainst: 'Goles sin penaltis concedidos generados a balón parado, excluyendo goles de penalti',
      PassesOppHalfPerPossession: 'Pases Campo Contrario por Posesión',
      AverageTimeRecovery: 'Tiempo Medio Recuperación',
      ExpectedPassing: 'Porcentaje de pases que se deberían haber compleado',
      NumPossession10Passes: 'Posesiones 10 Pases',
      PassesReceived: 'Pases Recibidos',
      PassesReceivedFinalThird: 'Pases Recibidos Último ⅓',
      ProgressivePassesTotalPct: 'Porcentaje de pases progresivos completados respecto al total de pases progresivos',
      ShortPassesPct: 'Porcentaje Pases Cortos',
      TouchesOppBoxOppTeam: 'Número de acciones del rival concedidas dentro del área propia cuando el jugador está en el campo',
      ShotsOnTargetOppTeam: 'Remates a puerta concedidos cuando el jugador está en el campo',
      NPGOppTeam: 'Goles sin contar penaltis recibidos cuando el jugador está en el campo',
      xGSetPiecePerxG: 'Goles esperados generados a balón parado necesarios para generar un gol esperado',
      ShotsOpenPlay: 'Número de remates generados en jugada',
      ShotsOpenPlayAgainst: 'Número de remates recibidos en jugada',
      ShotsFromDribble: 'Disparos realizados tras regatear a un oponente',
      GoalsFromDribble: 'Goles marcados tras regatear a un oponente',
      PassesIntoFinalThird: 'Pases exitosos desde fuera hacia dentro del tercio final',
      PassesIntoFinalThirdTotal: 'Total de pases intentados desde fuera hacia dentro del tercio final',
      PassesInsideFinalThird: 'Pases exitosos dentro del tercio final (inicio y fin en el tercio final)',
      PassesInsideFinalThirdTotal: 'Total de pases intentados dentro del tercio final (inicio y fin en el tercio final)',
      PassesFinalThirdNoArea: 'Pases exitosos que terminan en el tercio final (excluyendo el área)',
      PassesIntoOppBox: 'Pases exitosos que terminan en el área rival',
      CarriesFinalThird: 'Conducciones de al menos 7 metros que terminan en el tercio final',
      CarriesInsideFinalThird: 'Conducciones de al menos 7 metros dentro del tercio final (inicio y fin en el tercio final',
      CarriesFinalThirdNoBox: 'Conducciones de al menos 7 metros que terminan en el tercio final (excluyendo el área)',
      CarriesIntoOppBox: 'Conducciones de al menos 7 metros que terminan en el área rival',
      TimePossessionAgainst: 'Tiempo de posesión del balón del equipo rival',
      TimePossessionTotal: 'Tiempo de posesión del balón de ambos equipos',
      PassesInBox: 'Pases exitosos con origen dentro del área rival',
      LongThrowInSuccessful: 'Saque de banda largo exitoso desde la banda, diseñado para lanzar el balón más de 20 metros',
      LongThrowInTotal: 'Total de saques de banda largos desde la banda, diseñados para lanzar el balón más de 20 metros',
      LongThrowInPct: 'Porcentaje de saques de banda largos (más de 20 metros) que son exitosos',
      Games: 'Juegos jugados',
      PointsPerGame: 'Puntos por juego',
      ExpectedPointsDiff: 'Diferencia de puntos esperada',
      PassesTotalOwnHalf: 'Número total de pases realizados desde el propio campo',
      PassesOwnHalf: 'Número de pases exitosos realizados desde el propio campo',
      PassesTotalOppHalf: 'Número total de pases intentados que finalizan en campo contrario',
      ProgressivePassesTotal: 'Número total de pases de 10 metros o más en el eje X',
      DuelsWon: 'Duelos exitosos (Entradas, Aéreos, Toques de Balón, Regates y Faltas cometidas)',
      NonPenaltySaves: 'Paradas excluyendo remates de penalti',
      BadActionsOppHalf: 'Suma de todas las malas acciones cometidas en el campo contrario',
      CarriesSuccessful: 'Número de conducciones de al menos 7 metros que finalizan con un evento exitoso',
      CarriesIntoFinalThird: 'Conducciones de al menos 7 metros desde fuera hacia dentro del tercio final',
      ShotsOnTargetOutBox: 'Disparos a portería desde fuera del área',
      SwitchPlaySuccessful:'Número de pases completados de más de 32 metros en los que el desplazamiento lateral del balón es mayor que el desplazamiento en dirección a la portería contraria',
      SwitchPlayTotal:'Número total de pases intentados de más de 32 metros en los que el desplazamiento lateral del balón es mayor que el desplazamiento en dirección a la portería contraria',
      PassesInsideOppHalf:'Número total de pases que comienzan y terminan en campo contrario',
      PassesInsideOppHalfSuccessful:'Número de pases completados que comienzan y terminan en campo contrario',
      TacklesAttemptedFirstThird:'Número total de tackles intentados en el primer tercio del terreno de juego',
      TacklesAttemptedSecondThird:'Número total de tackles intentados en el segundo tercio del terreno de juego',
      TacklesFirstThird:'Número de tackles realizados con éxito en el primer tercio del terreno de juego',
      TacklesSecondThird:'Número de tackles realizados con éxito en el segundo tercio del terreno de juego',
      FoulsOwnHalf:'Número de faltas cometidas en campo propio',
      TouchesOppHalf:'Número de toques de balón realizados en campo contrario',
      TacklesAttemptedNotAdjusted:'Número total de tackles intentados, sin ajuste en función de la posesión',
      TacklesSuccessfulNotAdjusted:'Número total de tackles realizados con éxito, sin ajuste en función de la posesión',
      // Physical Stats
      TotalDistance: 'Distancia total recorrida',
      WalkingDistance: 'Distancia total que ha recorrido el Jugador durante un partido a una velocidad inferior a 2 m/s (7,2 km/h)',
      JoggingDistance: 'Distancia total que ha recorrido el Jugador durante un partido a una velocidad entre 2 m/s (7,2 km/h) y 4 m/s (14,4 km/h)',
      RunningDistance: 'Distancia total que ha recorrido el Jugador durante un partido a una velocidad entre 4 m/s (14,4 km/h) y 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Número de veces que el jugador acelera más de 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Número de carreras realizadas a una velocidad entre 14,4 km/h y 19,8 km/h',
      HsrDistance: 'Distancia a una velocidad >19.8 km/h',
      HsrNumber: 'Número de sprints a velocidad >19,8 km/h',
      HsrDistancePct: '% de distancia a velocidad >19.8 km/h respecto a la distancia total',
      SprintsNumber: 'Número de sprints a velocidad >25.2 km/h',
      SprintsDistance: 'Distancia a una velocidad >25.2 km/h',
      SprintNumberDeclinePct: 'Diferencia en % del número de sprints entre ambas mitades',
      SprintDistanceDeclinePct: 'Diferencia en % de la distancia de sprints entre ambas mitades',
      SprintNumberDecline: 'Diferencia en el número de sprints entre ambas mitades',
      SprintDistanceDecline: 'Diferencia en la distancia de sprints entre ambas mitades',
      SprintDistancePct: 'Porcentaje de distancia sprintada respecto a la distancia total',
      Accelerations: 'Cantidad de aceleraciones',
      MaxSpeed: 'Velocidad máxima alcanzada en algún momento del encuentro',
      AvgMaxSpeed: 'Promedio de la velocidad máxima alcanzada por el jugador',
      MaxAccelerations: 'Máxima aceleración en metros/segundo² lograda por el jugador',
      // Arrigo
      BypassedPlayersByPasses: 'Número de jugadores del lado del gol del portador del balón al comienzo del evento de toque, menos el número de jugadores del lado del gol al final del evento',
      BypassedDefendersByPasses: 'Número de defensores del lado del gol del portador del balón al comienzo del evento de toque, menos el número de defensores del lado del gol al final del evento',
      PassesBypassingPlayers: 'Número de pases que superaron a jugadores',
      PassesBypassingDefenders: 'Número de pases que superaron a defensores',
      BypassedPlayersPerPass: 'Número total de jugadores superados por pase',
      BypassedDefendersPerPass: 'Número total de defensores superados por pase',
      LineBreakingPasses: 'Pases completados que avanzan el balón al menos un 10% más cerca de la portería contraria e intersectan un par de defensores en proximidad o pasan detrás de la línea defensiva',
      LineBreakingPassesMD: 'Pases completados que atraviesan las líneas media y defensiva',
      LineBreakingPassesM: 'Pases completados que atraviesan la línea de mediocampistas',
      LineBreakingThroughBalls: 'Pases completados que atraviesan la línea defensiva',
      LineBreakingPassesPerPass: 'Porcentaje de pases completados entre líneas por cada pase realizado',
      TotalPassesUnderStrongPressure: 'Número total de pases realizados bajo fuerte presión (dentro de 0-2 metros del oponente más cercano)',
      TotalPassesUnderLightPressure: 'Número total de pases realizados bajo presión (dentro de 2-4 metros del oponente más cercano)',
      SuccessfulPassesUnderStrongPressure: 'Número de pases exitosos realizados bajo fuerte presión (dentro de 0-2 metros del oponente más cercano)',
      SuccessfulPassesUnderLightPressure: 'Número de pases exitosos realizados bajo presión (dentro de 2-4 metros del oponente más cercano)',
      PassingUnderStrongPressure: 'Porcentaje de pases exitosos y totales realizados bajo fuerte presión (dentro de 0-2 metros del oponente más cercano)',
      PassingUnderLightPressure: 'Porcentaje de pases exitosos y totales realizados bajo presión (dentro de 2-4 metros del oponente más cercano)',
      PassReceiptsInSpaceCompleted: 'Pases completados donde el receptor está en la mitad de ataque y no tiene defensores a un radio de 5 metros en dirección a la portería',
      PassReceiptsInSpace: 'Pases recibidos en la mitad de ataque sin defensores a un radio de 5 metros en dirección al gol',
      PassReceiptsInSpaceCompletedFirstThird: 'Pases realizados donde el receptor está en el primer tercio y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedSecondThird: 'Pases realizados donde el receptor está en el segundo tercio y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedFinalThird: 'Pases realizados donde el receptor está en el último tercio y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Pases realizados donde el receptor está en campo rival (lado derecho) y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Pases realizados donde el receptor está en campo rival (zona central) y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Pases realizados donde el receptor está en campo rival (lado izquierdo) y no tiene defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceFirstThird: 'Pases recibidos en el primer tercio donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceSecondThird: 'Pases recibidos en el segundo tercio donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceFinalThird: 'Pases recibidos en el último tercio donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceOppHalfRight: 'Pases recibidos en campo rival (lado derecho) donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceOppHalfCenter: 'Pases recibidos en campo rival (zona central) donde no hay defensores a menos de 5 metros en dirección a la portería',
      PassReceiptsInSpaceOppHalfLeft: 'Pases recibidos en campo rival (lado izquierdo) donde no hay defensores a menos de 5 metros en dirección a la portería',
      TotalStrongOnBallPressures: 'Número de presiones fuertes sobre el balón (dentro de 0-2 metros del portador del balón)',
      TotalLightOnBallPressures: 'Número de presiones sobre el balón (dentro de 2-4 metros del portador del balón)',
      SuccessfulStrongOnBallPressures: 'Número de presiones fuertes exitosas sobre el balón (dentro de 0-2 metros)',
      SuccessfulLightOnBallPressures: 'Número de presiones exitosas sobre el balón (dentro de 2-4 metros)',
      StrongOnBallPressuresPct: 'Porcentaje de presiones fuertes exitosas y totales sobre el balón (dentro de 0-2 metros del oponente más cercano)',
      LightOnBallPressuresPct: 'Porcentaje de presiones exitosas y totales sobre el balón (dentro de 2-4 metros del oponente más cercano)',
      TimesBypassedByPasses: 'Número total de veces que ha sido superado por pase',
      TimesBypassedByCarries: 'Número total de veces que ha sido superado por conducción',
      TimesBypassedByActions: 'Número total de veces que ha sido superado por pases y conducciones',
      BypassedPlayersByCarries: 'Número total de rivales (defensores y mediocampistas) superados mediante conducciones',
      BypassedDefendersByCarries: 'Número total de rivales (defensores) superados mediante conducciones',
      BypassedPlayersByActions: 'Número total de rivales (defensores y mediocampistas) superados mediante pases y conducciones combinados',
      BypassedDefendersByActions: 'Número total de rivales (defensores) superados mediante pases y conducciones combinados',
      CarriesBypassingPlayers: 'Número de conducciones que superaron jugadores',
      CarriesBypassingDefenders: 'Número de conducciones que superaron defensores',
      BypassedPlayersPerCarry: 'Promedio de rivales superados por conducción',
      BypassedDefendersPerCarry: 'Promedio de defensores superados por conducción',
      LineBreakingCarries: 'Número de conducciones que penetraron con éxito una o más líneas defensivas',
      LineBreakingCarriesMD: 'Número de conducciones que penetraron con éxito líneas de mediocampistas y defensores',
      LineBreakingCarriesM: 'Número de conducciones que penetraron con éxito la línea de mediocampistas',
      LineBreakingCarriesD: 'Número de conducciones que penetraron con éxito la línea defensiva',
      LineBreakingCarriesPerCarry: 'Porcentaje de conducciones entre líneas por conducción',
      LineBreakingActions: 'Número de pases y conducciones combinados que penetraron con éxito una o más líneas defensivas',
      LineBreakingActionsMD: 'Número de pases y conducciones combinados que penetraron con éxito líneas de mediocampistas y defensores',
      LineBreakingActionsM: 'Número de pases y conducciones combinados que penetraron con éxito la línea de mediocampistas',
      LineBreakingActionsD: 'Número de pases y conducciones combinados que penetraron con éxito la línea defensiva',
      PassesPerLineBreakingPass: 'Relación entre el número total de pases por pase entre líneas',
      CarriesPerLineBreakingCarry: 'Relación entre el número total de conducciones por conducción entre líneas',
      LinesBrokenByPasses: 'Número total de líneas superadas mediante pases',
      LinesBrokenByCarries: 'Número total de líneas superadas mediante conducciones',
      LinesBrokenByActions: 'Número total de líneas superadas mediante pases y conducciones combinados',
      LinesBrokenPerPass: 'Relación entre el número total de líneas superadas por cada pase realizado',
      LinesBrokenPerCarry: 'Relación entre el número total de líneas superadas por cada conducción realizada',
      AvgLastDefenderDistanceIP: 'Distancia entre el último defensor (más cercano a la propia portería) y la línea de gol con posesión',
      AvgLastDefenderDistanceOOP: 'Distancia entre el último defensor (más cercano a la propia portería) y la línea de gol sin posesión',
      AvgDefensiveLineDistanceIP: 'Distancia entre la posición de la línea defensiva más profunda y la portería con posesión',
      AvgDefensiveLineDistanceOOP: 'Distancia entre la posición de la línea defensiva más profunda y la portería sin posesión',
      AvgRBDistanceIP: 'Distancia del lateral derecho a su propia portería cuando está con posesión',
      AvgRBDistanceOOP: 'Distancia del lateral derecho a su propia portería cuando está sin posesión',
      AvgLBDistanceIP: 'Distancia del lateral izquierdo a su propia portería cuando está con posesión',
      AvgLBDistanceOOP: 'Distancia del lateral izquierdo a su propia portería cuando está sin posesión',
      AvgBlockDistanceIP: 'Distancia entre el jugador de campo más profundo y el más adelantado con posesión',
      AvgBlockDistanceOOP: 'Distancia entre el jugador de campo más profundo y el más adelantado sin posesión',
      AvgBlockAreaIP: 'El área que rodea a todos los jugadores de campo (una medida de cuánto espacio ocupan los jugadores de campo) con posesión',
      AvgBlockAreaOOP: 'El área que rodea a todos los jugadores de campo (una medida de cuánto espacio ocupan los jugadores de campo) sin posesión',
      AvgDefensiveLineWidthOOP: 'Anchura de la línea de jugadores más atrasada (más cerca de su propia portería) cuando defienden',
      AvgOffensiveLineLastThirdWidthIP: 'Anchura horizontal de la línea ofensiva cuando están con posesión',
      AvgLByIP: 'Posición del lateral izquierdo cuando está con posesión',
      AvgRByIP: 'Posición del lateral derecho cuando está con posesión',
      AvgOffensiveLineDistanceIP: 'Distancia entre la propia portería y la línea ofensiva cuando está con posesión',
      AvgOffensiveLineLastThirdDistanceIP: 'Distancia entre el último tercio del campo y la línea ofensiva cuando está con posesión',
      AvgOffensiveLineWidthIP: 'Anchura horizontal de la línea ofensiva cuando está con posesión',
      OffBallRuns: 'Movimientos intencionados del jugador sin balón (desmarques), con la intención de apoyar la fase de ataque',
      OffBallRunsOverlap: 'Desmarques en los que el jugador corre alrededor de su compañero por el exterior (más cerca de la línea de banda) mientras ese compañero tiene el balón',
      OffBallRunsUnderlap: 'Desmarques en los que el jugador corre por dentro de su compañero, pasando por el lado interior (más cerca del centro del campo)',
      OffBallRunsRunAhead: 'Carrera hacia delante que avanza más allá del portador del balón, pero se mantiene delante del último defensor',
      OffBallRunsRunBehind: 'Carrera hacia delante que penetra en la última línea defensiva, posicionándose entre los defensas y el portero',
      OffBallRunsCrossReceiver: 'Un jugador corre hacia el área y se coloca en posición de recibir un centro de un compañero',
      OffBallRunsSupport: 'El jugador corre para unirse a la línea del portador del balón, ofreciendo una opción de pase cercana en ataque',
      OffBallRunsComingShort: 'El jugador corre hacia el portador del balón para ofrecer un apoyo cercano o una opción de pase lejos de la portería',
      AvgTop5MaxSpeed:'Promedio de las cinco velocidades máximas más altas alcanzadas por el jugador',
      LBPReceived:'Número de pases de ruptura de líneas recibidos. Se consideran aquellos pases completados que acercan el balón al menos un 10% a la portería contraria e intersectan un par de defensores próximos entre sí o superan la línea defensiva',
      LBPMReceived:'Número de pases recibidos que atraviesan la línea de mediocampistas rival',
      LBPMDReceived:'Número de pases recibidos que atraviesan tanto la línea de mediocampistas como la línea defensiva rival',
      ThroughBallReceived:'Número de pases recibidos que atraviesan la última línea defensiva rival',
      HsrDistanceIP: 'Distancia en sprints >21 km/h en posesión',
      HsrDistanceOOP: 'Distancia en sprints >21 km/h sin posesión',
      JoggingDistanceIP: 'Distancia trotando en posesión',
      JoggingDistanceOOP: 'Distancia trotando sin posesión',
      RunningDistanceIP: 'Distancia corriendo en posesión',
      RunningDistanceOOP: 'Distancia corriendo sin posesión',
      SprintsDistanceIP: 'Distancia en sprints >24 km/h en posesión',
      SprintsDistanceOOP: 'Distancia en sprints >24 km/h sin posesión',
      WalkingDistanceIP: 'Distancia caminando en posesión',
      WalkingDistanceOOP: 'Distancia caminando sin posesión'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PFT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'PFS',
      PassesForwardTotal: 'PFT',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFTT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP%',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DPC',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      CarriesIntoFinalThird: 'CIF⅓',
      ShotsOnTargetOutBox: 'SOTOB',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      // Physical Stats
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'hg',
      HeadedShots: 'HS',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SOB',
      // Arrigo
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
    },
  },
  team: {
    title: 'Ficha del equipo',
    subtitle: 'Profundiza en las características y estadísticas del equipo',
    averageAge: 'Edad media',
    transferBalance: 'Balance de traspasos',
    roster: 'Plantilla',
    stadium: 'Estadio',
    coach: 'Entrenador',
    homeCoach: 'Entrenador Local',
    awayCoach: 'Entrenador Visitante',
    transfers: 'Traspasos',
    trends: 'Tendencias',
    loans: 'Cedidos',
    loanFrom: 'Cedido por',
    loanTo: 'Cedido a',
    latestGames: 'Últimos partidos',
    latestXGames: 'Últimos {0} partidos',
    playingFor: 'Juega para',
    overview: 'Resumen',
    visualization: 'Visualización',
    location: 'Ubicación',
    outcome: 'Resultado',
    beeswarm: 'Ranking',
    parentTeam: 'Primer equipo',
    childTeam: 'Filial',
    preferredFormation: 'Formación frecuente',
    mostFrecuentFormations: 'Formaciones más frecuentes',
    viewType: 'Tipo de vista',
    overviewTab: {
      axisXTotal: 'Total',
      axisXper90: 'Por 90\'',
      dataPerGameText: 'Datos por partido',
      season: 'Temporada',
      last: 'Última',
      current: 'Actual',
      TeamStyle: 'Estilo',
      TeamDefensive: 'Defensivo',
      TeamOffensive: 'Ofensivo',
      TeamCustom1: 'Personalizado 1',
      TeamCustom2: 'Personalizado 2',
      TeamCustom3: 'Personalizado 3',
      TeamCustom4: 'Personalizado 4',
      coach: 'Entrenador',
      groups: {
        Goals: {
          name: 'Goles',
          desc: 'Se muestran todos los goles (con y sin penaltis, tanto "En Juego" como "a Balón Parado").'
        },
        Assists: {
          name: 'Asistencias',
          desc: 'Jugadores con más asistencias (en juego y a balón parado) esta temporada.'
        },
        xG: {
          name: 'Goles Esperados',
          desc: 'Goles Esperados en juego y a balón parado, ordenados de forma descendente por el total xG generado.'
        },
        xA: {
          name: 'Asistencias Esperadas',
          desc: 'Asistencias Esperadas tanto a balón parado como durante el juego.'
        },
        Finishing: {
          name: 'Finalización',
          desc: 'Porcentaje de remates que acaban en gol.'
        },
        ScoringContribution: {
          name: 'Contribución Goleadora',
          desc: 'Número de asistencias y de goles del equipo.'
        },
        xT: {
          name: 'Peligro Esperado',
          desc: 'Peligro Esperado generado durante el juego, a balón parado y negativo.'
        }
      },
      stats: {
        openPlay: 'En Juego',
        setPiece: 'Balón Parado',
        negative: 'Negativo',
        npg: 'Goles sin Penaltis',
        goalsPenalty: 'Goles de Penalty',
        npgOpenPlay: 'Goles SP en Juego',
        npgSetPiece: 'Goles SP a Balón Parado',
        assists: 'Asistencias',
        assistsConceded: 'Asistencias encajadas',
        assistsOpenPlay: 'Asistencias en Juego',
        assistsSetPiece: 'Asistencias a Balón Parado',
        xGOpenPlay: 'xG en Juego',
        xGSetPiece: 'xG a Balón Parado',
        xAOpenPlay: 'xA en Juego',
        xASetPiece: 'xA a Balón Parado',
        xAConceded: 'xA encajada',
        nonPenaltyShots: 'Remates sin Penaltis',
        penaltyShots: 'Remates de Penalty',
        xT: 'Peligro Esperado',
        xTOpenPlay: 'xT en Juego',
        xTSetPiece: 'xT a Balón Parado',
        xTNeg: 'xT Negativo',
        totalFinishing: 'Finalización',
        nonPenaltyFinishing: 'Finalización sin Penaltis',
        goalsPenaltyFinishing: 'Finalización de Penaltis',
        goal: 'Gol',
        notGoal: 'No Gol',
        chance: 'Ocasión',
        finished: 'Rematada',
        notFinished: 'No Rematada',
        walkingDistance: 'Caminando',
        joggingDistance: 'Trotando',
        runningDistance: 'Corriendo',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprintando',
        runningNumber: 'Carreras',
        hsrNumber: 'Sprints HSR',
        sprintsNumber: 'Sprints',
        maxSpeed: 'Velocidad Máxima',
        accelerations: 'Aceleraciones',
        extremeAccelerations: 'Ac. Extremas',
        maxAcceleration: 'Ac. Máxima'
      }
    },
    teamAnalysis: 'Análisis del Equipo',
    agentView: {
      positions: {
        gk: 'Porteros',
        leftFullback: 'Laterales izq.',
        centralDefender: 'Centrales',
        rightFullback: 'Laterales der.',
        midfielder: 'Centrocampistas',
        attackingMidfielder: 'Mediapuntas',
        leftWinger: 'Extremos izq.',
        rightWinger: 'Extremos der.',
        fw: 'Delanteros'
      },
      groups: {
        contractEnd: 'Meses',
        age: 'Años',
        availability: 'Disponibilidad'
      },
      placer: {
        legend: 'Fuerza basada en la edad, contrato, minutos jugados y rendimiento'
      }
    },
    transfersTab: {
      valueMovements: 'Valor movimientos',
      valueTransfers: 'Valor transferencias',
      valueLoans: 'Valor cesiones',
      avgAgeMovements: 'Edad media movimientos',
      avgAgeTransfers: 'Edad media transferencias',
      avgAgeLoans: 'Edad media cesiones',
      operations: {
        buys: {
          buy: 'Compra',
          loan: 'Cesión',
          'end of loan': 'Fin de cesión',
          'free transfer': 'Gratis',
          free: 'Gratis',
          'loan transfer': 'Cesión',
          other: 'Otro'
        },
        sells: {
          buy: 'Venta',
          loan: 'Cesión',
          'end of loan': 'Fin de cesión',
          'free transfer': 'Gratis',
          free: 'Gratis',
          'loan transfer': 'Cesión',
          other: 'Otro',
          retired: 'Retirado'
        }
      }
    },
    trendsTab: {
      streaks: 'Rachas',
      wins: 'Victorias',
      results: 'Resultados',
      cleanSheets: 'Porterías a Cero',
      goalPeriods: 'Períodos con Goles Marcados',
      concededGoalPeriods: 'Períodos con Goles Recibidos',
      comebacks: 'Remontadas',
      avgTime: 'Promedio de Tiempo',
      kindOfGoals: 'Tipos de Goles',
      kindOfConcededGoals: 'Tipos de Goles Recibidos',
      percentWinning: '% Ganando',
      percentDrawing: '% Empatando',
      percentLosing: '% Perdiendo',
      totalOf: 'Total de',
      minutes: 'minutos',
      before: 'Antes',
      after: 'Después',
      playedOn: 'Jugado el',
      scored: 'Marcados',
      conceded: 'Recibidos',
      ownGoals: 'en Propia Puerta',
      phasesOfGame: 'Fases del Juego',
      showMinutes: 'Mostrar Minutos',
      intensityLabel: 'Intensidad de zona',
      intensityByTeam: 'Por Equipo %',
      intensityByLeagueAvg: 'Por Media Liga %',
      buildup: 'Construcción',
      midfieldProgression: 'Progresión en el Mediocampo',
      attackOpposition: 'Ataque al Rival',
      attackingTransition: 'Transición Ofensiva',
      highPress: 'Presión Alta',
      midBlock: 'Bloque Medio',
      lowBlock: 'Bloque Bajo',
      defensiveTransition: 'Transición Defensiva',
      draws: 'Empates',
      losts: 'Perdidos',
      chokes: 'Choke',
      zoneTooltip: "Determina el criterio para el degradado de color de cada bloque:",
      teamPctTooltip: 'Se calcula en función del porcentaje de tiempo total jugado por el equipo en cada zona.',
      leagueAvgPctTooltip: "Compara el porcentaje del equipo con el promedio de la liga en cada zona.",
      leagueAvgMinsTooltip: "Aplica el mismo criterio de comparación frente a la liga, pero evaluando el tiempo total en minutos en lugar de porcentajes."
    },
    onOff: 'On/Off',
    dragUpToXPlayers: 'Arrastra hasta {x} jugadores',
    selectUpToXPlayers: 'Selecciona hasta {x} jugadores',
    onOffTab: {
      G90: 'Goles 90',
      GA90: 'Goles en contra 90',
      diffG90: 'Diferencia goles 90',
      XG90: 'xG 90',
      XGA90: 'xG en contra 90',
      diffXG90: 'Diferencia xG 90',
      playersOn: 'Combinación ON',
      playersOff: 'Combinación OFF',
      ground: 'Local/Visitante',
      playersOnThePitch: 'Jugadores en el campo',
      playersOffThePitch: 'Jugadores fuera del campo',
      attackTitle: 'Ataque',
      attackSubTitle: 'Estadísticas ofensivas',
      defenseTitle: 'Defensa',
      defenseSubTitle: 'Estadísticas defensivas',
      associationTitle: 'Asociación',
      associationSubTitle: 'Estadísticas asociativas',
      comboOn: 'Combinación activa',
      comboOff: 'Resto de combinaciones',
      diffGoals90: 'G Diff 90',
      goals90: 'Goles sin penaltis 90',
      goalsAgainst90: 'Goles sin penaltis en contra 90',
      xgAgainstPer90: 'xG en contra 90',
      xgDiffPer90: 'xG Diff 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Remates a puerta 90',
      touchesOppBox90: 'Toques en el area 90',
      shotsOnTargetAgainst90: 'Remates a puerta en contra 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Verticalidad 90',
      possession: '% Posesión',
      pctPasses: '% Pases',
      pctPassesFinalThird: '% Pases último tercio',
      placeholder: 'Empieza seleccionando un equipo',
      subtitle: 'Optimiza las métricas del equipo añadiendo o quitando jugadores de la alineación'
    },
    terms: {
      short: 'Corta duración',
      mid: 'Duración media',
      long: 'Larga duración'
    },
    report: {
      title: 'Informe de Equipo',
      selectedPeriod: 'Período Seleccionado',
      stackedCharts: 'Gráficos de Barras',
      radars: 'Radares',
      generalData: 'Datos Generales',
      scoringChances: 'Ocasiones de Gol',
      areasReport: 'Informe de Áreas',
      setPieceReport: 'Informe a Balón Parado',
      corners: 'Córners',
      cornersAgainst: 'Córners en Contra',
      indirectFreeKicks: 'Faltas Indirectas',
      indirectFreeKicksAgainst: 'Faltas Indirectas en Contra',
      freeKicks: 'Faltas Directas',
      freeKicksAgainst: 'Faltas Directas en Contra',
      penaltys: 'Penaltis',
      freeKicksContribution: 'Participación Lanzamientos',
      shotsContribution: 'Participación Remates',
      topXPlayersByStats: 'Top {x} Jugadores por Métricas',
      lastShotZone: 'Zona Último Remate',
      throwSide: 'Perfil de Saque',
      kindOfThrow: 'Tipo de Saque',
      scored: 'A Favor',
      against: 'En Contra',
      perGame: 'por Partido',
      total: 'Total',
      efficiency: 'Eficiencia',
      organizedAttack: 'Ataque Organizado',
      offTransition: 'Transición Ofensiva',
      chances: 'Ocasiones',
      chancesScored: 'Ocasiones a Favor',
      chancesAgainst: 'Ocasiones en Contra',
      goalsScored: 'Goles a Favor',
      goalsAgainst: 'Goles en Contra',
      goalsOrganizedAttack: 'Goles Ataque Organizado',
      goalsOffTransition: 'Goles Transición Ofensiva',
      goalsSetPiece: 'Goles a Balón Parado',
      goalsOrganizedAttackScored: 'Goles At. Organizado a Favor',
      goalsOrganizedAttackAgainst: 'Goles At. Organizado en Contra',
      goalsOffTransitionScored: 'Goles Trans. Of. a Favor',
      goalsOffTransitionAgainst: 'Goles Trans. Of. en Contra',
      goalsSetPieceScored: 'Goles a Balón Parado a Favor',
      goalsSetPieceAgainst: 'Goles a Balón Parado en Contra',
      crossSide: 'Centro Lateral',
      externalShot: 'Tiro Exterior',
      innerPlay: 'Juego Interior',
      throwIn: 'Saque de Banda',
      box: 'Cajón',
      zone2: 'Zona 2',
      goalsPerPhases: 'Goles por Fases'
    },
    minutesAlert: '*Mostrando sólo jugadores con más de 450 minutos jugados',
    teamMinutesAlert: '*Mostrando sólo equipos con más de 450 minutos jugados',
    minutesException: 'No hay jugadores con más de 450 minutos jugados. Se muestran todos los jugadores',
    analysis: 'Análisis',
    substitutions: 'Sustituciones',
    attackZones: 'Zonas de ataque',
    formations: 'Formaciones',
    shotZones: 'Zonas de tiro',
    crossings: 'Centros',
    byTime: 'Por Tiempo',
    byPosition: 'Por Posición',
    byPlayer: 'Por Jugador',
    W: 'Ganando',
    D: 'Empatando',
    L: 'Perdiendo',
    substitutionsByGame: 'Sustituciones por partido',
    substitutionsShort: 'Sust.',
    avgSeasonShort: 'Media de la temp.',
    startingAt: 'Empieza en',
    endingAt: 'Termina en',
    startingAtInfo: 'Muestra la cuota de posesiones basada en la localización del primer evento',
    endingAtInfo: 'Muestra la cuota de posesiones basada en la localización del último evento',
    endingWithShot: 'Termina en tiro',
    endingInBox: 'Termina en el área',
    pfX: 'FP {x}',
    bySide: 'Por lado',
    cornerKicks: 'Lanzamientos de corner',
    included: 'Incluidos',
    excluded: 'Excluidos',
    onlyCorner: 'Solo corners',
    sizeByMarketValue: 'Tamaño por valor de mercado',
    timeInTeam: 'Temp. en el equipo',
    newSignings: 'Nuevos fichajes',
    sizeBy: 'Tamaño por',
    connections: 'Conexiones',
    assistant: 'Asistente',
    finisher: 'Rematador',
    playersMinutesAlert: 'Mostrando solo jugadores con minutos jugados en la temporada seleccionada',
    sideFilterTooltip: 'Muestra únicamente los eventos a balón parado que empiezan en el lado seleccionado (izquierda o derecha)',
    strategyFilterTooltip: 'Muestra los eventos sucedidos a balón parado o en plena acción de juego'
  },
  leagueTable: {
    subtitle: 'Analiza como se desarrollan las ligas'
  },
  leagueMatchdays: {
    byRound: 'Por jornada',
    byDate: 'Por fecha',
    byTeam: 'Por equipo'
  },
  teamStats: {
    subtitle: 'Compara como rinden los equipos',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Diferencia entre Goles Esperados y Goles',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Diferencia entre Puntos Esperados y Puntos',
    games: 'PAR',
    gamesExplicit: 'Partidos disputados',
    pointsPerGame: 'PPP',
    pointsPerGameExplicit: 'Puntos por Partido'
  },
  roles: {
    ROLE_USER: 'Usuario',
    ROLE_ADMIN: 'Administrador',
    ROLE_REPORTS: 'Driblab Informes',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Datos Físicos',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_RAW_EVENTING: 'Raw Eventing',
    ROLE_API_description: 'Obtén información de jugadores, equipos, partidos y ligas sin esfuerzo en formato JSON.',
    ROLE_EVENTING_DATA_description: 'Sumérgete en las estadísticas con gráficos de radar, rankings de gugadores, mapas y más basados en +100 métricas de rendimiento.',
    ROLE_PHYSICAL_DATA_description: 'Accede a datos físicos y filtra jugadores por diversas métricas de rendimiento (distancia, velocidad, sprints, aceleración…).',
    ROLE_VIDEO_description: 'Proporciona videos y alineaciones y obtén partidos etiquetados por eventos y con estadísticas para un análisis en profundidad.',
    ROLE_DRIBLAB_HUB_description: 'Haz un seguimiento eficiente y gestiona tareas de scouting con calendarios, notas, alertas y compartiendo documentos.',
    ROLE_TRACKING_description: 'Recibe datos posicionales de todos los jugadores en un partido a través de nuestra API para un análisis completo.',
    ROLE_ARRIGO_description: 'Combina datos de eventing y tracking en métricas innovadoras que van más allá de lo tradicional y aportan valor a cada acción.',
    ROLE_REPORTS_description: 'Solicita informes detallados de scouting de nuestro equipo de analistas para encontrar el equipo o jugador perfecto.'
  },
  administration: {
    pageSubtitle: 'Gestiona el funcionamiento de la aplicación',
    newClient: 'Nuevo cliente',
    clientDuplicateName: 'Ya existe un cliente con este nombre. Seleccione el cliente en la lista y use «Nuevo usuario» para añadir usuarios a ese cliente.',
    newUser: 'Nuevo usuario',
    editClient: 'Editar cliente',
    editUser: 'Editar usuario',
    clientName: 'Nombre',
    permissions: 'Permisos',
    releaseUser: 'Liberar usuario',
    connectAsUser: 'Conectarse como',
    releaseModalTitle: 'Confirmación para liberar usuario',
    releaseModalMessage: 'El usuario recibirá un correo infomandole sobre su nueva cuenta. ¿Está seguro de notificarle?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Equipo',
      Brand: 'Marca',
      Federation: 'Federación',
      Media: 'Medio de comunicación',
      Agency: 'Agencia',
      Individual: 'Persona física'
    },
    userType: {
      Ownership: 'Propietario',
      SportingDirector: 'Director deportivo',
      Brand: 'Marca',
      Federation: 'Federación',
      Media: 'Medio',
      Agency: 'Agente',
      Individual: 'Persona física',
      Scout: 'Ojeador',
      Coach: 'Entrenador',
      supervision: {
        title: 'Jerarquía de supervisión',
        subtitle: 'La supervisión fluye sólo hacia abajo. No se permite la supervisión al mismo nivel.',
        supervisesLowerLevels: 'Supervisa todos los roles a continuación.',
        ruleNoSameLevel: 'Los roles del mismo nivel no pueden supervisarse entre sí.',
        ruleOnlyDownwards: 'La supervisión solo está permitida desde roles superiores a inferiores.',
        ruleLevel3NoSupervision: 'El nivel más bajo no tiene permisos de supervisión.',
        currentUserType: 'Tu tipo de usuario actual'
      }
    },
    visibleYears: 'Años visibles',
    areaModalTitle: 'Confirmar Activar/Desactivar Ligas',
    areaModalMessage: '¿Está seguro de activar/desactivar todas las ligas del área seleccionada?',
    countStats: 'Contar estadísticas',
    userClientModalTitle: 'El usuario ya existe en otro cliente',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Contrato',
    contracts: 'Contratos',
    invoiceName: 'Nombre de la Factura',
    contractFee: 'Cuota del Contrato',
    renewal: 'Renovación',
    consultancy: 'Consultoría',
    deleteContract: 'Eliminar Contrato del Cliente',
    deleteContractMessage: 'El contrato se eliminará permanentemente. ¿Estás seguro?',
    activeVsHired: 'Activo vs Contratado',
    requestedVsHired: 'Solicitado vs Contratado',
    activeVsHiredWithPlaceholder: '{0} Activo vs {1} Contratado',
    requestedVsHiredWithPlaceholder: '{0} Solicitado vs {1} Contratado',
    salesRepresentative: 'Representante de Ventas',
    periodicities: {
      periodicity: 'Periodicidad',
      annual: 'Anual',
      biannual: 'Semestral',
      quarterly: 'Trimestral',
      monthly: 'Mensual',
      bimonthly: 'Bimestral',
      onePayment: 'Pago único',
      fourmonthly: 'Cuatrimestral'
    },
    paymentMethods: {
      payment: 'Pago',
      method: 'Método',
      transfer: 'Transferencia',
      mandate: 'Domiciliación'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Publicidad en Redes Sociales',
      videoWithFeedback: 'Vídeo con Feedback'
    },
    status: {
      status: 'Estado',
      pending: 'Pendiente',
      active: 'Activo',
      expiringSoon: 'Próximo a Vencer',
      expired: 'Vencido',
      expiringSoonWithDays: 'El contrato expira pronto: quedan {0} días'
    },
    updates: {
      roleAdded: '<b>{0}</b> añadió el rol <b>{1}</b> a <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> eliminó el rol <b>{1}</b> de <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> añadió <b>{1}</b> a la liga <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> eliminó <b>{1}</b> de la liga <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> añadió <b>{1}</b> a la temporada <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> eliminó <b>{1}</b> de la temporada <b>{2}</b>.',
      updateNotesPlaceholder: 'Incluye contexto para el cambio o añade notas relevantes aquí...',
      updates: 'Actualizaciones',
      products: 'Productos'
    },
    clients: 'Clientes',
    trials: 'Pruebas',
    activeClients: 'Clientes activos',
    activeTrials: 'Pruebas activas',
    activeTrialUsers: 'Usuarios de prueba activos',
    activeContracts: 'Contratos activos',
    expiration: 'Vencimiento',
    clientWarnings: {
      activeContractInactiveClient: 'Clientes con contratos activos pero sin usuarios habilitados',
      activeContractTrialUsers: 'Clientes con usuarios de prueba mientras hay un contrato activo',
      activeUsersWithoutContract: 'Clientes con usuarios activos no de prueba pero sin contrato activo',
      upcomingExpirations: 'Próximos vencimientos',
      renewedContracts: 'Clientes con contratos renovados',
      clientsWithWarnings: 'Clientes que requieren atención',
      enabledUsersWithoutContract: 'Usuarios habilitados no de prueba sin un contrato activo',
      trialUsersWithContract: 'Usuarios en modo de prueba a pesar de tener un contrato activo',
      activeContractInactiveUsers: 'El cliente tiene un contrato activo con todos los usuarios inactivos',
      activeContract: 'Este cliente tiene un contrato activo',
      noEnabledUsers: 'Este cliente no tiene usuarios habilitados',
      ongoingTrialInactiveUsers: 'Clientes con una prueba en curso pero sin usuarios habilitados',
      neverLoggedIn: 'Clientes que nunca han iniciado sesión'
    },
    daysLeft: 'Días restantes',
    expiringSoon: 'Próximo a vencer',
    loggedThisWeek: 'Iniciaron sesión esta semana',
    withWarnings: 'Con alertas',
    ofActiveClients: 'de clientes activos',
    endingIn30Days: 'vencen en 30 días',
    neverLogged: 'nunca han iniciado sesión',
    ofActiveTrials: 'de pruebas activas',
    activeClientsWithoutTrial: 'clientes activos (sin trial)',
    renewals: 'Renovaciones',
    ofActiveContracts: 'de contratos activos'
  },
  dashboards: {
    lastGame: 'Análisis del último partido',
    lastGameSimple: 'Último partido',
    seeAllGameInfo: 'Ver toda la información',
    nextGame: 'Siguiente Partido',
    myTeam: 'Mi equipo',
    lastMatchdayGames: 'Partidos última jornada',
    lastAdded: 'Últimos añadidos',
    myFavorites: 'Mis favoritos',
    seeAllFavorites: 'Ver todos los favoritos',
    placeholderFavorites: 'Desde el detalle de un jugador puedes añadirlo a favoritos',
    placeholderTeamFavorites: 'Desde el detalle de un equipo puedes añadirlo a favoritos',
    placeholderLeagueFavorites: 'Desde el detalle de una liga puedes añadirla a favoritos',
    myCollections: 'Mis colecciones',
    placeholderCollections: 'No tienes colecciones creadas',
    lastCreated: 'Últimas creadas',
    seeAllCollections: 'Ver todas las colecciones',
    seeRival: 'Ver rival',
    seeMyTeam: 'Ver mi equipo',
    title: 'Cuadro de mandos',
    subtitle: 'Bienvenido',
    recentPlayers: 'Jugadores recientes',
    lastScouted: 'Últimos buscados',
    scout: 'Scout',
    reportsRequested: 'Informes',
    lastRequested: 'Últimos pedidos',
    goInbox: 'Ir a la bandeja',
    placeholderLastScouted: 'Puedes buscar jugadores en la barra de la izquierda o en la herramienta de scout',
    placeholderReports: 'Puedes solicitar informes desde el detalle de un jugador',
    nationalPlayers: 'Jugadores nacionales de mayor valor en otros países',
    lastGames: 'Últimos partidos',
    nationalPlayersShort: 'Jugadores nacionales en otros países',
    nextMatchdayGames: 'Partidos siguiente jornada',
    injuredPlayers: 'Jugadores lesionados',
    atPresent: 'Actualmente',
    seeAllPlayers: 'Ver todos',
    suspendedPlayers: 'Jugadores suspendidos',
    placeholderInjured: 'No hay jugadores lesionados',
    teamValueImpacted: 'Valor del equipo afectado',
    placeholderSuspended: 'No hay jugadores suspendidos',
    placeholderNextGame: 'No hay partido disponible',
    placeholderNoGames: 'Aún no hay partidos disponibles',
    placeholderLastMatchDayNotFound: 'Última jornada no disponible',
    placeholderNextMatchDayNotFound: 'Próxima jornada no disponible',
    usersMostSearch: 'Usuarios que más buscan',
    lastTwoDays: 'Últimos dos días',
    searchesHistory: 'Histórico de búsquedas',
    dayByDay: 'Día a día',
    activeUsersTitle: 'Usuarios activos',
    activeUsersSubtitle: 'Han conectado en el último mes',
    onlineUsersTitle: 'Usuarios conectados',
    onlineUsersSubtitle: 'Han buscado en la última hora',
    searchesPerformed: 'Búsquedas realizadas',
    onlyClients: 'Solo clientes',
    activeClientsTitle: 'Clientes activos',
    activeClientsSubtitle: 'Al menos un usuario activo',
    last24Hours: 'Últimas 24 horas',
    activityHistory: 'Histórico de actividad',
    loginHistory: 'Histórico de accesos',
    failLogins: 'Accesos fallidos',
    successLogins: 'Accesos con éxito',
    clientStats: 'Estadísticas del cliente',
    playersMostSearch: 'Jugadores más buscados',
    toolsMoreUsed: 'Herramientas más usadas',
    hotPlayers: 'Jugadores relevantes',
    last_month: 'Último mes',
    last_week: 'Última semana',
    last_day: 'Últimas 24 horas',
    nClients: 'Nº de Clientes',
    userDashboard: 'Panel de control del usuario',
    userDashboardSubtitle: 'Resumen de la actividad de una cuenta',
    offlineDaysOfClient: 'Días sin conexión de cada cliente',
    hideNoConnected: 'Ocultar no conectados',
    onlyTrial: 'Solo clientes con prueba',
    daysWithoutLogin: 'Días sin inicio de sesión',
    trialDays: 'Días de prueba'
  },
  faq: {
    subtitle: '¿Qué es Driblab PRO?',
    categories: {
      playerMetrics: 'Métricas de Jugador',
      teamMetrics: 'Métricas de Equipo',
      positions: 'Posiciones de Equipo',
      tools: 'Herramientas',
      api: 'API',
      videos: 'Tutoriales',
      playerPositions: 'Posiciones de Jugadores',
      userTypes: 'Tipos de usuarios'
    },
    positions: {
      GK: 'Portero',
      DR: 'Lateral Derecho',
      DC: 'Defensa central',
      DL: 'Lateral Izquierdo',
      DMR: 'Carrilero Derecho',
      DMC: 'Mediocentro Defensivo',
      DML: 'Carrilero Izquierdo',
      MR: 'Medio Derecho',
      MC: 'Mediocentro',
      ML: 'Medio Izquierdo',
      AMR: 'Interior Derecho',
      AMC: 'Mediapunta',
      AML: 'Interior Izquierdo',
      FWR: 'Extremo Derecho',
      FW: 'Delantero',
      FWL: 'Extremo Izquierdo'
    },
    metrics: {
      categories: {
        Association: 'Asociación',
        Saving: 'Paradas',
        Shooting: 'Finalización',
        Defending: 'Defensivas',
        Passing: 'Pases',
        BallHandling: 'Control',
        Aerial: 'Aéreas',
        Physical: 'Físicas',
        Predictive: 'Predictivo',
        Arrigo: 'Arrigo',
        Score: 'Score',
        Turnovers: 'Pérdidas',
        Carries: 'Conducciones',
        SequenceInvolvement: 'Participación en Posesiones',
        Crosses: 'Centros',
        Distance: 'Distancia',
        Sprint: 'Sprint',
        Acceleration: 'Aceleración',
        MaxAcceleration: 'Aceleración máxima',
        Speed: 'Velocidad',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Pases entre Líneas',
        LineBreakingCarries: 'Conducciones entre Líneas',
        LineBreakingActions: 'Acciones entre Líneas',
        PassUnderPressure: 'Pase Bajo Presión',
        BallReceived: 'Balón Recibido',
        PassesUnderPressure: 'Pases Bajo Presión',
        OnBallPressureReceived: 'Presión al Balón Recibida',
        OnBallPressure: 'Presión al Balón',
        BallReceiptsInSpace: 'Recepciones en Espacio',
        SpatialCoverage: 'Control del Campo',
        OffBallPressure: 'Presión sin Balón',
        OffBallRuns: 'Desmarques',
        NoCategory: 'Otros',
        subcategories: {
          Quality: 'Calidad',
          Quantity: 'Cantidad',
          TeamComparison: 'Comparación de equipos',
          Receptions: 'Recepciones',
          LongBalls: 'Balones largos',
          Efficiency: 'Eficiencia',
          Ratio: 'Ratio',
          Defensive: 'Defensivo',
          Offensive: 'Ofensivo',
          Foot: 'Pie',
          Progression: 'Progresión',
          TopValue: 'Valor máximo',
          Predictive: 'Predictivo',
          Distance: 'Distancia',
          Aerial: 'Aéreas',
          Crosses: 'Centros',
          NoCategory: 'Otros'
        },
        desc: {
          Association: 'Asociación',
          Saving: 'Paradas',
          Shooting: 'Finalización',
          Defending: 'Defensivas',
          Passing: 'Pases',
          BallHandling: 'Control',
          Aerial: 'Aéreas',
          Physical: 'Físicas',
          Predictive: 'Predictivo',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Pérdidas',
          Carries: 'Conducciones',
          SequenceInvolvement: 'Participación en Posesiones',
          Crosses: 'Centros',
          Distance: 'Distancia cubierta a diferentes velocidades',
          Sprint: 'Carreras a diferentes velocidades',
          Acceleration: 'Aceleración',
          Speed: 'Velocidad',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Pases entre Líneas',
          LineBreakingCarries: 'Conducciones entre Líneas',
          LineBreakingActions: 'Acciones entre Líneas',
          PassUnderPressure: 'Pase Bajo Presión',
          BallReceived: 'Balón Recibido',
          OnBallPressureReceived: 'Presión al Balón Recibida',
          OnBallPressure: 'Presión al Balón',
          BallReceiptsInSpace: 'Recepciones en Espacio',
          SpatialCoverage: 'Control del Campo',
          OffBallPressure: 'Presión sin Balón',
          OffBallRuns: 'Desmarques'
        },
        abbr: {
          Association: 'Asociación',
          Saving: 'Paradas',
          Shooting: 'Finalización',
          Defending: 'Defensivas',
          Passing: 'Pases',
          BallHandling: 'Control',
          Aerial: 'Aéreas',
          Physical: 'Físicas',
          Predictive: 'Pred.',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Pérdidas',
          Carries: 'Conducc.',
          SequenceInvolvement: 'Part. en Pos.',
          Crosses: 'Centros',
          Distance: 'Distancia',
          Sprint: 'Sprint',
          Acceleration: 'Aceleración',
          MaxAcceleration: 'Aceleración Max.',
          Speed: 'Velocidad',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Pases entre Líneas',
          LineBreakingCarries: 'Conducciones entre Líneas',
          LineBreakingActions: 'Acciones entre Líneas',
          PassUnderPressure: 'Pase Bajo Presión',
          BallReceived: 'Balón Recibido',
          OnBallPressureReceived: 'Presión al Balón Recibida',
          OnBallPressure: 'Presión al Balón',
          BallReceiptsInSpace: 'Recepciones en Espacio',
          SpatialCoverage: 'Control del Campo',
          OffBallPressure: 'Presión sin Balón',
          OffBallRuns: 'Desmarques'
        }
      },
      types: {
        1: 'Por 90',
        2: 'Porcentaje',
        3: 'Ratio',
        4: 'Eficiencia',
        5: 'Media',
        6: 'Por Partido',
        7: 'Diferencia',
        8: 'Max'
      },
      moreInfo: 'Puedes leer más aquí'
    },
    api: {
      subtitle: 'Recopila datos de diferentes peticiones',
      resourcesTitle: 'Recursos',
      authentication: 'Autenticación',
      authText: 'Para realizar llamadas a la API debe incluir en cada petición la cabecera `Authorization` con valor `Bearer {API_TOKEN}`',
      generate: 'Generar',
      tokenPlaceholder: 'Si no tienes token o te ha caducado, pincha en \'Generar\'',
      pathParameters: 'Parámetros de ruta',
      queryParameters: 'Parámetros de consulta',
      responseModel: 'Módelo de respuesta',
      tokenWarning: '* Genera un token para poder probar la API',
      pathParamsWarning: '* Hay parámetros de ruta sin rellenar',
      genericDescription: 'Una API (Interfaz de Programación de Aplicaciones) permite a los desarrolladores acceder e integrar datos o funcionalidades en sus propias aplicaciones. Nuestra API de estadísticas de fútbol proporciona acceso integral a una variedad de datos sobre países, competiciones, equipos, jugadores, partidos y más. Al utilizar esta API, puedes desarrollar aplicaciones que aprovechen nuestros ricos datos de fútbol para análisis, visualizaciones u otras soluciones innovadoras.',
      methods: {
        getAllCountries: 'Este método devuelve una lista completa de todos los países disponibles en la API, proporcionando detalles clave como el identificador único y el nombre de cada país. Este endpoint es ideal para aplicaciones que requieren datos geográficos de fútbol, habilitando funciones como selección de país, filtrado y análisis. También sirve como un recurso fundamental para interactuar con otros endpoints que dependen de un parámetro `countryId`, asegurando una navegación e integración fluida con el conjunto de datos más amplio de la API.',
        getCountryDetail: 'Este método proporciona información detallada sobre un país específico disponible en la API. Al usar este endpoint, puedes devuelver datos como el nombre del país, su código y cualquier metadato relevante asociado. Este método es particularmente útil para aplicaciones que necesitan detalles específicos del país para mejorar la experiencia del usuario, como mostrar información contextual o crear análisis personalizados basados en datos geográficos. Complementa otros endpoints al permitir una exploración más profunda de un país seleccionado.',
        getCountryCompetitions: 'Este método devuelve una lista de todas las competiciones disponibles dentro de un país específico. Es un recurso valioso para construir funciones que permitan a los usuarios explorar competiciones por región, proporcionando una forma fluida de conectar datos de países con sus torneos asociados. Este endpoint es esencial para aplicaciones centradas en contenido de fútbol localizado o análisis regionales.',
        getAllCompetitionTypes: 'Este método devuelve una lista de todos los tipos de competiciones disponibles en la API, como ligas, copas y torneos internacionales. Este endpoint es ideal para categorizar competiciones y proporcionar a los usuarios una vista organizada de los diferentes tipos de eventos cubiertos. Es especialmente útil para construir funciones como filtros o menús desplegables que permitan a los usuarios explorar datos de fútbol según la naturaleza de la competición.',
        getAllCompetitions: 'Este método devuelve una lista completa de todas las competiciones disponibles en la API, independientemente del tipo o ubicación. Este endpoint es útil para aplicaciones que necesitan mostrar o analizar una amplia gama de competiciones de fútbol, permitiendo a los usuarios explorar y seleccionar eventos de interés.',
        getCompetitionAvailable: 'Este método devuelve una lista de competiciones que están marcadas como disponibles en la API. Esto asegura que los datos devueltos estén actualizados y listos para usarse en aplicaciones. Es particularmente útil para desarrolladores que crean funciones que dependen de competiciones activas o accesibles, permitiendo a los usuarios explorar eventos relevantes sin encontrar datos obsoletos o incompletos.',
        getCompetitionDetail: 'Este método proporciona información detallada sobre una competición específica disponible en la API. Es particularmente útil para aplicaciones que necesitan información en profundidad sobre una competición, habilitando funciones como vistas detalladas, análisis contextuales o opciones de filtrado basadas en las características de la competición.',
        getCompetitionSeasons: 'Este método devuelve una lista de todas las temporadas asociadas con una competición específica. Este endpoint es esencial para aplicaciones que buscan proporcionar una cobertura completa de la historia o el estado actual de una competición, permitiendo a los usuarios explorar datos temporada por temporada.',
        getSeasonAvailable: 'Este método proporciona una lista de temporadas que están marcadas como disponibles en la API. Es particularmente útil para aplicaciones que se centran en eventos de fútbol en vivo o en curso, permitiendo a los usuarios interactuar con datos de temporadas relevantes y actuales.',
        getSeasonDetail: 'Este método devuelve información detallada sobre una temporada específica, incluyendo su cronología, la competición asociada y metadatos clave. Este endpoint es esencial para aplicaciones que necesitan perspectivas en profundidad sobre una temporada en particular, habilitando funciones como vistas generales de temporada, filtrado por competición o mostrando cronologías detalladas para la interacción del usuario.',
        getSeasonTeams: 'Este método proporciona una lista de todos los equipos que participan en una temporada específica. Es ideal para funciones como la gestión de plantillas, análisis de rendimiento de equipos o la creación de filtros específicos de temporada para los usuarios.',
        getSeasonPlayer: 'Este método devuelve una lista de todos los jugadores registrados en una temporada específica. Es ideal para desarrollar funciones como plantillas de jugadores, seguimiento del rendimiento o el filtrado de jugadores en función de la temporada seleccionada.',
        getSeasonPlayerStats: 'Este método proporciona estadísticas detalladas para todos los jugadores en una temporada específica. Es particularmente útil para aplicaciones centradas en análisis, comparaciones de jugadores o la creación de visualizaciones dinámicas de logros de los jugadores durante la temporada.',
        getSeasonArrigoMetrics: 'Este método proporciona estadísticas combinadas para todos los jugadores en una temporada específica. Es particularmente útil para aplicaciones centradas en análisis, comparaciones de jugadores o la creación de visualizaciones dinámicas de logros de los jugadores durante la temporada.',
        getSeasonTeamStats: 'Este método proporciona estadísticas completas de todos los equipos que participan en una temporada específica. Es particularmente útil para aplicaciones centradas en análisis de equipos, resúmenes de temporada o comparaciones de rendimiento de equipos a lo largo de la temporada.',
        getSeasonCoaches: 'Este método devuelve una lista de todos los entrenadores que dirigieron equipos durante una temporada específica. Es particularmente útil para aplicaciones que se centran en perspectivas de temporada, análisis de entrenadores o el seguimiento de cambios en la dirección de equipos a lo largo de una temporada.',
        getSeasonGames: 'Este método proporciona una lista de todos los partidos jugados en una temporada específica. Es ideal para aplicaciones que necesitan mostrar calendarios completos de temporada, analizar resultados de partidos o proporcionar a los usuarios acceso a datos completos de partidos de la temporada.',
        getSeasonGamesMatchday: 'Este método devuelve todos los partidos de una jornada específica dentro de una temporada dada. Es particularmente útil para aplicaciones que buscan mostrar calendarios de jornadas, analizar rondas específicas o proporcionar perspectivas enfocadas en un conjunto particular de partidos durante la temporada.',
        getSeasonLeagueTable: 'Este método proporciona la tabla de clasificación de una temporada específica, incluyendo posiciones, puntos, victorias, empates, derrotas y otras estadísticas relevantes para cada equipo. Este endpoint es esencial para aplicaciones centradas en el seguimiento de clasificaciones de equipos, análisis de progresión de ligas o la presentación de clasificaciones actualizadas a lo largo de la temporada.',
        getTeamDetail: 'Este método proporciona información detallada sobre un equipo específico, incluyendo su nombre, año de fundación, estadio y otros metadatos. Este endpoint es ideal para aplicaciones que necesitan perspectivas específicas de equipos, habilitando funciones como perfiles detallados de equipos, contexto histórico o experiencias de usuario mejoradas con datos ricos relacionados con equipos.',
        getTeamLoans: 'Este método devuelve información sobre transacciones de cesiones que involucran a un equipo específico. Este endpoint es particularmente útil para aplicaciones centradas en análisis de transferencias, gestión de plantillas de equipos o seguimiento de movimientos de jugadores durante una temporada.',
        getTeamRoster: 'Este método proporciona una lista completa de jugadores en la plantilla de un equipo específico. Es ideal para aplicaciones que necesitan mostrar alineaciones de equipos, analizar roles de jugadores o gestionar funcionalidades relacionadas con la plantilla de un equipo.',
        getTeamGames: 'Este método devuelve una lista de todos los partidos jugados por un equipo específico. Es particularmente útil para aplicaciones centradas en el rendimiento de equipos, seguimiento de horarios o proporcionar a los usuarios acceso al historial completo de partidos de un equipo.',
        getTeamGameStats: 'Este método proporciona estadísticas detalladas para un equipo específico en un partido dado. Es particularmente útil para aplicaciones centradas en análisis de partidos, evaluaciones de rendimiento o desglose en profundidad del rendimiento de un equipo en partidos individuales.',
        getTeamTransfers: 'Este método devuelve información sobre transacciones de transferencias que involucran a un equipo específico. Es particularmente útil para aplicaciones que se centran en análisis del mercado de transferencias, cambios en la plantilla de equipos o seguimiento de movimientos de jugadores a lo largo del tiempo.',
        getGameStatus: 'Este método proporciona una lista de todos los posibles estados de un partido disponibles en la API, como programado, en progreso, finalizado, pospuesto o cancelado. Este endpoint es particularmente útil para aplicaciones que requieren seguimiento en tiempo real de partidos, filtrado de partidos por estado o proporcionar a los usuarios actualizaciones claras sobre el progreso o estado de un encuentro.',
        getPlayerPositions: 'Este método devuelve una lista de todas las posiciones posibles de los jugadores, como portero, defensor, mediocampista y delantero. Este endpoint es particularmente útil para aplicaciones que categorizan jugadores, analizan datos posicionales o permiten a los usuarios filtrar jugadores según sus roles en el campo.',
        getGameDetail: 'Este método proporciona información completa sobre un partido específico, incluyendo detalles como los equipos participantes, fecha y hora, estadio, marcador y otros metadatos clave. Este endpoint es ideal para aplicaciones que necesitan perspectivas detalladas sobre partidos, habilitando funciones como previas detalladas, informes o análisis.',
        getGameStats: 'Este método proporciona estadísticas detalladas para un partido específico, incluyendo métricas como goles, remates, porcentajes de posesión, pases y acciones defensivas. Este endpoint es particularmente útil para aplicaciones centradas en el análisis de partidos, informes post-partido o visualizaciones del rendimiento de los equipos durante un encuentro.',
        getGamePlayerStats: 'Este método devuelve estadísticas detalladas de rendimiento para todos los jugadores que participaron en un partido específico. Es particularmente útil para aplicaciones que analizan el rendimiento individual de los jugadores, generan informes de partidos o comparan jugadores dentro del contexto de un único partido.',
        getGamePlayerPhysicalStats: 'Este método proporciona métricas detalladas de rendimiento físico para los jugadores en un partido específico. Es particularmente útil para aplicaciones centradas en el análisis de la condición física de los jugadores, el seguimiento del rendimiento físico o la generación de perspectivas detalladas de los jugadores en un partido.',
        getGameTeamPhysicalStats: 'Este método proporciona métricas detalladas de rendimiento físico de los equipos en un partido específico. Esto incluye datos como la distancia total recorrida, número de sprints, carreras de alta intensidad y otros atributos físicos. Es particularmente útil para aplicaciones centradas en el análisis de la condición física del equipo, la comparación de esfuerzos físicos entre equipos o la evaluación del rendimiento general en un partido.',
        getGamePlayerArrigoMetrics: 'Este método proporciona métricas detalladas de arrigo para los jugadores en un partido específico. Es particularmente útil para aplicaciones centradas en el análisis de la generación de perspectivas detalladas de los jugadores en un partido.',
        getGameTeamArrigoMetrics: 'Este método proporciona métricas detalladas de arrigo de los equipos en un partido específico. Esto incluye datos como jugadores superados y otros atributos. Es particularmente útil para aplicaciones centradas en el análisis de la evaluación del rendimiento general en un partido.',
        getGameLineup: 'Este método devuelve la alineación de un partido específico, incluyendo los jugadores titulares, suplentes y sus respectivas posiciones. Este endpoint es particularmente útil para aplicaciones que muestran información previa al partido, analizan las formaciones de los equipos o proporcionan perspectivas sobre decisiones tácticas tomadas por los equipos para un partido dado.',
        getGameTimeline: 'Este método proporciona una lista cronológica de eventos que ocurrieron durante un partido específico. Es particularmente útil para aplicaciones que ofrecen actualizaciones en vivo de los partidos, resúmenes post-partido o análisis detallados de los eventos del juego.',
        getGameTracking: 'Este método proporciona un enlace para descargar el archivo de datos de tracking de un partido específico. Este archivo contiene datos detallados de movimiento y posicionamiento de los jugadores y el balón durante el partido. Es particularmente útil para aplicaciones centradas en análisis avanzados, análisis tácticos o la creación de visualizaciones de los movimientos de los jugadores y el balón durante el juego.',
        getGameEventing: 'Este métdodo devuelve todos los eventos',
        getGameTs: 'Este métdodo devuelve la última fecha del partido',
        getGameFileTypes: 'Este métdodo devuelve los tipos de ficheros de partido',
        getTrackingStatus: 'Este método devuelve una lista completa de todos los estados disponibles en el tracking, proporcionando detalles clave como el identificador único y el nombre de cada estado. Este endpoint es ideal para aplicaciones que requieren seguimiento de partidos, habilitando funciones como selección de estado, filtrado y análisis. También sirve como un recurso fundamental para interactuar con otros endpoints que dependen de un parámetro `statusId`, asegurando una navegación e integración fluida con el conjunto de datos más amplio de la API.',
        getPlayerTransfersTypes: 'Este método devuelve una lista de posibles tipos de traspasos de jugadores, como traspaso permanente, cesión, traspaso libre o intercambio. Este endpoint es particularmente útil para aplicaciones que analizan tendencias del mercado de fichajes, categorizan movimientos de jugadores o proporcionan a los usuarios perspectivas detalladas sobre los tipos de transacciones que involucran a jugadores.',
        getPlayerDetail: 'Este método proporciona información detallada sobre un jugador específico, incluyendo datos personales, estadísticas de carrera y afiliación actual con su equipo. Este endpoint es ideal para aplicaciones que ofrecen perfiles de jugadores, perspectivas históricas o análisis del rendimiento individual de los jugadores y sus trayectorias profesionales.',
        getPlayerGames: 'Este método devuelve una lista de todos los partidos en los que ha participado un jugador específico. Es particularmente útil para aplicaciones centradas en el seguimiento del rendimiento de jugadores, el análisis de historial de partidos o para proporcionar a los usuarios registros completos de partidos de jugadores individuales.',
        getPlayerInjuries: 'Este método proporciona un registro detallado de las lesiones sufridas por un jugador específico. Es particularmente útil para aplicaciones centradas en el análisis de salud de los jugadores, evaluaciones del impacto en su carrera o el seguimiento de los tiempos de recuperación.',
        getPlayerNationalTeam: 'Este método devuelve información detallada sobre la participación de un jugador en partidos de selecciones nacionales. Es particularmente útil para aplicaciones que se centran en el rendimiento de los jugadores a nivel nacional, el seguimiento de carreras internacionales o proporcionar perspectivas sobre las contribuciones durante torneos y amistosos.',
        getPlayerSeasons: 'Este método proporciona una lista de todas las temporadas en las que ha participado un jugador específico. Es particularmente útil para aplicaciones que rastrean la progresión de la carrera de un jugador, analizan el rendimiento a lo largo de las temporadas o proporcionan un contexto histórico sobre sus logros.',
        getPlayerTransfers: 'Este método devuelve un historial detallado de las transacciones de traspaso que involucran a un jugador específico. Es particularmente útil para aplicaciones centradas en el análisis de la carrera de un jugador, perspectivas del mercado de fichajes o el seguimiento de los movimientos de los jugadores entre equipos a lo largo del tiempo.',
        getPlayerSeasonTeamStats: 'Este método proporciona estadísticas detalladas de rendimiento para un jugador específico durante una temporada en particular con un equipo. Es particularmente útil para aplicaciones centradas en el análisis del jugador a lo largo de la temporada, comparaciones entre equipos o temporadas, y el seguimiento de las contribuciones individuales al éxito del equipo.',
        getPlayerSeasonPhysicalStats: 'Este método proporciona métricas detalladas de rendimiento físico para un jugador específico durante una temporada. Es particularmente útil para aplicaciones que se centran en el seguimiento de la condición física del jugador, el análisis del rendimiento físico o la evaluación de la carga de trabajo de un jugador durante una temporada.',
        getPlayerSeasonGamePhysicalStats: 'Este método proporciona métricas detalladas de rendimiento físico para un jugador específico en cada partido de una temporada. Es particularmente útil para aplicaciones centradas en el análisis físico específico de partidos, el seguimiento de la carga de trabajo de los jugadores o la comparación del rendimiento físico en diferentes encuentros.',
        getPlayerSeasonGameStats: 'Este método devuelve estadísticas detalladas de rendimiento para un jugador específico en cada partido de una temporada. Es particularmente útil para aplicaciones centradas en el análisis de jugadores en partidos individuales, tendencias de rendimiento o comparaciones detalladas entre encuentros dentro de una temporada.',
        getCoachDetail: 'Este método proporciona información detallada sobre un entrenador específico, incluyendo su nombre, historial profesional, equipos dirigidos y logros destacados. Este endpoint es particularmente útil para aplicaciones que destacan perfiles de entrenadores, rastrean carreras de directores técnicos o analizan el impacto de los entrenadores en el rendimiento del equipo.',
        getCoachHistory: 'Este método devuelve un historial completo de la carrera de un entrenador específico, incluyendo los equipos que ha dirigido, competiciones en las que ha participado y las duraciones de sus mandatos. Este endpoint es particularmente útil para aplicaciones que se centran en analizar carreras de entrenadores, rastrear cambios en la dirección técnica o proporcionar perspectivas sobre la trayectoria profesional y logros de un entrenador.',
        getLinkStream: 'Este método devuelve el enlace para visualizar el video de un partido',
        getLinkDownload: 'Este método devuelve el enlace para descargar el video de un partido',
        deletePlayer: 'Este método elimina un jugador'
      },
      responseCodes: 'Códigos de respuesta',
      furtherInformation: 'Para mas información consulte la guía en el siguiente enlace',
      clipboard: '¡Copiado al portapapeles!',
      limit50: 'Solo se muestran los primeros 50 resultados'
    }
  },
  globalSearch: {
    subtitle: 'Filtrado intensivo'
  },
  global: {
    teamElos: {
      title: 'ELO de Equipos',
      subtitle: 'Clasificaciones globales de equipos y análisis',
      team: 'Equipo',
      teams: 'Equipos',
      dates: 'Fechas',
      excludeInternational: 'Excluir equipos internacionales',
      elo: 'ELO',
      selectButton: 'Seleccionar arriba',
      selectTeamFromTable: 'Selecciona un equipo de la tabla para ver la tendencia ELO.',
      showingTeamAveragesLastSeason: 'Mostrando promedios de equipo de la última temporada',
      showingTeamStatsLastSeason: 'Mostrando solo estadísticas de equipos para su última temporada activa',
      searchToolTip: 'Consejo: Presione Ctrl + B para acceder directamente a la barra de búsqueda',
      selectTopTooltip: 'Mostrar equipos adicionales en el gráfico para comparar',
      loadingPage: 'Preparando los datos...'
    },
    leagueElos: {
      title: 'ELO de Ligas',
      subtitle: 'Clasificaciones de ligas globales y análisis',
      rankings: 'CLASIFICACIONES',
      insights: 'ANÁLISIS',
      filters: 'FILTROS',
      leagues: 'Ligas',
      from: 'Desde',
      to: 'Hasta',
      elo: 'ELO',
      change: 'Cambio',
      league: 'Liga',
      excludeContinental: 'Excluir Competiciones Internacionales',
      eloTrend: 'Tendencia ELO',
      eloRanking: 'Ranking ELO',
      currentELOLabel: '(ELO actual)',
      allTime: 'Todo el Tiempo',
      average: 'Promedio',
      noChartData: 'No hay datos disponibles para los filtros seleccionados.',
      selectLeagueFromTable: 'Selecciona una liga de la tabla para ver la tendencia ELO.',
      noInsightsData: 'No hay datos de insights disponibles para las ligas seleccionadas. Por favor, asegúrese de que las ligas tengan temporadas disponibles y datos de insights de equipos.',
      showingLeagueAveragesLastSeason: 'Mostrando solo promedios de liga para su última temporada activa',
      selectTopTooltip: 'Mostrar ligas adicionales en el gráfico para comparar',
      confederations: {
        world: 'Mundo',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Número de ligas',
      minimumElo: 'ELO Mínimo'
    },
    players: {
      title: 'GPI del jugador',
      subtitle: 'Clasificaciones y conocimientos globales de jugadores',
      gpiRanking: 'Clasificación GPI',
      rankTooltip: 'Pasa el cursor por encima para ver la clasificación global',
      globalRanking: 'Ranking Global',
      player: 'Jugador',
      players: 'Jugadores',
      gpiTrend: 'Tendencia del GPI',
      currentGPILabel: '(GPI actual)',
      nationality: 'País de nacimiento',
      position: 'Posición',
      marketValue: 'Valor comercial',
      apply: 'Aplicar',
      marketValueAndAgeTooltip: 'Ingrese un rango y haga clic en Aplicar o presione Entrar.',
      searchPlaceholder: 'Buscar un jugador...',
      selectTopTooltip: 'Mostrar jugadores adicionales en el gráfico para comparar',
      gpi: 'GPI',
      numberOfPlayers: 'Número de jugadores',
      showingPlayerStatsLastSeason: 'Mostrando solo estadísticas promedio de jugadores para su última temporada activa',
      date: 'FECHA',
      showChartLabels: 'Mostrar etiquetas',
      marketValueTooltip: 'Ingrese un rango y haga clic en Aplicar o presione Entrar.',
      freeAgents: 'Agentes Libres',
      selectPlayerFromTable: 'Selecciona un jugador de la tabla para ver la tendencia de GPI.',
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Bélgica',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canadá',
    CF: 'República Central Africana',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'RD Congo',
    CG: 'Congo',
    CI: 'Costa de Marfil',
    CU: 'Cuba',
    CZ: 'República Checa',
    DJ: 'Djibouti',
    DO: 'República Dominicana',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finlandia',
    PF: 'Polinesia Francesa',
    GM: 'Gambia',
    DE: 'Alemania',
    GI: 'Gibraltar',
    GL: 'Groenlandia',
    GP: 'Guadalupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungría',
    IN: 'India',
    IR: 'Irán',
    IE: 'Irlanda',
    IT: 'Italia',
    JP: 'Japón',
    KZ: 'Kazajistán',
    KI: 'Kiribati',
    KR: 'Corea del sur',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lituania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malasia',
    ML: 'Mali',
    MH: 'Islas Marshall',
    MR: 'Mauritania',
    MX: 'México',
    MD: 'Moldavia',
    MN: 'Mongolia',
    MA: 'Marruecos',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Holanda',
    NZ: 'Nueva Zelanda',
    NE: 'Nigeria',
    MP: 'Islas Marianas',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Filipinas',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Rumania',
    RW: 'Ruanda',
    LC: 'Santa Lucia',
    SM: 'San Marino',
    SA: 'Arabia Saudi',
    RS: 'Serbia',
    SL: 'Sierra Leona',
    SK: 'Eslovaquia',
    SB: 'Islas Salomon',
    ZA: 'Sudáfrica',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Esuatini',
    CH: 'Suiza',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad y Tobago',
    TR: 'Turquía',
    TV: 'Tuvalu',
    UA: 'Ucrania',
    GB: 'Reino Unido',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Islas Virgenes Británicas',
    EH: 'Sahara Oester',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua y Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia y Herzegovina',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Camerún',
    CV: 'Cabo Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Comoras',
    CR: 'Costa Rica',
    HR: 'Croacia',
    CY: 'Chipre',
    DK: 'Dinamarca',
    DM: 'Dominica',
    TL: 'Timor Oriental',
    EG: 'Egipto',
    GQ: 'Guinea Ecuatorial',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'Francia',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Grecia',
    GD: 'Granada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haití',
    HK: 'Hong Kong SAR',
    IS: 'Islandia',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordania',
    KE: 'Kenya',
    KP: 'Corea del norte',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxemburgo',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldivas',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Mónaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibiar',
    NP: 'Nepal',
    NC: 'Nueva Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Noruega',
    PK: 'Pakistan',
    PS: 'Territorios Palestinos',
    PG: 'Papua Nueva Guinea',
    PE: 'Perú',
    PL: 'Polonia',
    PR: 'Puerto Rico',
    RE: 'Réunion',
    RU: 'Federación Rusa',
    KN: 'San Cristobal y Nieves',
    WS: 'Samoa',
    ST: 'Santo Tomé y Príncipe',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapur',
    SI: 'Eslovenia',
    SO: 'Somalia',
    ES: 'España',
    VC: 'San Vicente y las Granadinas',
    SR: 'Suriname',
    SE: 'Suecia',
    SY: 'Siria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunez',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'Emiratos Arabes Unidos',
    US: 'Estados Unidos',
    UZ: 'Uzbekistan',
    VA: 'Ciudad del Vaticano',
    VN: 'Vietnam',
    VI: 'Islas Virgenes de los Estados Unidos',
    YE: 'Yemen',
    ZW: 'Zimbabue',
    EU: 'Europa',
    INT: 'Internacional',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'Inglaterra',
    'GB-WLS': 'Gales',
    'GB-SCT': 'Escocia',
    LATAM: 'Ámerica del sur',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Antillas Neerlandesas',
    AS: 'Samoa Americana',
    AW: 'Aruba',
    BM: 'Bermudas',
    BQ: 'Bonaire, SE y Saba',
    CK: 'Islas Cook',
    FO: 'Islas Feroe',
    GF: 'Guyana',
    GG: 'Bailía de Guernesey',
    GU: 'Territorio de Guam',
    IM: 'La Isla de Man',
    JE: 'Bailía de Jersey',
    KY: 'Las Islas Caimán',
    MF: 'La Colectividad de San Martín',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceanía',
    RI: 'Indonesia',
    SS: 'República de Sudán del Sur',
    TC: 'Islas Turcas y Caicos',
    YT: 'Departamento de Mayotte',
    SX: 'San Martín'
  },
  loadingMessages: {
    players: 'Preparando jugadores',
    teams: 'Ordenando equipos',
    games: 'Recuperando partidos',
    stats: 'Calculando métricas',
    graphs: 'Trazando gráficas',
    gettingReady: 'Calentando en la banda',
    placeholder: 'Cargando'
  },
  requestReport: {
    subtitle: 'Recibe un informe en profundidad con lo que necesitas',
    categories: {
      scouting: {
        title: 'Scouting',
        subtitle: '¿Quiénes son los mejores jugadores de una liga? ¿y de varias ligas? Haz una petición a medida, con los filtros que consideres oportunos (edad, altura, finalización de contrato) y descubre los jugadores que encajan mejor.'
      },
      coaches: {
        title: 'Entrenadores',
        subtitle: '¿Cómo juega un entrenador y cómo se adaptaría su estilo y juego a tu club? Obtén información detallada o, dado un perfil, conoce qué entrenadores cubren tus necesidades.'
      },
      'team analysis': {
        title: 'Análisis de equipo',
        subtitle: 'Obtén un resumen detallado sobre un equipo: estilo, rendimiento defensivo y ofensivo, puntos débiles, mejores jugadores, etc...'
      },
      'game analysis': {
        title: 'Análisis de partido',
        subtitle: 'Dado un partido, obten un análisis pre/post partido con información detallada'
      },
      'special projects': {
        title: 'Proyectos Especiales',
        subtitle: '¿Cómo rinde un jugador fuera de casa? ¿cómo cambian los jugadores de liga a liga? ¿qué jugadores podríamos encontrar para una cesión? Solicita cualquier duda que se te ocurra.'
      },
      conversation: {
        title: 'Conversación',
        subtitle: 'Comenzar una conversación con nuestro equipo'
      }
    },
    notesPlaceholder: 'Indica liga, perfil, entrenador, equipo o partido sobre el que necesitas información',
    chooseType: 'Selecciona un tipo de informe',
    requestSummary: 'Resumen de la solicitud',
    reportType: 'Tipo de informe',
    reportLanguage: 'Idioma del informe',
    detailTitle: 'Seguimiento del informe',
    detailSubtitle: 'Toda la info del informe que solicitaste'
  },
  bugReport: {
    modalSubtitle: 'Ayúdanos a mejorar',
    about: 'Acerca de',
    sendSuccess: 'Enviada con éxito. Compruebe actualizaciones desde la bandeja de entrada',
    bugs: 'Errores'
  },
  gbe: {
    autopass: 'Auto Pass',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Continental Competition',
    points: 'Points',
    titleWinner: 'Title Winner',
    qualifiedGroupsBandX: 'Qualified for group stage of a Band {0} Continental Competition',
    qualifiedQualifiersBandX: 'Qualified for qualifiers of a Band {0} Continental Competition',
    midTable: 'Mid-Table',
    relegation: 'Relegation',
    promotion: 'Promotion',
    final: 'Final',
    semifinal: 'Semifinales',
    quarterfinal: 'Cuartos de Final',
    round16: 'Octavos',
    round32: 'Dieciseisavos',
    groupstage: 'Fase de Grupos',
    firstRound: '1ª Ronda',
    secondRound: '2ª Ronda',
    thirdRound: '3ª Ronda',
    fourthRound: '4ª Ronda',
    preliminaryRound: 'Ronda Preliminar',
    other: 'Other',
    score: 'Score',
    totalSummary: 'Total Summary',
    currentlyPlayingInUK: 'The player is a citizen of the United Kingdom or Ireland, or the player is a permanent resident in the United Kingdom',
    bandsAlert: 'There are minutes played in more than one band, total is the max value',
    bandsAlertMax: 'There are minutes played in more than one band, total is the max value',
    bandsAlertAvg: 'There are minutes played in more than one band, total is the average value',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut juvenil',
    table1: {
      name: 'Player´s International Appearances',
      title1: 'Aggregated FIFA World Ranking of the Player’s National Association',
      title2: 'Player’s International Appearances'
    },
    table2: {
      name: 'Player’s Domestic Minutes',
      title1: 'Player’s Domestic Minutes'
    },
    table3: {
      name: 'Player’s Continental Minutes',
      title1: 'Player’s Continental Minutes'
    },
    table4: {
      name: 'Final League Position of Player´s Last Club',
      title1: 'Last Club’s Final League Position'
    },
    table5: {
      name: 'Continental Progression of Player´s Last Club',
      title1: 'Continental Progression'
    },
    table6: {
      name: 'League Quality of Player´s Current Club',
      title1: 'Band of Player’s Current Club'
    },
    table7: {
      name: 'Youth - Debut',
      title1: 'Band'
    },
    table8: {
      name: 'Youth - Final League Position',
      title1: 'Last Club’s Final League Position'
    },
    table9: {
      name: 'Youth - Continental Progression',
      title1: 'Continental Progression'
    },
    table10: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club'
    },
    table11: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club'
    },
    table12: {
      name: 'Youth - International Appearances',
      title1: 'Player\'s International Appearances'
    }
  },
  mediaMode: {
    borderColor: 'Color del borde',
    fillColor: 'Color del relleno',
    bgColor: 'Color del fondo',
    upperText: 'Texto superior',
    lowerText: 'Texto inferior',
    socialMedia: 'Redes sociales',
    textColor: 'Color del texto',
    axisColor: 'Color de los ejes',
    logo: 'Logo',
    comparisonBorderColor: 'Color del borde comparación',
    comparisonFillColor: 'Color del fondo comparación',
    comparisonUpperText: 'Texto superior comparación',
    comparisonLowerText: 'Texto inferior comparación',
    homeFillColor: 'Color del relleno (Local)',
    homeBorderColor: 'Color del borde (Local)',
    awayFillColor: 'Color del relleno (Visitante)',
    awayBorderColor: 'Color del borde (Visitante)',
    face: 'Cara',
    nationalTeam: 'Selección',
    comparisonFace: 'Cara comparación',
    upperTextX: 'Texto superior {0}',
    lowerTextX: 'Texto inferior {0}',
    borderColorX: 'Color del borde {0}',
    fillColorX: 'Color del relleno {0}',
    homeFillColorX: 'Color del relleno (Local) {0}',
    homeBorderColorX: 'Color del borde (Local) {0}',
    awayFillColorX: 'Color del relleno (Visitante) {0}',
    awayBorderColorX: 'Color del borde (Visitante) {0}',
    faceX: 'Cara {0}',
    selectField: 'Selecciona una propiedad',
    orientationX: 'Orientación {0}',
    searchBarPlaceholder: 'Busca jugadores y/o partidos...',
    title: 'Media - Cuadro de mandos',
    pageSubtitle: 'Explora y descarga mapas y gráficos',
    chooseChart: 'Selecciona gráfico...',
    headerTextX: 'Texto cabecera {0}',
    avatarLineLength: 'Longitud línea avatar',
    avatarLineWeight: 'Grosor línea avatar',
    avatarSize: 'Tamaño avatar',
    chartX: 'Gráfico {0}',
    chartHeaderFontSize: 'Tamaño título gráficos',
    chartHeaderFontWeight: 'Grosor títuto gráficos',
    upperTextFontSize: 'Tamaño texto superior',
    upperTextFontWeight: 'Grosor texto superior',
    lowerTextFontSize: 'Tamaño texto inferior',
    lowerTextFontWeight: 'Grosor texto inferior',
    socialMediaFontSize: 'Tamaño texto redes sociales',
    socialMediaFontWeight: 'Grosor texto redes sociales',
    subtitle: 'Subtítulo',
    subtitleFontSize: 'Tamaño subtítulo',
    subtitleFontWeight: 'Grosor subtítulo',
    subtitleX: 'Subtítulo {0}',
    subtitleFontSizeX: 'Tamaño subtítulo {0}',
    subtitleFontWeightX: 'Grosor subtítulo {0}',
    titleX: 'Título {0}',
    titleFontSize: 'Tamaño título',
    titleFontWeight: 'Grosor título',
    sponsor: 'Sponsor',
    fontFamily: 'Fuente'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Informes de scouting',
      GAME_REPORT: 'Informes de partidos',
      MEDICAL_REPORT: 'Informes médicos',
      PHYSICAL_REPORT: 'Informes físicos',
      PSYCHOLOGICAL_REPORT: 'Informes psicológicos',
      OTHER: 'Otros',
      QUICK_NOTES: 'Notas',
      PLAYER_REPORT: 'Informes de jugador',
      GENERAL_COMMENTS: 'Comentarios generales',
      PLAYER_ANALYSIS: 'Análisis de jugador'
    },
    uploadDocument: 'Subir documento',
    notesPlaceholder: 'Indica notas o comentarios descriptivos relacionados al documento',
    notesPlaceholderAlt: 'Indica notas o comentarios descriptivos relacionados al jugador',
    uploadedBy: 'Subido por',
    updatedBy: 'Actualizado por',
    seeNotes: 'Ver notas',
    addNote: 'Añadir nota',
    rating: 'Calificación',
    position: 'Mejor posición',
    physical: 'Físico',
    onBall: 'Con Balón',
    offBall: 'Sin Balón',
    mental: 'Mental',
    potential: 'Potencial',
    conclusion: 'Conclusión',
    recommendation: {
      1: 'Firmar',
      2: 'Seguir',
      3: 'Descartar',
      4: 'Interesante',
      label: 'Recomendación'
    },
    match: 'Partido',
    deleteQuickNote: 'Eliminar nota',
    deleteQuickNoteMessage: 'La nota se eliminará permanentemente. ¿Estás seguro?',
    noQuickNotes: 'Sin datos. ¡Comienza añadiendo algunas notas!',
    deleteDocument: 'Eliminar documento',
    deleteDocumentMessage: 'El documento se eliminará permanentemente. ¿Estás seguro?',
    noDocuments: 'Sin datos. ¡Comienza añadiendo algunos documentos!'
  },
  notifications: {
    newReportMessage: 'Hay 1 mensaje nuevo en un informe'
  },
  blog: {
    subtitle: 'Últimos articulos, avances y noticias',
    newEntry: 'Nueva entrada',
    title: 'Título',
    text: 'Texto',
    link: 'Enlace',
    image: 'Imagen',
    author: 'Autor',
    date: 'Fecha de publicación',
    deleteEntry: 'Eliminar entrada',
    deleteEntryMessage: '¿Está seguro que desea eliminar esta entrada?',
    readMore: "Leer más"
  },
  positionsOrlegi: {
    GK: 'Portero',
    DC: 'Central',
    DR: 'Lateral',
    MC: 'Centrocampista',
    AMC: 'Mediapunta',
    FW: 'Delantero',
    FWR: 'Extremo'
  },
  library: {
    subtitle: 'Mira y comparte los documentos subidos',
    mediaSubtitle: 'Mira y comparte los gráficos exportados',
    charts: 'Gráficos',
    goToLibrary: 'Ir a Biblioteca'
  },
  scatterPlot: {
    bubbleSize: 'Burbujas',
    byMinutes: 'Por Minutos',
    byAge: 'Por Edad',
    byMarketValue: 'Por Valor'
  },
  eventChart: {
    successfulEvent: 'Exitoso',
    unsuccessfulEvent: 'Fallado',
    possessionLost: 'Exitoso sin recuperación',
    successfulPass: 'Pase exitoso',
    unsuccessfulPass: 'Pase fallado',
    successfulCarry: 'Conducción acertada',
    unsuccessfulCarry: 'Conducción fallada',
    carryAndKeyPass: 'Conducción y pase',
    carryAndAssist: 'Conducción y asistencia',
    carryAndShot: 'Conducción y tiro',
    ballProgressionAndPass: 'Prog. Balón con Éxito y Pase',
    ballProgression: 'Progresión de balón',
    ballProgressionAndKeyPass: 'Prog. Balón y Pase Clave',
    ballProgressionAndAssist: 'Prog. Balón y Asistencia',
    ballProgressionAndShot: 'Prog. Balón y Tiro',
    ballProgressionAndGoal: 'Prog. Balón y Gol',
    pass: 'Pase',
    carryAndPass: 'Conducción y pase',
    carryAndGoal: 'Conducción y gol',
    totalTouches: 'Toques totales',
    totalPasses: 'Pases Totales',
    totalEvents: 'Eventos Totales',
    successful: 'Con éxito',
    unsuccessful: 'Fallado',
    tacklePossessionLost: 'Con éxito - Posesión Perdida',
    gamesSelected: '{count} partidos seleccionados',
    allGamesOfSeason: 'Todos los partidos de la temporada',
    allGamesOfSeasons: 'Todos los partidos de las temporadas',
    allEvents: 'Todos los eventos',
    eventTypesCount: '{count} tipos de eventos'
  },
  event: {
    Pass: 'Pase',
    TakeOn: 'Regate',
    Takeon: 'Regate',
    Foul: 'Falta',
    'Foul taken': 'Falta Recibida',
    Error: 'Error',
    Tackle: 'Tackle',
    Interception: 'Intercepción',
    Clearance: 'Despeje',
    MissedShot: 'Tiro Fallado',
    ShotOnPost: 'Tiro al Poste',
    SavedShot: 'Tiro Parado',
    Goal: 'Gol',
    Aerial: 'Duelo Aéreo',
    BallRecovery: 'Recuperación de Balón',
    Dispossessed: 'Pérdida',
    ChanceMissed: 'Ocasión Fallada',
    BallTouch: 'Toque de Balón',
    BlockedPass: 'Pase Bloqueado',
    Challenge: 'Regateado',
    lossPossession: 'Pérdida de posesión',
    OffsidePass: 'Pase en fuera de juego',
    groundDuelsLost: 'Duelos en el suelo perdidos',
    'Ball touch': 'Toque',
    Smother: 'Cobertura',
    'Keeper pickup': 'Bola atrapada del suelo',
    'Good skill': 'Movimiento habilidoso',
    Punch: 'Despeje de puños',
    'Saved shot': 'Tiro parado',
    'Shot on post': 'Tiro al palo',
    'Missed shot': 'Tiro fallado',
    Save: 'Parada',
    'Take on': 'Regate',
    'Offside pass': 'Pase fuera de juego',
    Claim: 'Bola atrapada en un centro',
    'Blocked pass': 'Pase Bloqueado',
    KeeperPickup: 'Recogida del guardián',
    'Ball recovery': 'Recuperación de Balón',
    'Ball Recovery': 'Recuperación de Balón',
    'Chance missed': 'Ocasión Fallada',
    'Loss possession': 'Pérdida de posesión',
    Carries: 'Conducción',
    BallProgression: 'Progresión de balón',
    MissedChance: 'Ocasión Fallada',
    Event: 'Evento',
    Shot: 'Tiro',
    Assist: 'Asistencia',
    KeyPass: 'Pase Clave'
  },
  leagueTab: {
    leagueTable: 'Clasificación',
    matchdays: 'Jornadas',
    playerInsights: 'Jugadores clave',
    onlyLocalPlayers: 'Solo Jugadores Locales',
    teamInsights: 'Equipos clave',
    head2head: 'Cara a cara',
    addNewChart: 'Agregar gráfico',
    rounds: {
      W: 'Ganador',
      F: 'Final',
      SF: 'Semifinales',
      QF: 'Cuartos de Final',
      16: 'Octavos de Final',
      32: 'Dieciseisavos de Final',
      GR: 'Fase de Grupos',
      '4R': 'Cuarta Ronda',
      '3R': 'Tercera Ronda',
      '2R': 'Segunda Ronda',
      '1R': 'Primera Ronda',
      PR: 'Ronda Preliminar',
      QPO1: 'Dieciseisavos Nivel Inferior',
      QPO2: 'Previa Dieciseisavos de Final',
      QPO3: 'Previa Treintaidosavos de Final',
    },
    positions: 'Posiciones',
    prediction: 'Predicciones',
    predicted: 'Predicción',
    groups: 'Grupos',
    ranking: 'Clasificación',
    numberOfTeams: 'Número de equipos',
    statsWithMinimum: {
      message: 'Mostrando solo jugadores con más de {0} {1} en la temporada seleccionada',
      dribblesTotal90: 'regates por 90 minutos',
      crosses90: 'centros por 90 minutos',
      tacklesAttempted90: 'entradas intentadas por 90 minutos',
      aerialsTotal90: 'duelos aéreos por 90 minutos'
    },
    numberOfLeagues: 'Número de ligas',
    position: {
      titleWinner: 'Title winner',
      championsLeague: 'Champions League',
      qualifierChampionsLeague: 'Qualifier Champions League',
      europeLeague: 'Europe League',
      qualifierEuropeLeague: 'Qualifier Europe League',
      conferenceLeague: 'Conference League',
      qualifierConferenceLeague: 'Qualifier Conference League',
      midTable: 'Mid-table',
      relegation: 'Relegation',
      promotion: 'Promotion',
      relegationPlayoff: 'Relegation Play-off',
      promotionPlayoff: 'Promotion Play-off',
      championshipGroup: 'Championship Group',
      relegationGroup: 'Relegation Group',
      championshipPlayoffs: 'Championship Playoffs',
      preChampionshipPlayoffs2: 'Pre Championship Playoffs 2',
      preChampionshipPlayoffs3: 'Pre Championship Playoffs 3',
      playoffsQualifierBand3: 'Playoffs Qualifier Band 3',
      continentalGroup: 'Continental Group',
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'I',
      10: 'J',
      11: 'K',
      12: 'L',
    },
  },
  similarity: {
    subtitle: 'Encuentra jugadores similares',
    searchBarPlaceholder: 'Busca y seleccionar un jugador para encontrar similares',
    radarFilters: 'Filtros del radar',
    similarityFilters: 'Filtros de los similares',
    playersFilters: 'Filtros de jugadores',
    similarPlayers: 'Jugadores similares',
    seasonWarning: 'Solo disponibles temporadas habilitadas en el Similarity en las que haya jugado más de 450 minutos'
  },
  squadBuilder: {
    subtitle: 'Crea y modela plantillas únicas',
    playerSelector: 'Catálogo de jugadores',
    loadSquad: 'Cargar plantilla',
    yearsOld: 'años',
    playersPerPosition: 'Jugadores por posición',
    custom: 'Personalizado',
    removeSquad: 'Eliminar Plantilla',
    removeSquadMessage: '¿Está seguro de que desea eliminar la plantilla?',
    deleteSquadSuccess: 'Plantilla eliminada correctamente',
    playerDetails: 'Visibilidad de los detalles',
    ageFormat: 'Formato de la edad',
    mainPlayer: 'Jugador principal',
    showDetails: 'Mostrar detalles',
    all: 'Todos',
    squadPosition: 'Posición en la plantilla',
    noData: 'Sin datos. ¡Empieza añadiendo algunos jugadores al campo!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'No mostrar más',
      skipTour: 'Saltar Visita Guiada',
      previous: 'Previo',
      next: 'Siguiente',
      finish: 'Finalizar'
    },
    playerRadar: {
      step1: {
        title: 'FICHA PERSONAL',
        message: 'Consulta datos básicos del jugador: edad, altura o fecha de contrato'
      },
      step2: {
        title: 'FILTRO GBE',
        message: 'Funcionalidad que permite saber si un jugador tiene puntos GBE suficientes para jugar en el Reino Unido'
      },
      step3: {
        title: 'DISPONIBILIDAD',
        message: 'Consulta porcentaje de minutos disponibles y porcentaje de minutos jugados'
      },
      step4: {
        title: 'POSICIONES',
        message: 'Conoce en qué posiciones ha jugado el futbolista y cuantos minutos ha jugado en cada una de ellas'
      },
      step5: {
        title: 'FORMATOS DE VISUALIZACIÓN',
        message: 'Mide el rendimiento con 4 visualizaciones diferentes, Radar, Polar, Lollipop y Texto, para compararlo con los jugadores de su posición'
      },
      step6: {
        title: 'RADAR DE RENDIMIENTO',
        message: 'Rendimiento de forma visual. El panel es interactivo, puedes pasar el ratón por encima de cada métrica y obtener su definición'
      },
      step7: {
        title: 'SELECCIÓN DE TEMPORADAS',
        message: 'Selecciona o añade temporadas para medir su rendimiento'
      },
      step8: {
        title: 'SELECCIÓN DE PLANTILLA PERSONALIZADA',
        message: 'Utiliza las plantillas personalizadas que hayas creado para medir al jugador con métricas diferentes a las del radar estándar'
      },
      step9: {
        title: 'SELECCIÓN DE POSICIONES JUGADAS',
        message: 'Marca y desmarca las diferentes posiciones para medirlo en la posición que desees'
      },
      step10: {
        title: 'SELECCIÓN DE MÍNIMOS Y MÁXIMOS',
        message: 'Mide al jugador con máximos y mínimos de su temporada, de las cinco grandes ligas o de la temporada propia y predeterminada de cuenta de usuario'
      },
      step11: {
        title: 'COMPARATIVAS',
        message: 'Compara al jugador con su rendimiento previo, con otros jugadores de su posición, con la media de la posición'
      },
      step12: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'TEMPORADA, PLANTILLA Y POSICIÓN',
        message: 'Selecciona temporada, plantilla y posición con la que comparar al futbolista'
      },
      step2: {
        title: 'FILTROS BÁSICOS',
        message: 'Filtra jugadores según su edad, minutos o altura'
      },
      step3: {
        title: 'RESALTA Y EXCLUYE',
        message: 'Resalta los jugadores que quieras y excluye equipos en la visualización'
      },
      step4: {
        title: 'FILTRA POR CATEGORÍA',
        message: 'Selecciona estadísticas por su categoría: Asociación, Defensivas, Pase, Control, etc'
      },
      step5: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'SELECCIONA VISUALIZACIÓN',
        message: 'Puedes ver el mapa de remates en visión cenital, visión portería y en una tabla de distribución'
      },
      step2: {
        title: 'SELECCIÓN DE TEMPORADAS',
        message: 'Añade temporadas para medir su eficacia en el tiro'
      },
      step3: {
        title: 'UBICACIÓN DEL TIRO',
        message: 'Selecciona la posibilidad de ver ubicación exacta del tiro (círculos) o por zonas del área y el campo (áreas)'
      },
      step4: {
        title: 'xG A PUERTA',
        message: 'Marca las casillas de xG a Puerta y xG Finalización para ver qué valor añadido sumó el jugador después del tiro'
      },
      step5: {
        title: 'TIPO DE TIRO',
        message: 'Filtra por tipo de remate, estrategia, área o parte del cuerpo'
      },
      step6: {
        title: 'FILTRA MINUTOS',
        message: 'Barra de minutos para seleccionar remates y goles marcados por tramos concretos de partido'
      },
      step7: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      },
      step8: {
        title: 'MAPA DE TIROS',
        message: 'El mapa es interactivo. Consulta cada circulo con el ratón para saber xG de cada tiro'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SELECCIÓN DE TEMPORADAS',
        message: 'Añade temporadas para medir su eficacia en el tiro'
      },
      step2: {
        title: 'UBICACIÓN DEL PASE CLAVE',
        message: 'Selecciona la posibilidad de ver ubicación exacta del pase clave (círculo) o por zonas del área y el campo (áreas)'
      },
      step3: {
        title: 'TIPO DE REMATE TRAS PASE',
        message: 'Filtra por tipo de remate, estrategia, área o parte del cuerpo realizados tras el pase clave'
      },
      step4: {
        title: 'FILTRA MINUTOS',
        message: 'Barra de minutos para seleccionar remates y goles marcados por tramos concretos de partido'
      },
      step5: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      },
      step6: {
        title: 'MAPA DE PASES',
        message: 'El mapa es interactivo. Consulta cada circulo con el ratón para saber xA de cada pase'
      }
    },
    playerThreat: {
      step1: {
        title: 'SELECCIÓN DE TEMPORADAS',
        message: 'Añade temporadas para medir su eficacia en el tiro'
      },
      step2: {
        title: 'UBICACIÓN DEL PELIGRO',
        message: 'Selecciona la posibilidad de ver ubicación exacta del pase clave (círculo) o por zonas del área y el campo (áreas)'
      },
      step3: {
        title: 'ACCIÓN Y FINALIZACIÓN',
        message: 'Marca y desmarca según el tipo de acción y finalización que quieras visualizar en el mapa'
      },
      step4: {
        title: 'MINUTOS Y PELIGRO',
        message: 'Filtra por periodo, por minutos y por valor de peligrosidad de las acciones'
      },
      step5: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      },
      step6: {
        title: 'MAPA DE PELIGRO',
        message: 'El mapa es interactivo. Consulta cada circulo con el ratón para saber el peligro generado en cada juego xT de cada pase'
      }
    },
    playerTouches: {
      step1: {
        title: 'SELECCIÓN DE PARTIDOS Y EVENTOS',
        message: 'Selecciona el partido y los eventos que quieres visualizar en el mapa'
      },
      step2: {
        title: 'TIPO DE EVENTO',
        message: 'Marca y desmarca según el carácter defensivo u ofensivo del evento del jugador a lo largo del partido'
      },
      step3: {
        title: 'FILTRO DE VISUALIZACIÓN',
        message: 'Filtra el mapa por acciones básicas, mapa de calor, círculos o cajas'
      },
      step4: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      },
      step5: {
        title: 'MAPA DE TOQUES',
        message: 'El mapa es interactivo. Puedes consultar cada evento clicando en cada evento'
      }
    },
    playerAllGames: {
      step1: {
        title: 'DISPONIBILIDAD',
        message: 'Consulta disponibilidad y minutos jugados partido a partido'
      },
      step2: {
        title: 'POSICIONES',
        message: 'Consulta las posiciones y los eventos del jugador (tarjetas, goles, asistencias) en cada partido'
      }
    },
    playerInjuries: {
      step1: {
        title: 'HISTORIAL Y DURACIÓN',
        message: ' Consulta lesiones de último año o del todo el historial y rango de lesiones según su duración en días'
      },
      step2: {
        title: 'LESIONES POR CLUB',
        message: 'Consulta las lesiones separadas por temporada y/o club de su trayectoria'
      }
    },
    playerInfo: {
      step1: {
        title: 'TRAYECTORIA Y TRASPASOS',
        message: 'Puedes consultar historial de minutos, posición o disponibilidad con su club, con su selección y los traspasos del jugador en toda su carrera'
      }
    },
    teamOverview: {
      step1: {
        title: 'FICHA DE EQUIPO',
        message: 'Consulta datos básicos del equipo: edad media, formación base, ELO o Balance de traspasos'
      },
      step2: {
        title: 'ESTADÍSTICAS BÁSICAS',
        message: 'Consulta posesión, xG, Remates, PPDA o Verticalidad'
      },
      step3: {
        title: 'RADAR Y TEMPORADA',
        message: 'Selecciona radar, temporada y partidos en casa o fuera para medir el rendimiento del equipo'
      },
      step4: {
        title: 'FILTRA POR ENTRENADOR Y PARTIDOS',
        message: 'Consulta el rendimiento métrica a métrica en el radar'
      },
      step5: {
        title: 'RADAR DE RENDIMIENTO',
        message: 'El panel es interactivo, puedes pasar el ratón por encima de cada métrica y obtener su definición métrica en el radar'
      },
      step6: {
        title: 'FORMATOS DE DESCARGA',
        message: 'Dispones de dos formatos de descarga: png y svg'
      },
      step7: {
        title: 'CALENDARIO',
        message: 'Consulta el calendario de partidos del equipo'
      },
      step8: {
        title: 'MEJORES JUGADORES POR MÉTRICA',
        message: 'En este panel puedas seleccionar diferentes métricas y ver qué jugadores son los más importantes'
      },
      step9: {
        title: 'PROXIMO PARTIDO Y AUSENCIAS',
        message: 'Consulta el próximo rival y los jugadores lesionados y suspendidos del equipo'
      },
      step10: {
        title: 'GRÁFICAS Y TENDENCIAS',
        message: 'Consulta diferentes gráficas de los últimos 10 o 20 partidos'
      }
    },
    teamRoster: {
      step1: {
        title: 'TIPO DE VISTA',
        message: 'Visualiza la plantilla desde 6 categorías diferentes: por posición, fin de contrato, edad, disponibilidad, perfil de edad y campo'
      }
    },
    teamLoans: {
      step1: {
        title: 'CEDIDOS',
        message: 'Consulta los jugadores cedidos a otros equipos y en qué posición juegan'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'TEMPORADA Y PLANTILLA',
        message: 'Filtra por temporada, plantilla del radar y compara con las ligas que quieras'
      },
      step2: {
        title: 'RENDIMIENTO POR MÉTRICAS',
        message: 'Consulta dónde está el equipo en cada métrica comparado con todos los equipos de las ligas seleccionadas previamente'
      },
      step3: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SELECCIÓN DE TEMPORADAS',
        message: 'Añade temporadas para medir la eficacia en el tiro'
      },
      step2: {
        title: 'FINALIZACIÓN PROPIA O DE RIVAL',
        message: 'Elige si quieres ver mapa de finalización del equipo o de todos sus rivales'
      },
      step3: {
        title: 'UBICACIÓN DE LOS TIROS',
        message: 'Selecciona cómo quieres ver los remates del equipo, por círculos o por zonas (cajas)'
      },
      step4: {
        title: 'TIPO DE TIRO',
        message: 'Filtra por tipo de remate, estrategia, área o parte del cuerpo'
      },
      step5: {
        title: 'FILTRA MINUTOS',
        message: 'Barra de minutos para seleccionar remates y goles marcados por tramos concretos de partido'
      },
      step6: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      },
      step7: {
        title: 'MAPA DE TIROS',
        message: 'El mapa es interactivo. Consulta cada circulo con el ratón para saber xG de cada tiro'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SELECCIÓN DE TEMPORADAS',
        message: 'Añade temporadas para medir su eficacia en el tiro'
      },
      step2: {
        title: 'PASES CLAVE PROPIOS O DE RIVAL',
        message: 'Elige si quieres ver mapa de pases clave del equipo o de todos sus rivales'
      },
      step3: {
        title: 'UBICACIÓN DEL PASE CLAVE',
        message: 'Selecciona la posibilidad de ver ubicación exacta del pase clave (círculo) o por zonas del área y el campo (cajas)'
      },
      step4: {
        title: 'TIPO DE REMATE TRAS PASE',
        message: 'Filtra por tipo de remate, estrategia, área o parte del cuerpo realizados tras el pase clave'
      },
      step5: {
        title: 'FILTRA MINUTOS',
        message: 'Barra de minutos para seleccionar remates y goles marcados por tramos concretos de partido'
      },
      step6: {
        title: 'FORMATOS DE DESCARGA DE IMAGEN',
        message: 'Dispones de tres formatos de descarga: png, svg y embed'
      },
      step7: {
        title: 'MAPA DE PASES',
        message: 'El mapa es interactivo. Consulta cada circulo con el ratón para saber el xA de cada pase'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'ÚLTIMOS PARTIDOS',
        message: 'Consulta resultados, posesión, xG y % de victoria de todos los partidos del equipo'
      }
    },
    teamTransfers: {
      step1: {
        title: 'LLEGADAS',
        message: 'Consulta todas las llegadas (compras + cesiones) por año natural'
      },
      step2: {
        title: 'SALIDAS',
        message: 'Consulta las salidas (ventas + cesiones) por año natural'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TENDENCIAS',
        message: 'Consulta estado de forma del equipo a través de rachas, victorias, porterías a cero, remontadas, periodos con goles o tipos de goles'
      },
      step2: {
        title: 'BALÓN PARADO',
        message: 'Consulta estadísticas de un equipo sobre sus jugadas a balón parado'
      },
      step3: {
        title: 'SUSTITUCIONES',
        message: 'Consulta cuándo realiza sustituciones el equipo y qué jugadores son más cambiados'
      },
      step4: {
        title: 'CONEXIONES',
        message: 'Consulta conexiones más habituales entre jugadores. Filtra por temporada y tipo de jugada'
      },
      step5: {
        title: 'ZONAS DE ATAQUE',
        message: 'Descubre zonas de ataque del equipo y filtra por temporada o tipo de ataque'
      },
      step6: {
        title: 'FORMACIONES',
        message: 'Consulta las formaciones más utilizadas y su % de victorias, empate so derrotas con cada una de ellas'
      },
      step7: {
        title: 'ZONAS DE TIRO',
        message: 'Filtra por temporada, equipo o rival, forma de visualizar el mapa, tipos de remate o minutos'
      },
      step8: {
        title: 'CENTROS',
        message: 'Consulta y filtra por temporada, tipo de visualización, exitosos o fallados, desde donde empiezan y terminan o incluyendo saques de esquina'
      },
      step9: {
        title: 'JUGADORES',
        message: 'Filtra por temporada, tipo de visualización, exitosos o fallados, desde donde empiezan y terminan o incluyendo saques de esquina'
      }
    },
    teamOnOff: {
      step1: {
        title: 'TEMPORADAS Y PARTIDOS',
        message: 'Filtra por temporada, partidos o por partidos de local o visitante'
      },
      step2: {
        title: 'JUGADORES',
        message: 'Consulta el rendimiento de todos los jugadores de la plantilla a través de innumerables métricas'
      }
    }
  },
  alerts: {
    numPlayers: 'Número de jugadores',
    newPlayersLastWeek: 'Nuevos jugadores última semana',
    subtitle: 'Recibe alertas cuando tus búsquedas encuentren nuevos jugadores',
    generalSubtitle: 'Alertas sobre nuevos jugadores según tu criteria y noticias de tus jugadores favoritos',
    subtitlePlayer: 'Recibe alertas cuando tengamos novedades sobre tus jugadores favoritos',
    subtitleSearch: 'Recibe alertas cuando nuevos jugadores cumplan tus criterios de búsqueda',
    favorite: 'Favorito',
    newEventCalendar: 'Nuevo Evento',
    updatedEventCalendar: 'Evento Actualizado',
    newShareFrom: 'Nuevo Compartido de',
    injuryAlert: 'Alerta de Lesión',
    contractAlert: 'Alerta de Contrato',
    teamAlert: 'Alerta de Fichaje',
    marketValueAlert: 'Alerta de Valor de Mercado',
    gameAlert: 'Alerta de Partido Jugado'
  },
  videoEvents: {
    highlights: 'Destacados',
    fullGame: 'Partido completo',
    autoplay: 'Reproducción automática',
    searchBarPlaceholder: 'Busca jugadores,partidos o equipos...',
    subtitle: 'Analiza eventos en video',
    successful: 'Éxito',
    unsuccessful: 'Fallo',
    playing: 'Reproduciendo',
    games: 'Partidos',
    moreFilters: 'Mas filtros...',
    startArea: 'Área de inicio',
    endArea: 'Área de fin',
    select: 'Seleccionar',
    selectLastXGames: 'Seleccionar {0} últimos partidos',
    advancedFilters: 'Filtros avanzados',
    freeKicks: 'Faltas directas',
    cornerKicks: 'Corners',
    allShots: 'Remates',
    generateZip: 'Descargar Vídeos',
    zippedModalMessage: 'Estamos creando tu lista de videos y la enviaremos a tu correo electrónico en breve.',
    clickToSeeVideo: 'Pincha para el ver video'
  },
  videoUpload: {
    subtitle: 'Subir video y crear partido',
    uploadVideo: 'Subir video',
    selectPeriod: 'Seleccionar periodo',
    gameData: 'Datos del partido',
    venue: 'Estadio',
    matchType: 'Tipo de partido',
    matchGroup: 'Grupo',
    roundType: 'Tipo de ronda',
    roundNumber: 'Num. de ronda',
    offsetFh: 'Offset 1ra parte',
    offsetSh: 'Offset 2da parte',
    offsetFhOT: 'Offset Prórroga 1ra parte',
    offsetShOT: 'Offset Prórroga 2da parte',
    homeLineup: 'Alineación local',
    awayLineup: 'Alineación visitante',
    existingPlayer: 'Jugador existente',
    newPlayer: 'Nuevo jugador',
    startingTeam: 'Titular',
    saveAndUpload: 'Guardar y subir',
    existingGame: 'El partido ya existe',
    sendToKora: 'Enviar',
    invalidForm: 'Formulario inválido',
    warningModalTitle: 'Se han detectado anomalías',
    noScoreSheetWarning: 'No hay alineaciones',
    onlyOnePartUploadedWarning: 'Solo hay una media parte',
    continueQuestion: '¿Desea continuar?',
    slaLimit: 'Ha subido {0} partidos con {1}. Su límite es {2}',
    requestedGames: 'Partidos solicitados',
    limitClose: 'Quedan solo {0} partidos por solicitar',
    limitReached: 'Has alcanzado tu límite de petición de videos. Subir más partidos podrá conllevar cargos adicionales.',
    seasonFinishedWarning: 'Esto creará un partido en una temporada que ya ha terminado. Por favor, comprueba si es correcto.',
    teamCountryWarning: 'Este equipo es de un país diferente al de la liga seleccionada. Por favor, comprueba si es correcto.',
    uploading: 'Subiendo',
    doNotNavigateAway: 'Por favor, no cierres esta pestaña, actualices la pestaña ni navegues a otra página mientras la subida esté en curso.',
    severalMinutes: 'Este proceso puede tardar varios minutos.',
  },
  videoPlaylists: {
    subtitle: 'Colección de filtros de videos destacados',
    savePlaylist: 'Guardar lista de reproducción',
    seeAllPlaylists: 'Ver todas las listas'
  },
  videoHighlights: {
    recap: 'Recap',
    homeCondensed: 'Resumen partido local',
    awayCondensed: 'Resumen partido visitante',
    selectedActions: 'Acciones seleccionadas',
    noActions: 'No hay acciones que coincidan con los filtros especificados',
    noGames: 'Aún no se han subido partidos',
    attackingActions: 'Acciones de ataque',
    defensiveActions: 'Acciones defensivas',
    groundDuels: 'Duelos en el suelo',
    penaltiesProvoked: 'Penaltis provocados',
    goalkeeperActions: 'Acciones del Portero',
    addSomeGames: '¡Comienza añadiendo algunos partidos!',
    goToVideoUploadTool: 'Ir a Cargar Vídeos',
    ballInPlay: 'En juego',
    filterSeasons: 'Filtrar Temporadas',
    streaming: 'Streaming',
    clips: 'Clips',
    homePlayerHighlights: 'Destacados de los jugadores locales',
    awayPlayerHighlights: 'Destacados de los jugadores visitantes',
    qualifiers: {
      Pass: 'Pase',
      Save: 'Parada',
      'Saved Shot': 'Remate Parado',
      Shot: 'Tiro',
      Goal: 'Gol',
      'Missed Shot': 'Tiro Fuera',
      'Shot on Post': 'Tiro al Poste',
      Error: 'Error',
      Clearance: 'Despeje',
      Aerial: 'Duelo Aéreo',
      Challenge: 'Duelo Perdido',
      Dispossessed: 'Pérdida de Balón',
      Foul: 'Falta',
      Card: 'Tarjeta',
      'Offside Pass': 'Pase en Fuera de Juego',
      Claim: 'Centro Atrapado',
      'Keeper Pickup': 'Balón Atrapado',
      'Ball Touch': 'Toque de Balón',
      Dribble: 'Regate',
      Interception: 'Intercepción',
      Tackle: 'Entrada',
      'Ball Recovery': 'Recuperación de Balón',
      Takeon: 'Regate'
    },
    qualifierIds: {
      1: 'Pase largo',
      2: 'Centro',
      5: 'Falta directa',
      6: 'Córner',
      9: 'Penalti',
      15: 'De cabeza',
      20: 'Pie derecho',
      21: 'Otra parte del cuerpo',
      22: 'Juego abierto',
      23: 'Contraataque',
      24: 'Balón parado',
      25: 'De córner',
      26: 'Tiro libre',
      28: 'Gol en propia',
      29: 'Asistido',
      31: 'Tarjeta amarilla',
      32: 'Segunda tarjeta amarilla',
      33: 'Tarjeta roja',
      72: 'Pie izquierdo',
      73: 'Izquierda',
      82: 'Tiro bloqueado (defensa)',
      94: 'Bloqueo defensivo',
      123: 'Saque de mano portero',
      124: 'Saque de puerta',
      160: 'Saque de banda',
      170: 'Acaba en gol',
      173: 'Despeje seguro',
      174: 'Despeje peligroso',
      177: 'Recogido',
      178: 'De pie',
      179: 'Tirándose',
      182: 'Manos',
      183: 'Pies',
      185: 'Centro bloqueado',
      210: 'Asistencia',
      215: 'Jugada individual',
      279: 'Saque de centro',
      285: 'Defensivo',
      286: 'Ofensivo'
    },
    areas: {
      goalArea: 'Área pequeña',
      boxLeft: 'Área Izquierda',
      boxCenter: 'Área Central',
      boxRight: 'Área Derecha',
      outBoxDeepLeft: 'Fuera del Área Profundo Izquierda',
      outBoxDeepRight: 'Fuera del Área Profundo Derecha',
      outBoxLeft: 'Fuera del Área Izquierda',
      outBoxCentreLeft: 'Fuera del Área Centro Izquierda',
      outBoxCentre: 'Fuera del Área Central',
      outBoxCentreRight: 'Fuera del Área Centro Derecha',
      outBoxRight: 'Fuera del Área Derecha',
      midfieldLeft35: 'Mediocampo Izquierda',
      midfieldCentreLeft35: 'Mediocampo Centro Izquierda',
      midfieldCentre35: 'Mediocampo Central',
      midfieldCentreRight35: 'Mediocampo Centro Derecha',
      midfieldRight35: 'Mediocampo Derecha',
      ownGoalArea: 'Propia Área de Meta',
      ownBoxLeft: 'Propia Área Izquierda',
      ownBoxCenter: 'Propia Área Central',
      ownBoxRight: 'Propia Área Derecha',
      ownFieldOutOfBoxDeepLeft: 'Propio Campo Fuera del Área Profundo Izquierda',
      ownFieldOutOfBoxDeepRight: 'Propio Campo Fuera del Área Profundo Derecha',
      ownFieldOutOfBoxLeft: 'Propio Campo Fuera del Área Izquierda',
      ownFieldOutOfBoxCentreLeft: 'Propio Campo Fuera del Área Centro Izquierda',
      ownFieldOutOfBoxCentre: 'Propio Campo Fuera del Área Central',
      ownFieldOutOfBoxCentreRight: 'Propio Campo Fuera del Área Centro Derecha',
      ownFieldOutOfBoxRight: 'Propio Campo Fuera del Área Derecha',
      "6 YARD BOX": "Área pequeña",
      "BOX RIGHT": "Área derecha",
      "BOX CENTER": "Área central",
      "BOX LEFT": "Área izquierda",
      "OUT BOX DEEP RIGHT": "Fuera del Área Profundo Derecha",
      "OUT BOX DEEP LEFT": "Fuera del Área Profundo Izquierda",
      "OUT BOX RIGHT": "Fuera del Área Derecha",
      "OUT BOX LEFT": "Fuera del Área Izquierda",
      "FINAL THIRD RIGHT": "Último tercio Derecha",
      "FINAL THIRD LEFT": "Último tercio Izquierda",
      "FULL BOX": "Área completa",
      "OUT BOX DEEP RIGHT LARGE": "Fuera del Área Profundo Derecha Grande",
      "OUT BOX DEEP LEFT LARGE": "Fuera del Área Profundo Izquierda Grande",
      "FINAL THIRD RIGHT LARGE": "Último tercio Derecha Grande",
      "FINAL THIRD LEFT LARGE": "Último tercio Izquierda Grande",
      "OUT BOX CENTER RIGHT": "Fuera del Área Centro Derecha",
      "OUT BOX CENTER": "Fuera del Área Centro",
      "OUT BOX CENTER LEFT": "Fuera del Área Centro Izquierda",
      "FINAL THIRD CENTER RIGHT": "Último tercio centro derecha",
      "FINAL THIRD CENTER": "Último tercio centro",
      "FINAL THIRD CENTER LEFT": "Último tercio centro izquierda",
      "OUT BOX CENTER RIGHT SMALL": "Fuera del área centro derecha pequeño",
      "OUT BOX CENTER SMALL": "Fuera del área centro pequeño",
      "OUT BOX CENTER LEFT SMALL": "Fuera del área centro izquierda pequeño",
      "FINAL THIRD CENTER RIGHT LARGE": "Último tercio centro derecha grande",
      "FINAL THIRD CENTER LARGE": "Último tercio centro grande",
      "FINAL THIRD CENTER LEFT LARGE": "Último tercio centro izquierda grande",
      "OWN 6 YARD BOX": "Propio campo Área pequeña",
      "OWN BOX RIGHT": "Propio campo Área derecha",
      "OWN BOX CENTER": "Propio campo Área central",
      "OWN BOX LEFT": "Propio campo Área izquierda",
      "OWN OUT BOX DEEP RIGHT": "Propio campo Fuera del Área Profundo Derecha",
      "OWN OUT BOX DEEP LEFT": "Propio campo Fuera del Área Profundo Izquierda",
      "OWN OUT BOX RIGHT": "Propio campo Fuera del Área Derecha",
      "OWN OUT BOX LEFT": "Propio campo Fuera del Área Izquierda",
      "OWN FINAL THIRD RIGHT": "Propio campo Último tercio Derecha",
      "OWN FINAL THIRD LEFT": "Propio campo Último tercio Izquierda",
      "OWN FULL BOX": "Propio campo Área completa",
      "OWN OUT BOX DEEP RIGHT LARGE": "Propio campo Fuera del Área Profundo Derecha Grande",
      "OWN OUT BOX DEEP LEFT LARGE": "Propio campo Fuera del Área Profundo Izquierda Grande",
      "OWN FINAL THIRD RIGHT LARGE": "Propio campo Último tercio Derecha Grande",
      "OWN FINAL THIRD LEFT LARGE": "Propio campo Último tercio Izquierda Grande",
      "OWN OUT BOX CENTER RIGHT": "Propio campo Fuera del Área Centro Derecha",
      "OWN OUT BOX CENTER": "Propio campo Fuera del Área Centro",
      "OWN OUT BOX CENTER LEFT": "Propio campo Fuera del Área Centro Izquierda",
      "OWN FINAL THIRD CENTER RIGHT": "Propio campo Último tercio centro derecha",
      "OWN FINAL THIRD CENTER": "Propio campo Último tercio centro",
      "OWN FINAL THIRD CENTER LEFT": "Propio campo Último tercio centro izquierda",
      "OWN OUT BOX CENTER RIGHT SMALL": "Propio campo Fuera del área centro derecha pequeño",
      "OWN OUT BOX CENTER SMALL": "Propio campo Fuera del área centro pequeño",
      "OWN OUT BOX CENTER LEFT SMALL": "Propio campo Fuera del área centro izquierda pequeño",
      "OWN FINAL THIRD CENTER RIGHT LARGE": "Propio campo Último tercio centro derecha grande",
      "OWN FINAL THIRD CENTER LARGE": "Propio campo Último tercio centro grande",
      "OWN FINAL THIRD CENTER LEFT LARGE": "Propio campo Último tercio centro izquierda grande"
    },
    outcomes: {
      success: 'Éxito',
      fail: 'Fallo',
      possessionWon: 'Posesión Ganada',
      possessionNotWon: 'Posesión No Ganada',
      received: 'Recibido',
      provoked: 'Provocado'
    }
  },
  share: {
    shareTo: 'Compartir a',
    viaApp: 'App (Mensaje Driblab)',
    viaEmail: 'Email',
    description: 'Descripción',
    titleTab: 'Compartidos',
    toMe: 'Recibido',
    fromMe: 'Enviado',
    typeInternal: 'Interno',
    typeExternal: 'Externo',
    title: 'Compartidos',
    subtitle: 'Resumen de los elementos en tu lista de compartidos',
    selectUser: 'Seleccionar usuario',
    expired: 'Expirado',
    limitReached: 'Este enlace ha alcanzado el límite de usos'
  },
  homeStats: {
    data: 'Datos disponibles',
    players: 'jugadores',
    totalPlayers: 'jugadores en total',
    teams: 'equipos',
    totalTeams: 'equipos en total',
    leagues: 'ligas',
    totalLeagues: 'ligas en total',
    seasons: 'temporadas',
    totalSeasons: 'temporadas en total',
    games: 'partidos',
    totalGames: 'partidos en total'
  },
  scoutingCalendar: {
    subtitle: 'Crea y organiza tus tareas de scouting',
    myCalendars: 'Calendario privado',
    publicCalendars: 'Calendarios públicos',
    otherCalendars: 'Otros calendarios',
    calendarSettings: 'Ajustes del calendario',
    moreInfo: 'Más información',
    individualScouting: 'Scouting Individual',
    matchScouting: 'Scouting de Partido',
    calendarView: {
      type: 'Tipo de calendario',
      month: 'Mes',
      week: 'Semana',
      day: 'Día'
    },
    weekView: {
      type: 'Tipo de semana',
      monSun: 'Lunes - Domingo',
      sunSat: 'Domingo - Sábado',
      monFri: 'Lunes - Viernes'
    },
    tasks: {
      addNew: 'Añadir nueva tarea',
      myTasks: 'Mis tareas',
      filterTasks: 'Filtrar tareas',
      sharedWithMe: 'Compartido conmigo',
      createTask: 'Crear tarea',
      newTask: 'Nueva tarea',
      taskName: 'Nombre de la tarea',
      allDay: 'Todo el día',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de finalización',
      startHour: 'Hora de inicio',
      endHour: 'Hora de finalización',
      assignedTo: 'Asignado a',
      assignedToMe: 'Asignada a mí',
      color: 'Color',
      scoutingType: 'Tipo de scouting',
      taskLocation: 'Ubicación de la tarea',
      selectLeague: 'Seleccionar liga',
      selectMatch: 'Seleccionar partido',
      useMatchdate: 'Usar fecha del partido como fecha',
      stadium: 'Estadio',
      travel: 'Viaje',
      hotel: 'Hotel',
      tickets: 'Entradas',
      taskNotes: 'Escribe notas descriptivas o comentarios relacionados con la tarea',
      states: {
        toDo: 'Pendiente',
        inProgress: 'En proceso',
        done: 'Completado'
      },
      type: {
        player: 'Evaluación de jugador',
        team: 'Evaluación de equipo',
        other: 'Otro'
      },
      location: {
        stadium: 'En el estadio',
        video: 'Vídeo'
      },
      accommodation: {
        accommodationDetails: 'Detalles del alojamiento',
        ownArrangement: 'Cuenta propia',
        required: 'Requerido',
        notRequired: 'No requerido',
        booked: 'Reservado'
      },
      assignToMe: 'Asignarme a mí',
      addOther: 'Añadir otro',
      deleteTask: 'Eliminar tarea',
      deleteTaskMessage: 'La tarea será eliminada. ¿Estás seguro?',
      cancelUpdate: 'Cancelar actualización',
      cancelUpdateMessage: 'Los cambios no se guardarán. ¿Estás seguro?',
      selectGame: 'Por favor, selecciona un partido para añadir archivos',
      noData: 'Sin datos. ¡Comienza añadiendo algunas tareas!',
      widgetSubtitle: 'Revisa tus próximas tareas',
      scoutingDetails: 'Detalles de scouting',
      taskDetails: 'Detalles de la tarea',
      playerDocuments: 'Documentos del jugador',
      teamDocuments: 'Documentos del equipo',
      gameDocuments: 'Documentos del partido',
      taskDocuments: 'Documentos de la tarea',
      task: 'Tarea'
    },
    nextGames: 'Próximos partidos'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Esta semana',
      month: 'Este mes',
      year: 'Este año'
    },
    noTasks: '¡Crea tareas nuevas o arrastra una aquí!',
    goToBoard: 'Ir a Tasks Board'
  },
  profile: {
    title: 'Perfil',
    subtitle: 'Personaliza los detalles de tu cuenta y suscripción'
  },
  hub: {
    onlyHub: 'Sólo disponible en Driblab Hub',
    blue: 'azul',
    purple: 'morado',
    orange: 'naranja',
    grey: 'gris',
    indigo: 'indigo',
    teal: 'azul verdoso',
    lightBlue: 'azul claro',
    brown: 'marrón'
  },
  uploadedGames: {
    subtitle: 'Todos los partidos subidos',
    timeRequested: 'Cuando fue pedido',
    timeReceived: 'Cuando fue recibido',
    diffHours: 'Diferencia en horas',
    collectionCompleted: 'Colección completada',
    dateFrom: 'Fecha desde',
    dateTo: 'Fecha hasta',
    goToUploadedGames: 'Ir a Partidos Subidos',
    sla: 'Acuerdo de Nivel de Servicio',
    matchDate: 'Fecha del partido',
    rejectedGame: 'Rechazado',
    reviewed: 'Revisado',
    requested: 'Solicitado',
    koraStatus: 'Estado Kora',
    aws: 'AWS',
    fullVideo: 'Video completo',
    offset: 'Offset',
    updateFullVideo: '¿Actualizar video completo?'
  },
  gameMap: {
    title: 'Mapa de partidos',
    subtitle: 'Explora los partidos de los próximos días',
    warning: 'La hora y el lugar pueden no ser correctos. Por favor, confirma esta información.',
    taskAdded: 'Tarea creada con éxito. Consulta el Scouting Calendar.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Notificación enviada con éxito',
    notPermissions: 'No tienes permisos para ver',
    notPermissionsLeague: 'No tienes permisos para ver esta liga',
    notPermissionsGame: 'No tienes permisos para ver este partido',
    requestAccessTo: 'Solicitar acceso a',
    sendRequest: 'Enviar Solicitud'
  },
  videoTeams: {
    subtitle: 'Encuentra los últimos partidos analizados por equipo',
    noGamesUploaded: 'Aún no se han subido partidos'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Análisis de scouting',
    scoutingAnalyses: 'Análisis de scouting',
    playerScoutingAnalyses: 'Ánalisis de scouting de jugador',
    gameScoutingAnalyses: 'Análisis de scouting de partido',
    analyses: 'Análisis',
    addReport: 'Añadir análisis',
    technical: 'Técnico',
    tactical: 'Táctico',
    physical: 'Físico',
    mental: 'Psicológico',
    technicalNotes: 'Notas técnicas',
    tacticalNotes: 'Notas tácticas',
    physicalNotes: 'Notas físicas',
    mentalNotes: 'Notas sobre el perfil psicológico',
    conclusion: 'Conclusión',
    charactersMax: 'Máximo 1000 caracteres',
    globalRating: 'Evaluación global',
    noData: 'No hay datos. ¡Comienza añadiendo algunos análisis!',
    deleteAnalysis: 'Eliminar Scouting Analysis',
    deleteAnalysisMessage: 'El análisis se eliminará permanentemente. ¿Estás seguro?',
    avgTooltip: 'Promedio basado en las notas finales de los análisis visibles para ti',
    avgPotentialTooltip: 'Media basada en el potencial de los análisis visibles para ti',
    avgOverallScoreTooltip: 'Promedio basado en las puntuaciones generales del jugador visibles para ti',
    scouter: 'Scouter',
    lastEdited: 'Última edición',
    analysisFilters: 'Filtros de Análisis',
    generalFilters: 'Filtros Generales',
    widgetSubtitle: 'Últimos análisis añadidos',
    addPlayerReport: 'Añadir análisis de scouting del jugador',
    seeReports: 'Ver informes',
    addGameReport: 'Agregar Análisis de Scouting del Partido',
    keyPlayers: 'Jugadores Clave',
    formation: 'Formación',
    inPossession: 'Momento con balón',
    notesIP: 'Notas de Momento con balón',
    outOfPossession: 'Momento sin balón',
    notesOP: 'Notas de Momento sin balón',
    transitions: 'Transiciones',
    notesTransitions: 'Notas de Transiciones',
    notesSP: 'Notas de Jugadas a Balón Parado',
    finalRating: 'Calificación Final',
    gameNotesPlaceholder: 'Escribe notas descriptivas o comentarios relacionados con el partido',
    potential: 'Potencial',
    tags: 'Etiquetas',
    tagsPlaceholder: 'Añade algunas etiquetas',
    tagsHint: 'Escribe y pulsa Enter para añadir una etiqueta',
    exampleTags: {
      leadership: 'Liderazgo',
      resilience: 'Resiliencia',
      competitiveMindset: 'Mentalidad competitiva',
      calmUnderPressure: 'Calma bajo presión',
      focus: 'Concentración',
      discipline: 'Disciplina',
      coachability: 'Acepta instrucciones',
      poorBodyLanguage: 'Mal lenguaje corporal',
      lowConfidence: 'Baja confianza',
      easilyFrustrated: 'Fácilmente frustrado',
    }
  },
  addPlayerForm: {
    noLeague: 'Crear un equipo sin liga puede tener un efecto negativo en su indexación y posterior búsqueda dentro de la aplicación.'
  },
  expenses: {
    expense: 'Gasto',
    expenses: 'Gastos',
    addExpense: 'Añadir gasto',
    transportation: 'Transporte',
    accommodation: 'Alojamiento',
    dietary: 'Dietas',
    eventTicket: 'Entradas para evento',
    expenseType: 'Tipo de gasto',
    amount: 'Cantidad',
    expenseDate: 'Fecha del gasto',
    expenseFilters: 'Filtros de gastos',
    noData: 'Sin datos. ¡Empieza añadiendo algunos gastos!',
    deleteExpense: 'Eliminar gasto',
    deleteExpenseMessage: 'El gasto se eliminará permanentemente. ¿Estás seguro?'
  },
  disabledTooltips: {
    general: 'Esta función está deshabilitada actualmente',
    youth: 'Debe ser juvenil para establecer una edad',
    unit: 'La estadística debe ser Runs, HSR o SPR',
    seasonsWithout60MinsGames: 'El jugador no ha jugado más de 60 minutos en un solo partido en la(s) temporada(s) seleccionada(s)',
    notEditable: 'Esto no se puede editar',
    noMatchdate: 'Fecha del partido no disponible',
    selectGame: 'Selecciona un partido primero',
    selectPlayer: 'Selecciona un jugador primero',
    selectTeam: 'Selecciona un equipo primero',
    selectBoxes: 'Debe seleccionarse la visualización de cajas',
    selectYear: 'Selecciona un año primero',
    pdScoreNotAvailable: 'Puntuación no disponible para jugadores que no han alcanzado los 60 minutos de juego en un partido',
    pdSeasonNotAvailable: 'Datos físicos no disponibles para esta temporada',
    pdGameNotAvailable: 'Datos físicos no disponibles para este partido'
  },
  leagueTypes: {
    regular: 'Regular',
    continental: 'Continental',
    nationalTeam: 'Selecciones',
    countryCup: 'Copa del País',
    qualifier: 'Clasificatorio',
    playOff: 'Play-Off',
    regionalLeague: 'Liga Regional',
    friendly: 'Amistoso',
    nationalFriendly: 'Amistoso Nacional',
    nationaQualifier: 'Clasificatorio Nacional'
  },
  playerSides: {
    'Left/Right': 'Izquierda/Derecha',
    'Left/Centre/Right': 'Izquierda/Centro/Derecha',
    Right: 'Derecha',
    Centre: 'Centro',
    'Centre/Right': 'Centro/Derecha',
    Left: 'Izquierda',
    'Left/Centre': 'Izquierda/Centro'
  },
  areaSelector: {
    selectAreas: 'Seleccionar áreas',
    filterAreas: 'Filtrar áreas'
  },
  spatialCoverage: {
    lastDefenderDist: 'Distancia último defensor',
    defensiveLineDist: 'Distancia línea defensiva',
    fullBackAvgDist: 'Distancia media laterales',
    offensiveLineDist: 'Distancia línea ofensiva',
    distanceToGoal: 'Distancia a portería',
    avgLineWidth: 'Prom. ancho línea',
    leagueAvgDistanceToGoal: 'Prom. dist. liga a portería',
    leagueAvgLineWidth: 'Prom. ancho línea liga',
    avgShort: 'Prom.',
    meters: 'metros',
    leagueAvgDist: 'Prom. distancia liga',
    distance: 'Distancia',
    avgPositionYAxis: 'Prom. distancia en campo (Y)',
    leagueAvgPositionYAxis: 'Prom. liga distancia en campo (Y)',
    lbRbDistanceSeparation: 'Distancia LB–RB',
    leagueAvgLbRbDistanceSeparation: 'Prom. liga distancia LB–RB',
    legendTeam: 'Equipo',
    legendLeagueAvg: 'Prom. Liga',
    maxLength: 'Longitud máx.',
    maxWidth: 'Amplitud máx.',
    avgBlockDistance: 'Prom. dist. del bloque'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Datos inteligentes',
    passesUnderPressureSubtitle: 'Análisis de la tasa de éxito de los pases realizados bajo presión defensiva',
    onBallPressureSubtitle: 'Analiza eventos de presión defensiva y su tasa de éxito por zonas del campo',
    ballReceiptsInSpaceSubtitle: 'Analiza los pases recibidos en espacio por zona del campo',
    ballReceipts: 'recepciones',
    totalBallReceipts: 'Total Recepciones en Espacio',
    totalBallReceiptsCompleted: 'Total Recepciones en Espacio Completadas',
    completed: 'Completadas',
    lineBreakingPassesSubtitle: 'Analiza los pases que rompen líneas y generan ventajas',
    offBallRunSubtitle: 'Analiza los desmarques sin balón al espacio',
    bypassed: 'Superados',
    oppsBypassed: 'Oponentes superados',
    passer: 'Pasador',
    passedTo: 'Pase a',
    receivedFrom: 'Recibió de',
    distanceToNearestDefender: 'Distancia al defensa más cercano',
    lineBreaking: '{0} entre lineas',
    keyPass: 'Pase Clave',
    receiver: 'Receptor',
    dynamicTracking: 'Tracking dinámico',
    eventLockTooltip: 'Algunos jugadores no son visibles en la jugada',
    bypassedPlayers: '{0} jugadores superados',
    playersCount: '{0} jugadores',
    bothTeams: 'Ambos equipos',
    matchesCount: '{0} partidos',
     passType: {
      P: 'Pase',
      A: 'Asistencia',
      KP: 'Pase Clave',
      PiOB: 'Pase al Área Rival',
      PiFT: 'Pase al Último Tercio',
      SoPP: 'Pase de Cambio de Juego',
    },
    lbpType: {
      F: 'Línea ofensiva',
      M: 'Línea media',
      B: 'Línea defensiva',
      MF: 'Líneas media y ofensiva',
      BM: 'Líneas defensiva y media',
      BF: 'Líneas defensiva y ofensiva',
      BMF: 'Líneas defensiva, media y ofensiva'
    },
    lbpCategory: {
      'G-IN-T': 'Raso por dentro (Supera Línea Defensiva)',
      'G-IN-NT': 'Raso por dentro (No Supera Línea Defensiva)',
      'G-OUT-T': 'Raso por fuera (Supera Línea Defensiva)',
      'G-OUT-NT': 'Raso por fuera (No Supera Línea Defensiva)',
      'O-IN-T': 'Elevado por dentro (Supera Línea Defensiva)',
      'O-IN-NT': 'Elevado por dentro (No Supera Línea Defensiva)',
      'O-OUT-T': 'Elevado por fuera (Supera Línea Defensiva)',
      'O-OUT-NT': 'Elevado por fuera (No Supera Línea Defensiva)',
      ground: 'Raso',
      over: 'Por alto',
      inside: 'Por dentro',
      outside: 'Por fuera',
      through: 'Supera Línea Defensiva',
      notThrough: 'No Supera Línea Defensiva',
      throughAbbr: 'Supera línea def.',
      notThroughAbbr: 'No supera línea def.'
    },
    lbpCategorySplit: {
      G: 'Raso: El pase fue raso',
      O: 'Elevado: El pase fue elevado',
      OUT: 'Por fuera: El pase fue por fuera',
      IN: 'Por dentro: El pase fue por dentro',
      T: 'Supera Línea Defensiva: El pase atraviesa la línea defensiva (rompe la línea por dentro)',
      NT: 'No Supera Línea Defensiva: El pase no supera la línea defensiva por dentro; la sortea por fuera sin romperla de forma directa'
    },
    obrType: {
      OL: 'Superposición',
      UL: 'Transposición',
      RA: 'Carrera por delante',
      RB: 'Carrera por detrás',
      CR: 'Receptor cruzado',
      SP: 'Apoyo',
      CS: 'Venir en corto'
    },
    visualization: 'Visualización',
    points: 'Circulos',
    zones: 'Mapa de Calor',
    pressureIntensity: 'Intensidad de la presión',
    pressureOutcome: 'Resultado de la presión',
    passesOutcome: 'Resultado de los Pases',
    strong: 'Fuerte',
    light: 'Ligero',
    normal: 'Normal',
    successful: 'Exitoso',
    unsuccessful: 'No exitoso',
    presses: 'Presiones',
    passes: 'Pases',
    passUnder: 'Pases Bajo',
    successRate: 'Ratio de Éxito',
    pressureOn: 'Presión en',
    pressureOf: 'Presión de',
    pressure: 'Presión',
    totalLabel: 'total',
    totalPasses: 'Pases Totales',
    unknown: 'desconocido',
    selectGameToViewMap: 'Selecciona un partido para ver la mapa de presión',
    noEventsFoundForGame: 'No se encontraron eventos de presión para este partido',
    noEventsFoundForTeamAndSeason: 'No se encontraron eventos de presión para este equipo y temporada',
    noEventsFoundForPlayerAndSeason: 'No se encontraron eventos de presión para este jugador y temporada',
    noEventsMatchFilters: 'No se encontraron eventos que coincidan con los filtros actuales',
    totalEventsAvailable: 'total de eventos disponibles',
    minFrom: 'Min Desde',
    minTo: 'Min Hasta',
    secondFrom: 'Seg Desde',
    secondTo: 'Seg Hasta',
    positionPlayed: 'Posición Jugada',
    highlight: 'Resaltar',
    passTypeLabel: 'Tipo de Pase',
    pressurePassTypeLabel: 'Presión sobre Tipo de Pase',
    insights: 'Estadísticas',
    insightsSubtitle: 'Clasificando a los mejores con la analítica avanzada de Arrigo'
  },
  driblabAI: {
    chatText: '¿Cómo puedo ayudarte hoy?',
    chatSubtext: '¡Pregunta lo que quieras sobre datos de fútbol!',
    thinking: 'Pensando...',
    giveFeedback: 'Enviar comentarios',
    disclaimer: 'DriblabAI puede cometer errores. Por favor, asegúrate de verificar la información.',
    recent: 'Recientes',
    noConversations: '¡Aquí verás tus conversaciones recientes!',
    rename: 'Renombrar',
    deleteConversation: 'Eliminar conversación',
    confirmDelete: '¿Estás seguro de que quieres eliminar esta conversación?',
    feedback: 'Comentarios',
    feedbackQuestion: '¿Te ha resultado útil esta respuesta?',
    feedbackComments: 'Comentarios adicionales',
    feedbackPlaceholder: 'Cuéntanos qué te ha resultado útil o qué se podría mejorar...',
    errorMessage: 'No se ha podido procesar el mensaje. Por favor, inténtalo de nuevo.',
    newConversation: 'Nuevo chat',
    write: 'Escribe un mensaje...',
  },
  periodId:{
    '-1':"Otro",
    1: "Primera parte",
    2: "Segunda parte",
    3: "Prórroga - 1",
    4: "Prórroga - 2",
    5: "Tanda de penalties",
    6: "Completo",
    8: "Suspendido",
    9: "En Directo",
    7: "No empezado",
    10: "0-15",
    11: "16-30",
    12: "31+",
    13: "45-60",
    14: "61-75",
    15: "76+"
  }
};


// WEBPACK FOOTER //
// ./src/utils/translations/es.js